/**
* enum case
* */
export class KLEnumCase<T = string|number> {
    constructor(
        public readonly name: string|null,
        public readonly value: T|null,
        public readonly label: string
    ){}
}

/**
* 枚举基类
*/
export abstract class KLEnum<T = string|number> {
    protected constructor(
        public readonly name: string,
        public readonly value: T,
        public readonly label: string
    ){}
}

/**
 * 国家
*/
export class KLCountry extends KLEnum<number>{

    // 中国
    static readonly CN = new KLCountry('CN',1,'中国');

    // 日本
    static readonly JP = new KLCountry('JP',2,'日本');

    // 韩国
    static readonly KR = new KLCountry('KR',3,'韩国');

    // 新加坡
    static readonly SG = new KLCountry('SG',4,'新加坡');

    // 印度
    static readonly IN = new KLCountry('IN',5,'印度');

    // 泰国
    static readonly TH = new KLCountry('TH',6,'泰国');

    // 马来西亚
    static readonly MY = new KLCountry('MY',7,'马来西亚');

    // 菲律宾
    static readonly PH = new KLCountry('PH',8,'菲律宾');

    // 印度尼西亚
    static readonly ID = new KLCountry('ID',9,'印度尼西亚');

    // 越南
    static readonly VN = new KLCountry('VN',10,'越南');

    // 以色列
    static readonly IL = new KLCountry('IL',11,'以色列');

    // 土耳其
    static readonly TR = new KLCountry('TR',12,'土耳其');

    // 沙特阿拉伯
    static readonly SA = new KLCountry('SA',13,'沙特阿拉伯');

    // 阿联酋
    static readonly AE = new KLCountry('AE',14,'阿联酋');

    // 美国
    static readonly US = new KLCountry('US',15,'美国');

    // 加拿大
    static readonly CA = new KLCountry('CA',16,'加拿大');

    // 巴西
    static readonly BR = new KLCountry('BR',17,'巴西');

    // 墨西哥
    static readonly MX = new KLCountry('MX',18,'墨西哥');

    // 阿根廷
    static readonly AR = new KLCountry('AR',19,'阿根廷');

    // 智利
    static readonly CL = new KLCountry('CL',20,'智利');

    // 哥伦比亚
    static readonly CO = new KLCountry('CO',21,'哥伦比亚');

    // 秘鲁
    static readonly PE = new KLCountry('PE',22,'秘鲁');

    // 欧盟
    static readonly EU = new KLCountry('EU',23,'欧盟');

    // 英国
    static readonly GB = new KLCountry('GB',24,'英国');

    // 德国
    static readonly DE = new KLCountry('DE',25,'德国');

    // 法国
    static readonly FR = new KLCountry('FR',26,'法国');

    // 意大利
    static readonly IT = new KLCountry('IT',27,'意大利');

    // 西班牙
    static readonly ES = new KLCountry('ES',28,'西班牙');

    // 荷兰
    static readonly NL = new KLCountry('NL',29,'荷兰');

    // 瑞士
    static readonly CH = new KLCountry('CH',30,'瑞士');

    // 俄罗斯
    static readonly RU = new KLCountry('RU',31,'俄罗斯');

    // 挪威
    static readonly NO = new KLCountry('NO',32,'挪威');

    // 瑞典
    static readonly SE = new KLCountry('SE',33,'瑞典');

    // 丹麦
    static readonly DK = new KLCountry('DK',34,'丹麦');

    // 波兰
    static readonly PL = new KLCountry('PL',35,'波兰');

    // 捷克
    static readonly CZ = new KLCountry('CZ',36,'捷克');

    // 匈牙利
    static readonly HU = new KLCountry('HU',37,'匈牙利');

    // 奥地利
    static readonly AT = new KLCountry('AT',38,'奥地利');

    // 比利时
    static readonly BE = new KLCountry('BE',39,'比利时');

    // 爱尔兰
    static readonly IE = new KLCountry('IE',40,'爱尔兰');

    // 芬兰
    static readonly FI = new KLCountry('FI',41,'芬兰');

    // 葡萄牙
    static readonly PT = new KLCountry('PT',42,'葡萄牙');

    // 希腊
    static readonly GR = new KLCountry('GR',43,'希腊');

    // 澳大利亚
    static readonly AU = new KLCountry('AU',44,'澳大利亚');

    // 新西兰
    static readonly NZ = new KLCountry('NZ',45,'新西兰');

    // 南非
    static readonly ZA = new KLCountry('ZA',46,'南非');

    // 尼日利亚
    static readonly NG = new KLCountry('NG',47,'尼日利亚');

    // 埃及
    static readonly EG = new KLCountry('EG',48,'埃及');

    // 肯尼亚
    static readonly KE = new KLCountry('KE',49,'肯尼亚');

    // 摩洛哥
    static readonly MA = new KLCountry('MA',50,'摩洛哥');

    // 加纳
    static readonly GH = new KLCountry('GH',51,'加纳');

    // 埃塞俄比亚
    static readonly ET = new KLCountry('ET',52,'埃塞俄比亚');

    // 突尼斯
    static readonly TN = new KLCountry('TN',53,'突尼斯');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLCountry.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('CN',1,'中国'),
            new KLEnumCase<number>('JP',2,'日本'),
            new KLEnumCase<number>('KR',3,'韩国'),
            new KLEnumCase<number>('SG',4,'新加坡'),
            new KLEnumCase<number>('IN',5,'印度'),
            new KLEnumCase<number>('TH',6,'泰国'),
            new KLEnumCase<number>('MY',7,'马来西亚'),
            new KLEnumCase<number>('PH',8,'菲律宾'),
            new KLEnumCase<number>('ID',9,'印度尼西亚'),
            new KLEnumCase<number>('VN',10,'越南'),
            new KLEnumCase<number>('IL',11,'以色列'),
            new KLEnumCase<number>('TR',12,'土耳其'),
            new KLEnumCase<number>('SA',13,'沙特阿拉伯'),
            new KLEnumCase<number>('AE',14,'阿联酋'),
            new KLEnumCase<number>('US',15,'美国'),
            new KLEnumCase<number>('CA',16,'加拿大'),
            new KLEnumCase<number>('BR',17,'巴西'),
            new KLEnumCase<number>('MX',18,'墨西哥'),
            new KLEnumCase<number>('AR',19,'阿根廷'),
            new KLEnumCase<number>('CL',20,'智利'),
            new KLEnumCase<number>('CO',21,'哥伦比亚'),
            new KLEnumCase<number>('PE',22,'秘鲁'),
            new KLEnumCase<number>('EU',23,'欧盟'),
            new KLEnumCase<number>('GB',24,'英国'),
            new KLEnumCase<number>('DE',25,'德国'),
            new KLEnumCase<number>('FR',26,'法国'),
            new KLEnumCase<number>('IT',27,'意大利'),
            new KLEnumCase<number>('ES',28,'西班牙'),
            new KLEnumCase<number>('NL',29,'荷兰'),
            new KLEnumCase<number>('CH',30,'瑞士'),
            new KLEnumCase<number>('RU',31,'俄罗斯'),
            new KLEnumCase<number>('NO',32,'挪威'),
            new KLEnumCase<number>('SE',33,'瑞典'),
            new KLEnumCase<number>('DK',34,'丹麦'),
            new KLEnumCase<number>('PL',35,'波兰'),
            new KLEnumCase<number>('CZ',36,'捷克'),
            new KLEnumCase<number>('HU',37,'匈牙利'),
            new KLEnumCase<number>('AT',38,'奥地利'),
            new KLEnumCase<number>('BE',39,'比利时'),
            new KLEnumCase<number>('IE',40,'爱尔兰'),
            new KLEnumCase<number>('FI',41,'芬兰'),
            new KLEnumCase<number>('PT',42,'葡萄牙'),
            new KLEnumCase<number>('GR',43,'希腊'),
            new KLEnumCase<number>('AU',44,'澳大利亚'),
            new KLEnumCase<number>('NZ',45,'新西兰'),
            new KLEnumCase<number>('ZA',46,'南非'),
            new KLEnumCase<number>('NG',47,'尼日利亚'),
            new KLEnumCase<number>('EG',48,'埃及'),
            new KLEnumCase<number>('KE',49,'肯尼亚'),
            new KLEnumCase<number>('MA',50,'摩洛哥'),
            new KLEnumCase<number>('GH',51,'加纳'),
            new KLEnumCase<number>('ET',52,'埃塞俄比亚'),
            new KLEnumCase<number>('TN',53,'突尼斯'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLCountry|null {
        switch (val) {
            case KLCountry.CN.value:return KLCountry.CN;
            case KLCountry.JP.value:return KLCountry.JP;
            case KLCountry.KR.value:return KLCountry.KR;
            case KLCountry.SG.value:return KLCountry.SG;
            case KLCountry.IN.value:return KLCountry.IN;
            case KLCountry.TH.value:return KLCountry.TH;
            case KLCountry.MY.value:return KLCountry.MY;
            case KLCountry.PH.value:return KLCountry.PH;
            case KLCountry.ID.value:return KLCountry.ID;
            case KLCountry.VN.value:return KLCountry.VN;
            case KLCountry.IL.value:return KLCountry.IL;
            case KLCountry.TR.value:return KLCountry.TR;
            case KLCountry.SA.value:return KLCountry.SA;
            case KLCountry.AE.value:return KLCountry.AE;
            case KLCountry.US.value:return KLCountry.US;
            case KLCountry.CA.value:return KLCountry.CA;
            case KLCountry.BR.value:return KLCountry.BR;
            case KLCountry.MX.value:return KLCountry.MX;
            case KLCountry.AR.value:return KLCountry.AR;
            case KLCountry.CL.value:return KLCountry.CL;
            case KLCountry.CO.value:return KLCountry.CO;
            case KLCountry.PE.value:return KLCountry.PE;
            case KLCountry.EU.value:return KLCountry.EU;
            case KLCountry.GB.value:return KLCountry.GB;
            case KLCountry.DE.value:return KLCountry.DE;
            case KLCountry.FR.value:return KLCountry.FR;
            case KLCountry.IT.value:return KLCountry.IT;
            case KLCountry.ES.value:return KLCountry.ES;
            case KLCountry.NL.value:return KLCountry.NL;
            case KLCountry.CH.value:return KLCountry.CH;
            case KLCountry.RU.value:return KLCountry.RU;
            case KLCountry.NO.value:return KLCountry.NO;
            case KLCountry.SE.value:return KLCountry.SE;
            case KLCountry.DK.value:return KLCountry.DK;
            case KLCountry.PL.value:return KLCountry.PL;
            case KLCountry.CZ.value:return KLCountry.CZ;
            case KLCountry.HU.value:return KLCountry.HU;
            case KLCountry.AT.value:return KLCountry.AT;
            case KLCountry.BE.value:return KLCountry.BE;
            case KLCountry.IE.value:return KLCountry.IE;
            case KLCountry.FI.value:return KLCountry.FI;
            case KLCountry.PT.value:return KLCountry.PT;
            case KLCountry.GR.value:return KLCountry.GR;
            case KLCountry.AU.value:return KLCountry.AU;
            case KLCountry.NZ.value:return KLCountry.NZ;
            case KLCountry.ZA.value:return KLCountry.ZA;
            case KLCountry.NG.value:return KLCountry.NG;
            case KLCountry.EG.value:return KLCountry.EG;
            case KLCountry.KE.value:return KLCountry.KE;
            case KLCountry.MA.value:return KLCountry.MA;
            case KLCountry.GH.value:return KLCountry.GH;
            case KLCountry.ET.value:return KLCountry.ET;
            case KLCountry.TN.value:return KLCountry.TN;
        }
        return null;
    }
}

/**
 * 货币
*/
export class KLCurrency extends KLEnum<string>{

    // 人民币
    static readonly CNY = new KLCurrency('CNY','CNY','人民币');

    // 菲律宾比索
    static readonly PHP = new KLCurrency('PHP','PHP','菲律宾比索');

    // 美元
    static readonly USD = new KLCurrency('USD','USD','美元');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLCurrency.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CNY','CNY','人民币'),
            new KLEnumCase<string>('PHP','PHP','菲律宾比索'),
            new KLEnumCase<string>('USD','USD','美元'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLCurrency|null {
        switch (val) {
            case KLCurrency.CNY.value:return KLCurrency.CNY;
            case KLCurrency.PHP.value:return KLCurrency.PHP;
            case KLCurrency.USD.value:return KLCurrency.USD;
        }
        return null;
    }
}

/**
 * 性别
*/
export class KLGender extends KLEnum<string>{

    // 未知
    static readonly UNKNOWN = new KLGender('UNKNOWN','UNKNOWN','未知');

    // 男
    static readonly MALE = new KLGender('MALE','MALE','男');

    // 女
    static readonly FEMALE = new KLGender('FEMALE','FEMALE','女');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLGender.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNKNOWN','UNKNOWN','未知'),
            new KLEnumCase<string>('MALE','MALE','男'),
            new KLEnumCase<string>('FEMALE','FEMALE','女'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLGender|null {
        switch (val) {
            case KLGender.UNKNOWN.value:return KLGender.UNKNOWN;
            case KLGender.MALE.value:return KLGender.MALE;
            case KLGender.FEMALE.value:return KLGender.FEMALE;
        }
        return null;
    }
}

/**
 * 语言
*/
export class KLLang extends KLEnum<string>{

    // 中文(简体)
    static readonly ZH_CN = new KLLang('ZH_CN','zh-CN','中文(简体)');

    // 中文(繁体)
    static readonly ZH_TW = new KLLang('ZH_TW','zh-TW','中文(繁体)');

    // 英语
    static readonly EN = new KLLang('EN','en','英语');

    // 菲律宾语
    static readonly EN_PH = new KLLang('EN_PH','en-PH','菲律宾语');

    // 日语
    static readonly JA_JP = new KLLang('JA_JP','ja-JP','日语');

    // 韩语
    static readonly KO_KR = new KLLang('KO_KR','ko-KR','韩语');

    // 越南语
    static readonly VI_VN = new KLLang('VI_VN','vi-VN','越南语');

    // 泰语
    static readonly TH_TH = new KLLang('TH_TH','th-TH','泰语');

    // 印尼语
    static readonly ID_ID = new KLLang('ID_ID','id-ID','印尼语');

    // 马来语
    static readonly MS_MY = new KLLang('MS_MY','ms-MY','马来语');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLLang.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ZH_CN','zh-CN','中文(简体)'),
            new KLEnumCase<string>('ZH_TW','zh-TW','中文(繁体)'),
            new KLEnumCase<string>('EN','en','英语'),
            new KLEnumCase<string>('EN_PH','en-PH','菲律宾语'),
            new KLEnumCase<string>('JA_JP','ja-JP','日语'),
            new KLEnumCase<string>('KO_KR','ko-KR','韩语'),
            new KLEnumCase<string>('VI_VN','vi-VN','越南语'),
            new KLEnumCase<string>('TH_TH','th-TH','泰语'),
            new KLEnumCase<string>('ID_ID','id-ID','印尼语'),
            new KLEnumCase<string>('MS_MY','ms-MY','马来语'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLLang|null {
        switch (val) {
            case KLLang.ZH_CN.value:return KLLang.ZH_CN;
            case KLLang.ZH_TW.value:return KLLang.ZH_TW;
            case KLLang.EN.value:return KLLang.EN;
            case KLLang.EN_PH.value:return KLLang.EN_PH;
            case KLLang.JA_JP.value:return KLLang.JA_JP;
            case KLLang.KO_KR.value:return KLLang.KO_KR;
            case KLLang.VI_VN.value:return KLLang.VI_VN;
            case KLLang.TH_TH.value:return KLLang.TH_TH;
            case KLLang.ID_ID.value:return KLLang.ID_ID;
            case KLLang.MS_MY.value:return KLLang.MS_MY;
        }
        return null;
    }
}

/**
 * 随机评分场景
*/
export class RandomScoreScene extends KLEnum<string>{

    // 首页瀑布流
    static readonly FEED = new RandomScoreScene('FEED','feed','首页瀑布流');

    // 购物车推荐
    static readonly CART = new RandomScoreScene('CART','cart','购物车推荐');

    // 热门搜索
    static readonly HOT = new RandomScoreScene('HOT','hot','热门搜索');

    // 商品搜索
    static readonly SEARCH = new RandomScoreScene('SEARCH','search','商品搜索');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... RandomScoreScene.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FEED','feed','首页瀑布流'),
            new KLEnumCase<string>('CART','cart','购物车推荐'),
            new KLEnumCase<string>('HOT','hot','热门搜索'),
            new KLEnumCase<string>('SEARCH','search','商品搜索'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):RandomScoreScene|null {
        switch (val) {
            case RandomScoreScene.FEED.value:return RandomScoreScene.FEED;
            case RandomScoreScene.CART.value:return RandomScoreScene.CART;
            case RandomScoreScene.HOT.value:return RandomScoreScene.HOT;
            case RandomScoreScene.SEARCH.value:return RandomScoreScene.SEARCH;
        }
        return null;
    }
}

/**
 * 
*/
export class KLOrderButtonStyle extends KLEnum<string>{

    // 普通（黑框白底）
    static readonly NORMAL = new KLOrderButtonStyle('NORMAL','normal','普通（黑框白底）');

    // 强调（橙色填充）
    static readonly EMPHASIS = new KLOrderButtonStyle('EMPHASIS','emphasis','强调（橙色填充）');

    // 次要（橙框白底）
    static readonly SECONDARY = new KLOrderButtonStyle('SECONDARY','secondary','次要（橙框白底）');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLOrderButtonStyle.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NORMAL','normal','普通（黑框白底）'),
            new KLEnumCase<string>('EMPHASIS','emphasis','强调（橙色填充）'),
            new KLEnumCase<string>('SECONDARY','secondary','次要（橙框白底）'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLOrderButtonStyle|null {
        switch (val) {
            case KLOrderButtonStyle.NORMAL.value:return KLOrderButtonStyle.NORMAL;
            case KLOrderButtonStyle.EMPHASIS.value:return KLOrderButtonStyle.EMPHASIS;
            case KLOrderButtonStyle.SECONDARY.value:return KLOrderButtonStyle.SECONDARY;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallOrderAction extends KLEnum<string>{

    // Pay Now
    static readonly PAY_NOW = new KLMallOrderAction('PAY_NOW','pay_now','Pay Now');

    // Cancel
    static readonly CANCEL_UNPAID = new KLMallOrderAction('CANCEL_UNPAID','cancel_unpaid','Cancel');

    // Cancel
    static readonly CANCEL_PAID = new KLMallOrderAction('CANCEL_PAID','cancel_paid','Cancel');

    // Reorder
    static readonly REORDER = new KLMallOrderAction('REORDER','reorder','Reorder');

    // Refund
    static readonly REFUND = new KLMallOrderAction('REFUND','refund','Refund');

    // Refund Details
    static readonly REFUND_DETAILS = new KLMallOrderAction('REFUND_DETAILS','refund_details','Refund Details');

    // Review
    static readonly REVIEW = new KLMallOrderAction('REVIEW','review','Review');

    // Review Info
    static readonly REVIEW_INFO = new KLMallOrderAction('REVIEW_INFO','review_info','Review Info');

    // Delete
    static readonly DELETE = new KLMallOrderAction('DELETE','delete','Delete');

    // Contact Seller
    static readonly CONTACT_SELLER = new KLMallOrderAction('CONTACT_SELLER','contact_seller','Contact Seller');

    // Rider
    static readonly CONTACT_RIDER = new KLMallOrderAction('CONTACT_RIDER','contact_rider','Rider');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PAY_NOW','pay_now','Pay Now'),
            new KLEnumCase<string>('CANCEL_UNPAID','cancel_unpaid','Cancel'),
            new KLEnumCase<string>('CANCEL_PAID','cancel_paid','Cancel'),
            new KLEnumCase<string>('REORDER','reorder','Reorder'),
            new KLEnumCase<string>('REFUND','refund','Refund'),
            new KLEnumCase<string>('REFUND_DETAILS','refund_details','Refund Details'),
            new KLEnumCase<string>('REVIEW','review','Review'),
            new KLEnumCase<string>('REVIEW_INFO','review_info','Review Info'),
            new KLEnumCase<string>('DELETE','delete','Delete'),
            new KLEnumCase<string>('CONTACT_SELLER','contact_seller','Contact Seller'),
            new KLEnumCase<string>('CONTACT_RIDER','contact_rider','Rider'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderAction|null {
        switch (val) {
            case KLMallOrderAction.PAY_NOW.value:return KLMallOrderAction.PAY_NOW;
            case KLMallOrderAction.CANCEL_UNPAID.value:return KLMallOrderAction.CANCEL_UNPAID;
            case KLMallOrderAction.CANCEL_PAID.value:return KLMallOrderAction.CANCEL_PAID;
            case KLMallOrderAction.REORDER.value:return KLMallOrderAction.REORDER;
            case KLMallOrderAction.REFUND.value:return KLMallOrderAction.REFUND;
            case KLMallOrderAction.REFUND_DETAILS.value:return KLMallOrderAction.REFUND_DETAILS;
            case KLMallOrderAction.REVIEW.value:return KLMallOrderAction.REVIEW;
            case KLMallOrderAction.REVIEW_INFO.value:return KLMallOrderAction.REVIEW_INFO;
            case KLMallOrderAction.DELETE.value:return KLMallOrderAction.DELETE;
            case KLMallOrderAction.CONTACT_SELLER.value:return KLMallOrderAction.CONTACT_SELLER;
            case KLMallOrderAction.CONTACT_RIDER.value:return KLMallOrderAction.CONTACT_RIDER;
        }
        return null;
    }
}

/**
 * 订单展示状态
*/
export class KLMallOrderDisplayStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING_PAYMENT = new KLMallOrderDisplayStatus('PENDING_PAYMENT','PENDING_PAYMENT','Pending');

    // Order Confirmed
    static readonly ORDER_CONFIRMED = new KLMallOrderDisplayStatus('ORDER_CONFIRMED','ORDER_CONFIRMED','Order Confirmed');

    // Packing
    static readonly PACKING = new KLMallOrderDisplayStatus('PACKING','PACKING','Packing');

    // Picking Up
    static readonly PICKING_UP = new KLMallOrderDisplayStatus('PICKING_UP','PICKING_UP','Picking Up');

    // Delivering
    static readonly DELIVERING = new KLMallOrderDisplayStatus('DELIVERING','DELIVERING','Delivering');

    // Arrived
    static readonly ARRIVED = new KLMallOrderDisplayStatus('ARRIVED','ARRIVED','Arrived');

    // Completed
    static readonly COMPLETED = new KLMallOrderDisplayStatus('COMPLETED','COMPLETED','Completed');

    // After-sales
    static readonly AFTER_SALES = new KLMallOrderDisplayStatus('AFTER_SALES','AFTER_SALES','After-sales');

    // Cancelled
    static readonly CANCELLED = new KLMallOrderDisplayStatus('CANCELLED','CANCELLED','Cancelled');

    // Refunded
    static readonly REFUNDED = new KLMallOrderDisplayStatus('REFUNDED','REFUNDED','Refunded');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderDisplayStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING_PAYMENT','PENDING_PAYMENT','Pending'),
            new KLEnumCase<string>('ORDER_CONFIRMED','ORDER_CONFIRMED','Order Confirmed'),
            new KLEnumCase<string>('PACKING','PACKING','Packing'),
            new KLEnumCase<string>('PICKING_UP','PICKING_UP','Picking Up'),
            new KLEnumCase<string>('DELIVERING','DELIVERING','Delivering'),
            new KLEnumCase<string>('ARRIVED','ARRIVED','Arrived'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('AFTER_SALES','AFTER_SALES','After-sales'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderDisplayStatus|null {
        switch (val) {
            case KLMallOrderDisplayStatus.PENDING_PAYMENT.value:return KLMallOrderDisplayStatus.PENDING_PAYMENT;
            case KLMallOrderDisplayStatus.ORDER_CONFIRMED.value:return KLMallOrderDisplayStatus.ORDER_CONFIRMED;
            case KLMallOrderDisplayStatus.PACKING.value:return KLMallOrderDisplayStatus.PACKING;
            case KLMallOrderDisplayStatus.PICKING_UP.value:return KLMallOrderDisplayStatus.PICKING_UP;
            case KLMallOrderDisplayStatus.DELIVERING.value:return KLMallOrderDisplayStatus.DELIVERING;
            case KLMallOrderDisplayStatus.ARRIVED.value:return KLMallOrderDisplayStatus.ARRIVED;
            case KLMallOrderDisplayStatus.COMPLETED.value:return KLMallOrderDisplayStatus.COMPLETED;
            case KLMallOrderDisplayStatus.AFTER_SALES.value:return KLMallOrderDisplayStatus.AFTER_SALES;
            case KLMallOrderDisplayStatus.CANCELLED.value:return KLMallOrderDisplayStatus.CANCELLED;
            case KLMallOrderDisplayStatus.REFUNDED.value:return KLMallOrderDisplayStatus.REFUNDED;
        }
        return null;
    }
}

/**
 * 商品排序
*/
export class KLMallGoodsSortField extends KLEnum<string>{

    // Default
    static readonly DEFAULT = new KLMallGoodsSortField('DEFAULT','DEFAULT','Default');

    // Price: Low to High
    static readonly PRICE_ASC = new KLMallGoodsSortField('PRICE_ASC','PRICE_ASC','Price: Low to High');

    // Price: High to Low
    static readonly PRICE_DESC = new KLMallGoodsSortField('PRICE_DESC','PRICE_DESC','Price: High to Low');

    // Sales
    static readonly SALES = new KLMallGoodsSortField('SALES','SALES','Sales');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsSortField.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DEFAULT','DEFAULT','Default'),
            new KLEnumCase<string>('PRICE_ASC','PRICE_ASC','Price: Low to High'),
            new KLEnumCase<string>('PRICE_DESC','PRICE_DESC','Price: High to Low'),
            new KLEnumCase<string>('SALES','SALES','Sales'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsSortField|null {
        switch (val) {
            case KLMallGoodsSortField.DEFAULT.value:return KLMallGoodsSortField.DEFAULT;
            case KLMallGoodsSortField.PRICE_ASC.value:return KLMallGoodsSortField.PRICE_ASC;
            case KLMallGoodsSortField.PRICE_DESC.value:return KLMallGoodsSortField.PRICE_DESC;
            case KLMallGoodsSortField.SALES.value:return KLMallGoodsSortField.SALES;
        }
        return null;
    }
}

/**
 * 商品收藏排序方式
*/
export class KLMallUserGoodsCollectSortBy extends KLEnum<string>{

    // Default
    static readonly DEFAULT = new KLMallUserGoodsCollectSortBy('DEFAULT','created_at','Default');

    // Price: Low to High
    static readonly PRICE_LOW_TO_HIGH = new KLMallUserGoodsCollectSortBy('PRICE_LOW_TO_HIGH','price_asc','Price: Low to High');

    // Price: High to Low
    static readonly PRICE_HIGH_TO_LOW = new KLMallUserGoodsCollectSortBy('PRICE_HIGH_TO_LOW','price_desc','Price: High to Low');

    // Sales
    static readonly SALES = new KLMallUserGoodsCollectSortBy('SALES','sales','Sales');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallUserGoodsCollectSortBy.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DEFAULT','created_at','Default'),
            new KLEnumCase<string>('PRICE_LOW_TO_HIGH','price_asc','Price: Low to High'),
            new KLEnumCase<string>('PRICE_HIGH_TO_LOW','price_desc','Price: High to Low'),
            new KLEnumCase<string>('SALES','sales','Sales'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallUserGoodsCollectSortBy|null {
        switch (val) {
            case KLMallUserGoodsCollectSortBy.DEFAULT.value:return KLMallUserGoodsCollectSortBy.DEFAULT;
            case KLMallUserGoodsCollectSortBy.PRICE_LOW_TO_HIGH.value:return KLMallUserGoodsCollectSortBy.PRICE_LOW_TO_HIGH;
            case KLMallUserGoodsCollectSortBy.PRICE_HIGH_TO_LOW.value:return KLMallUserGoodsCollectSortBy.PRICE_HIGH_TO_LOW;
            case KLMallUserGoodsCollectSortBy.SALES.value:return KLMallUserGoodsCollectSortBy.SALES;
        }
        return null;
    }
}

/**
 * 商品收藏状态筛选
*/
export class KLMallUserGoodsCollectStatus extends KLEnum<string>{

    // All
    static readonly ALL = new KLMallUserGoodsCollectStatus('ALL','all','All');

    // Available
    static readonly AVAILABLE = new KLMallUserGoodsCollectStatus('AVAILABLE','available','Available');

    // Sold Out
    static readonly SOLD_OUT = new KLMallUserGoodsCollectStatus('SOLD_OUT','sold_out','Sold Out');

    // Expired
    static readonly EXPIRED = new KLMallUserGoodsCollectStatus('EXPIRED','expired','Expired');

    // Deleted
    static readonly DELETED = new KLMallUserGoodsCollectStatus('DELETED','deleted','Deleted');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallUserGoodsCollectStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','all','All'),
            new KLEnumCase<string>('AVAILABLE','available','Available'),
            new KLEnumCase<string>('SOLD_OUT','sold_out','Sold Out'),
            new KLEnumCase<string>('EXPIRED','expired','Expired'),
            new KLEnumCase<string>('DELETED','deleted','Deleted'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallUserGoodsCollectStatus|null {
        switch (val) {
            case KLMallUserGoodsCollectStatus.ALL.value:return KLMallUserGoodsCollectStatus.ALL;
            case KLMallUserGoodsCollectStatus.AVAILABLE.value:return KLMallUserGoodsCollectStatus.AVAILABLE;
            case KLMallUserGoodsCollectStatus.SOLD_OUT.value:return KLMallUserGoodsCollectStatus.SOLD_OUT;
            case KLMallUserGoodsCollectStatus.EXPIRED.value:return KLMallUserGoodsCollectStatus.EXPIRED;
            case KLMallUserGoodsCollectStatus.DELETED.value:return KLMallUserGoodsCollectStatus.DELETED;
        }
        return null;
    }
}

/**
 * 用户中心列表模块类型
*/
export class KLUserCenterLinkType extends KLEnum<string>{

    // Link
    static readonly LINK = new KLUserCenterLinkType('LINK','link','Link');

    // Language
    static readonly LANGUAGE = new KLUserCenterLinkType('LANGUAGE','language','Language');

    // Invite Code
    static readonly INVITE_CODE = new KLUserCenterLinkType('INVITE_CODE','invite_code','Invite Code');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserCenterLinkType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('LINK','link','Link'),
            new KLEnumCase<string>('LANGUAGE','language','Language'),
            new KLEnumCase<string>('INVITE_CODE','invite_code','Invite Code'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserCenterLinkType|null {
        switch (val) {
            case KLUserCenterLinkType.LINK.value:return KLUserCenterLinkType.LINK;
            case KLUserCenterLinkType.LANGUAGE.value:return KLUserCenterLinkType.LANGUAGE;
            case KLUserCenterLinkType.INVITE_CODE.value:return KLUserCenterLinkType.INVITE_CODE;
        }
        return null;
    }
}

/**
 * 用户设置类型
*/
export class KLUserSettingsType extends KLEnum<string>{

    // 个性化内容推荐
    static readonly PERSONALIZED_CONTENT = new KLUserSettingsType('PERSONALIZED_CONTENT','personalized_content','个性化内容推荐');

    // 个性化广告
    static readonly PERSONALIZED_ADS = new KLUserSettingsType('PERSONALIZED_ADS','personalized_ads','个性化广告');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserSettingsType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PERSONALIZED_CONTENT','personalized_content','个性化内容推荐'),
            new KLEnumCase<string>('PERSONALIZED_ADS','personalized_ads','个性化广告'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserSettingsType|null {
        switch (val) {
            case KLUserSettingsType.PERSONALIZED_CONTENT.value:return KLUserSettingsType.PERSONALIZED_CONTENT;
            case KLUserSettingsType.PERSONALIZED_ADS.value:return KLUserSettingsType.PERSONALIZED_ADS;
        }
        return null;
    }
}

/**
 * 售后类型
*/
export class KLMallAftersaleType extends KLEnum<string>{

    // Refund Only
    static readonly REFUND_ONLY = new KLMallAftersaleType('REFUND_ONLY','REFUND_ONLY','Refund Only');

    // Return Refund
    static readonly RETURN_REFUND = new KLMallAftersaleType('RETURN_REFUND','RETURN_REFUND','Return Refund');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallAftersaleType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('REFUND_ONLY','REFUND_ONLY','Refund Only'),
            new KLEnumCase<string>('RETURN_REFUND','RETURN_REFUND','Return Refund'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallAftersaleType|null {
        switch (val) {
            case KLMallAftersaleType.REFUND_ONLY.value:return KLMallAftersaleType.REFUND_ONLY;
            case KLMallAftersaleType.RETURN_REFUND.value:return KLMallAftersaleType.RETURN_REFUND;
        }
        return null;
    }
}

/**
 * 售后审核动作
*/
export class KLMallOrderReturnAuditAction extends KLEnum<string>{

    // 通过
    static readonly APPROVE = new KLMallOrderReturnAuditAction('APPROVE','APPROVE','通过');

    // 拒绝
    static readonly REJECT = new KLMallOrderReturnAuditAction('REJECT','REJECT','拒绝');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnAuditAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('APPROVE','APPROVE','通过'),
            new KLEnumCase<string>('REJECT','REJECT','拒绝'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnAuditAction|null {
        switch (val) {
            case KLMallOrderReturnAuditAction.APPROVE.value:return KLMallOrderReturnAuditAction.APPROVE;
            case KLMallOrderReturnAuditAction.REJECT.value:return KLMallOrderReturnAuditAction.REJECT;
        }
        return null;
    }
}

/**
 * 售后配送方式
*/
export class KLMallOrderReturnDeliveryType extends KLEnum<string>{

    // Platform
    static readonly PLATFORM = new KLMallOrderReturnDeliveryType('PLATFORM','PLATFORM','Platform');

    // Merchant
    static readonly MERCHANT = new KLMallOrderReturnDeliveryType('MERCHANT','MERCHANT','Merchant');

    // Third
    static readonly THIRD = new KLMallOrderReturnDeliveryType('THIRD','THIRD','Third');

    // Self Pickup
    static readonly SELF_PICKUP = new KLMallOrderReturnDeliveryType('SELF_PICKUP','SELF_PICKUP','Self Pickup');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnDeliveryType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PLATFORM','PLATFORM','Platform'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','Merchant'),
            new KLEnumCase<string>('THIRD','THIRD','Third'),
            new KLEnumCase<string>('SELF_PICKUP','SELF_PICKUP','Self Pickup'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnDeliveryType|null {
        switch (val) {
            case KLMallOrderReturnDeliveryType.PLATFORM.value:return KLMallOrderReturnDeliveryType.PLATFORM;
            case KLMallOrderReturnDeliveryType.MERCHANT.value:return KLMallOrderReturnDeliveryType.MERCHANT;
            case KLMallOrderReturnDeliveryType.THIRD.value:return KLMallOrderReturnDeliveryType.THIRD;
            case KLMallOrderReturnDeliveryType.SELF_PICKUP.value:return KLMallOrderReturnDeliveryType.SELF_PICKUP;
        }
        return null;
    }
}

/**
 * 原支付方式
*/
export class KLMallOrderReturnOriginalPayMethod extends KLEnum<string>{

    // Online
    static readonly ONLINE = new KLMallOrderReturnOriginalPayMethod('ONLINE','ONLINE','Online');

    // COD
    static readonly COD = new KLMallOrderReturnOriginalPayMethod('COD','COD','COD');

    // Balance
    static readonly BALANCE = new KLMallOrderReturnOriginalPayMethod('BALANCE','BALANCE','Balance');

    // Mixed
    static readonly MIXED = new KLMallOrderReturnOriginalPayMethod('MIXED','MIXED','Mixed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnOriginalPayMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','Online'),
            new KLEnumCase<string>('COD','COD','COD'),
            new KLEnumCase<string>('BALANCE','BALANCE','Balance'),
            new KLEnumCase<string>('MIXED','MIXED','Mixed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnOriginalPayMethod|null {
        switch (val) {
            case KLMallOrderReturnOriginalPayMethod.ONLINE.value:return KLMallOrderReturnOriginalPayMethod.ONLINE;
            case KLMallOrderReturnOriginalPayMethod.COD.value:return KLMallOrderReturnOriginalPayMethod.COD;
            case KLMallOrderReturnOriginalPayMethod.BALANCE.value:return KLMallOrderReturnOriginalPayMethod.BALANCE;
            case KLMallOrderReturnOriginalPayMethod.MIXED.value:return KLMallOrderReturnOriginalPayMethod.MIXED;
        }
        return null;
    }
}

/**
 * 取件状态
*/
export class KLMallOrderReturnPickupStatus extends KLEnum<string>{

    // Pending Allocation
    static readonly PENDING = new KLMallOrderReturnPickupStatus('PENDING','PENDING','Pending Allocation');

    // Assigned
    static readonly ASSIGNED = new KLMallOrderReturnPickupStatus('ASSIGNED','ASSIGNED','Assigned');

    // Picking Up
    static readonly PICKING_UP = new KLMallOrderReturnPickupStatus('PICKING_UP','PICKING_UP','Picking Up');

    // Picked Up
    static readonly PICKED_UP = new KLMallOrderReturnPickupStatus('PICKED_UP','PICKED_UP','Picked Up');

    // Cancelled
    static readonly CANCELLED = new KLMallOrderReturnPickupStatus('CANCELLED','CANCELLED','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnPickupStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending Allocation'),
            new KLEnumCase<string>('ASSIGNED','ASSIGNED','Assigned'),
            new KLEnumCase<string>('PICKING_UP','PICKING_UP','Picking Up'),
            new KLEnumCase<string>('PICKED_UP','PICKED_UP','Picked Up'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnPickupStatus|null {
        switch (val) {
            case KLMallOrderReturnPickupStatus.PENDING.value:return KLMallOrderReturnPickupStatus.PENDING;
            case KLMallOrderReturnPickupStatus.ASSIGNED.value:return KLMallOrderReturnPickupStatus.ASSIGNED;
            case KLMallOrderReturnPickupStatus.PICKING_UP.value:return KLMallOrderReturnPickupStatus.PICKING_UP;
            case KLMallOrderReturnPickupStatus.PICKED_UP.value:return KLMallOrderReturnPickupStatus.PICKED_UP;
            case KLMallOrderReturnPickupStatus.CANCELLED.value:return KLMallOrderReturnPickupStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 退款原因
*/
export class KLMallOrderReturnReasonCode extends KLEnum<string>{

    // 不想要了
    static readonly DONT_WANT = new KLMallOrderReturnReasonCode('DONT_WANT','DONT_WANT','不想要了');

    // 缺货
    static readonly OUT_OF_STOCK = new KLMallOrderReturnReasonCode('OUT_OF_STOCK','OUT_OF_STOCK','缺货');

    // 无法配送
    static readonly UNABLE_DELIVER = new KLMallOrderReturnReasonCode('UNABLE_DELIVER','UNABLE_DELIVER','无法配送');

    // 信息错误
    static readonly INCORRECT_INFO = new KLMallOrderReturnReasonCode('INCORRECT_INFO','INCORRECT_INFO','信息错误');

    // 质量问题
    static readonly QUALITY_ISSUE = new KLMallOrderReturnReasonCode('QUALITY_ISSUE','QUALITY_ISSUE','质量问题');

    // 其他
    static readonly OTHER = new KLMallOrderReturnReasonCode('OTHER','OTHER','其他');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnReasonCode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DONT_WANT','DONT_WANT','不想要了'),
            new KLEnumCase<string>('OUT_OF_STOCK','OUT_OF_STOCK','缺货'),
            new KLEnumCase<string>('UNABLE_DELIVER','UNABLE_DELIVER','无法配送'),
            new KLEnumCase<string>('INCORRECT_INFO','INCORRECT_INFO','信息错误'),
            new KLEnumCase<string>('QUALITY_ISSUE','QUALITY_ISSUE','质量问题'),
            new KLEnumCase<string>('OTHER','OTHER','其他'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnReasonCode|null {
        switch (val) {
            case KLMallOrderReturnReasonCode.DONT_WANT.value:return KLMallOrderReturnReasonCode.DONT_WANT;
            case KLMallOrderReturnReasonCode.OUT_OF_STOCK.value:return KLMallOrderReturnReasonCode.OUT_OF_STOCK;
            case KLMallOrderReturnReasonCode.UNABLE_DELIVER.value:return KLMallOrderReturnReasonCode.UNABLE_DELIVER;
            case KLMallOrderReturnReasonCode.INCORRECT_INFO.value:return KLMallOrderReturnReasonCode.INCORRECT_INFO;
            case KLMallOrderReturnReasonCode.QUALITY_ISSUE.value:return KLMallOrderReturnReasonCode.QUALITY_ISSUE;
            case KLMallOrderReturnReasonCode.OTHER.value:return KLMallOrderReturnReasonCode.OTHER;
        }
        return null;
    }
}

/**
 * 退款范围
*/
export class KLMallOrderReturnRefundScope extends KLEnum<string>{

    // Full
    static readonly FULL = new KLMallOrderReturnRefundScope('FULL','FULL','Full');

    // Partial
    static readonly PARTIAL = new KLMallOrderReturnRefundScope('PARTIAL','PARTIAL','Partial');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnRefundScope.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FULL','FULL','Full'),
            new KLEnumCase<string>('PARTIAL','PARTIAL','Partial'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnRefundScope|null {
        switch (val) {
            case KLMallOrderReturnRefundScope.FULL.value:return KLMallOrderReturnRefundScope.FULL;
            case KLMallOrderReturnRefundScope.PARTIAL.value:return KLMallOrderReturnRefundScope.PARTIAL;
        }
        return null;
    }
}

/**
 * 退款状态
*/
export class KLMallOrderReturnRefundStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING = new KLMallOrderReturnRefundStatus('PENDING','PENDING','Pending');

    // Processing
    static readonly PROCESSING = new KLMallOrderReturnRefundStatus('PROCESSING','PROCESSING','Processing');

    // Completed
    static readonly COMPLETED = new KLMallOrderReturnRefundStatus('COMPLETED','COMPLETED','Completed');

    // failed
    static readonly FAILED = new KLMallOrderReturnRefundStatus('FAILED','FAILED','failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnRefundStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','Processing'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('FAILED','FAILED','failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnRefundStatus|null {
        switch (val) {
            case KLMallOrderReturnRefundStatus.PENDING.value:return KLMallOrderReturnRefundStatus.PENDING;
            case KLMallOrderReturnRefundStatus.PROCESSING.value:return KLMallOrderReturnRefundStatus.PROCESSING;
            case KLMallOrderReturnRefundStatus.COMPLETED.value:return KLMallOrderReturnRefundStatus.COMPLETED;
            case KLMallOrderReturnRefundStatus.FAILED.value:return KLMallOrderReturnRefundStatus.FAILED;
        }
        return null;
    }
}

/**
 * 售后申请来源
*/
export class KLMallOrderReturnSource extends KLEnum<string>{

    // App
    static readonly APP = new KLMallOrderReturnSource('APP','APP','App');

    // PC
    static readonly PC = new KLMallOrderReturnSource('PC','PC','PC');

    // WAP
    static readonly WAP = new KLMallOrderReturnSource('WAP','WAP','WAP');

    // Applet
    static readonly APPLET = new KLMallOrderReturnSource('APPLET','APPLET','Applet');

    // Other
    static readonly OTHER = new KLMallOrderReturnSource('OTHER','OTHER','Other');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnSource.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('APP','APP','App'),
            new KLEnumCase<string>('PC','PC','PC'),
            new KLEnumCase<string>('WAP','WAP','WAP'),
            new KLEnumCase<string>('APPLET','APPLET','Applet'),
            new KLEnumCase<string>('OTHER','OTHER','Other'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnSource|null {
        switch (val) {
            case KLMallOrderReturnSource.APP.value:return KLMallOrderReturnSource.APP;
            case KLMallOrderReturnSource.PC.value:return KLMallOrderReturnSource.PC;
            case KLMallOrderReturnSource.WAP.value:return KLMallOrderReturnSource.WAP;
            case KLMallOrderReturnSource.APPLET.value:return KLMallOrderReturnSource.APPLET;
            case KLMallOrderReturnSource.OTHER.value:return KLMallOrderReturnSource.OTHER;
        }
        return null;
    }
}

/**
 * 退货退款单状态
*/
export class KLMallOrderReturnStatus extends KLEnum<string>{

    // Under Review
    static readonly UNDER_REVIEW = new KLMallOrderReturnStatus('UNDER_REVIEW','UNDER_REVIEW','Under Review');

    // Processing
    static readonly PROCESSING = new KLMallOrderReturnStatus('PROCESSING','PROCESSING','Processing');

    // Rejected
    static readonly REJECTED = new KLMallOrderReturnStatus('REJECTED','REJECTED','Rejected');

    // Completed
    static readonly COMPLETED = new KLMallOrderReturnStatus('COMPLETED','COMPLETED','Completed');

    // Cancelled
    static readonly CANCELLED = new KLMallOrderReturnStatus('CANCELLED','CANCELLED','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNDER_REVIEW','UNDER_REVIEW','Under Review'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','Processing'),
            new KLEnumCase<string>('REJECTED','REJECTED','Rejected'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnStatus|null {
        switch (val) {
            case KLMallOrderReturnStatus.UNDER_REVIEW.value:return KLMallOrderReturnStatus.UNDER_REVIEW;
            case KLMallOrderReturnStatus.PROCESSING.value:return KLMallOrderReturnStatus.PROCESSING;
            case KLMallOrderReturnStatus.REJECTED.value:return KLMallOrderReturnStatus.REJECTED;
            case KLMallOrderReturnStatus.COMPLETED.value:return KLMallOrderReturnStatus.COMPLETED;
            case KLMallOrderReturnStatus.CANCELLED.value:return KLMallOrderReturnStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 售后类型
*/
export class KLMallOrderReturnType extends KLEnum<string>{

    // Refund Only
    static readonly REFUND_ONLY = new KLMallOrderReturnType('REFUND_ONLY','REFUND_ONLY','Refund Only');

    // Return Refund
    static readonly RETURN_REFUND = new KLMallOrderReturnType('RETURN_REFUND','RETURN_REFUND','Return Refund');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('REFUND_ONLY','REFUND_ONLY','Refund Only'),
            new KLEnumCase<string>('RETURN_REFUND','RETURN_REFUND','Return Refund'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnType|null {
        switch (val) {
            case KLMallOrderReturnType.REFUND_ONLY.value:return KLMallOrderReturnType.REFUND_ONLY;
            case KLMallOrderReturnType.RETURN_REFUND.value:return KLMallOrderReturnType.RETURN_REFUND;
        }
        return null;
    }
}

/**
 * 售后原因
*/
export class KLMallReturnReason extends KLEnum<string>{

    // Do not want it anymore
    static readonly DONT_WANT = new KLMallReturnReason('DONT_WANT','DONT_WANT','Do not want it anymore');

    // Unable to deliver
    static readonly UNABLE_DELIVER = new KLMallReturnReason('UNABLE_DELIVER','UNABLE_DELIVER','Unable to deliver');

    // Incorrect order information
    static readonly INCORRECT_INFO = new KLMallReturnReason('INCORRECT_INFO','INCORRECT_INFO','Incorrect order information');

    // Quantity issue
    static readonly QUALITY_ISSUE = new KLMallReturnReason('QUALITY_ISSUE','QUALITY_ISSUE','Quantity issue');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallReturnReason.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DONT_WANT','DONT_WANT','Do not want it anymore'),
            new KLEnumCase<string>('UNABLE_DELIVER','UNABLE_DELIVER','Unable to deliver'),
            new KLEnumCase<string>('INCORRECT_INFO','INCORRECT_INFO','Incorrect order information'),
            new KLEnumCase<string>('QUALITY_ISSUE','QUALITY_ISSUE','Quantity issue'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallReturnReason|null {
        switch (val) {
            case KLMallReturnReason.DONT_WANT.value:return KLMallReturnReason.DONT_WANT;
            case KLMallReturnReason.UNABLE_DELIVER.value:return KLMallReturnReason.UNABLE_DELIVER;
            case KLMallReturnReason.INCORRECT_INFO.value:return KLMallReturnReason.INCORRECT_INFO;
            case KLMallReturnReason.QUALITY_ISSUE.value:return KLMallReturnReason.QUALITY_ISSUE;
        }
        return null;
    }
}

/**
 * 购物车SKU状态
*/
export class KLMallCartStatus extends KLEnum<string>{

    // 可用
    static readonly VALID = new KLMallCartStatus('VALID','VALID','可用');

    // 不可用
    static readonly INVALID = new KLMallCartStatus('INVALID','INVALID','不可用');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallCartStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('VALID','VALID','可用'),
            new KLEnumCase<string>('INVALID','INVALID','不可用'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallCartStatus|null {
        switch (val) {
            case KLMallCartStatus.VALID.value:return KLMallCartStatus.VALID;
            case KLMallCartStatus.INVALID.value:return KLMallCartStatus.INVALID;
        }
        return null;
    }
}

/**
 * Cart validation failure codes
*/
export class KLMallCartValidationCode extends KLEnum<string>{

    // 库存不足
    static readonly INSUFFICIENT_STOCK = new KLMallCartValidationCode('INSUFFICIENT_STOCK','INSUFFICIENT_STOCK','库存不足');

    // 已售罄
    static readonly OUT_OF_STOCK = new KLMallCartValidationCode('OUT_OF_STOCK','OUT_OF_STOCK','已售罄');

    // 库存预占超时
    static readonly STOCK_RESERVATION_TIMEOUT = new KLMallCartValidationCode('STOCK_RESERVATION_TIMEOUT','STOCK_RESERVATION_TIMEOUT','库存预占超时');

    // 价格变动
    static readonly PRICE_CHANGED = new KLMallCartValidationCode('PRICE_CHANGED','PRICE_CHANGED','价格变动');

    // 促销活动结束
    static readonly PROMOTION_ENDED = new KLMallCartValidationCode('PROMOTION_ENDED','PROMOTION_ENDED','促销活动结束');

    // 商品下架
    static readonly PRODUCT_OFF_SHELF = new KLMallCartValidationCode('PRODUCT_OFF_SHELF','PRODUCT_OFF_SHELF','商品下架');

    // 商品禁售
    static readonly PRODUCT_BANNED = new KLMallCartValidationCode('PRODUCT_BANNED','PRODUCT_BANNED','商品禁售');

    // SKU停售
    static readonly SKU_DISCONTINUED = new KLMallCartValidationCode('SKU_DISCONTINUED','SKU_DISCONTINUED','SKU停售');

    // SKU已删除
    static readonly SKU_DELETED = new KLMallCartValidationCode('SKU_DELETED','SKU_DELETED','SKU已删除');

    // 商品违规
    static readonly PRODUCT_VIOLATES_POLICY = new KLMallCartValidationCode('PRODUCT_VIOLATES_POLICY','PRODUCT_VIOLATES_POLICY','商品违规');

    // 超过限购数量
    static readonly EXCEED_PURCHASE_LIMIT = new KLMallCartValidationCode('EXCEED_PURCHASE_LIMIT','EXCEED_PURCHASE_LIMIT','超过限购数量');

    // 未达到起订量
    static readonly BELOW_MIN_ORDER_QTY = new KLMallCartValidationCode('BELOW_MIN_ORDER_QTY','BELOW_MIN_ORDER_QTY','未达到起订量');

    // 超过订单限额
    static readonly EXCEED_ORDER_AMOUNT_LIMIT = new KLMallCartValidationCode('EXCEED_ORDER_AMOUNT_LIMIT','EXCEED_ORDER_AMOUNT_LIMIT','超过订单限额');

    // 重复购买限制
    static readonly DUPLICATE_PURCHASE_RESTRICTED = new KLMallCartValidationCode('DUPLICATE_PURCHASE_RESTRICTED','DUPLICATE_PURCHASE_RESTRICTED','重复购买限制');

    // 预售未开始
    static readonly PRESALE_NOT_STARTED = new KLMallCartValidationCode('PRESALE_NOT_STARTED','PRESALE_NOT_STARTED','预售未开始');

    // 商品属性变更
    static readonly ATTRIBUTE_CHANGED = new KLMallCartValidationCode('ATTRIBUTE_CHANGED','ATTRIBUTE_CHANGED','商品属性变更');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallCartValidationCode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('INSUFFICIENT_STOCK','INSUFFICIENT_STOCK','库存不足'),
            new KLEnumCase<string>('OUT_OF_STOCK','OUT_OF_STOCK','已售罄'),
            new KLEnumCase<string>('STOCK_RESERVATION_TIMEOUT','STOCK_RESERVATION_TIMEOUT','库存预占超时'),
            new KLEnumCase<string>('PRICE_CHANGED','PRICE_CHANGED','价格变动'),
            new KLEnumCase<string>('PROMOTION_ENDED','PROMOTION_ENDED','促销活动结束'),
            new KLEnumCase<string>('PRODUCT_OFF_SHELF','PRODUCT_OFF_SHELF','商品下架'),
            new KLEnumCase<string>('PRODUCT_BANNED','PRODUCT_BANNED','商品禁售'),
            new KLEnumCase<string>('SKU_DISCONTINUED','SKU_DISCONTINUED','SKU停售'),
            new KLEnumCase<string>('SKU_DELETED','SKU_DELETED','SKU已删除'),
            new KLEnumCase<string>('PRODUCT_VIOLATES_POLICY','PRODUCT_VIOLATES_POLICY','商品违规'),
            new KLEnumCase<string>('EXCEED_PURCHASE_LIMIT','EXCEED_PURCHASE_LIMIT','超过限购数量'),
            new KLEnumCase<string>('BELOW_MIN_ORDER_QTY','BELOW_MIN_ORDER_QTY','未达到起订量'),
            new KLEnumCase<string>('EXCEED_ORDER_AMOUNT_LIMIT','EXCEED_ORDER_AMOUNT_LIMIT','超过订单限额'),
            new KLEnumCase<string>('DUPLICATE_PURCHASE_RESTRICTED','DUPLICATE_PURCHASE_RESTRICTED','重复购买限制'),
            new KLEnumCase<string>('PRESALE_NOT_STARTED','PRESALE_NOT_STARTED','预售未开始'),
            new KLEnumCase<string>('ATTRIBUTE_CHANGED','ATTRIBUTE_CHANGED','商品属性变更'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallCartValidationCode|null {
        switch (val) {
            case KLMallCartValidationCode.INSUFFICIENT_STOCK.value:return KLMallCartValidationCode.INSUFFICIENT_STOCK;
            case KLMallCartValidationCode.OUT_OF_STOCK.value:return KLMallCartValidationCode.OUT_OF_STOCK;
            case KLMallCartValidationCode.STOCK_RESERVATION_TIMEOUT.value:return KLMallCartValidationCode.STOCK_RESERVATION_TIMEOUT;
            case KLMallCartValidationCode.PRICE_CHANGED.value:return KLMallCartValidationCode.PRICE_CHANGED;
            case KLMallCartValidationCode.PROMOTION_ENDED.value:return KLMallCartValidationCode.PROMOTION_ENDED;
            case KLMallCartValidationCode.PRODUCT_OFF_SHELF.value:return KLMallCartValidationCode.PRODUCT_OFF_SHELF;
            case KLMallCartValidationCode.PRODUCT_BANNED.value:return KLMallCartValidationCode.PRODUCT_BANNED;
            case KLMallCartValidationCode.SKU_DISCONTINUED.value:return KLMallCartValidationCode.SKU_DISCONTINUED;
            case KLMallCartValidationCode.SKU_DELETED.value:return KLMallCartValidationCode.SKU_DELETED;
            case KLMallCartValidationCode.PRODUCT_VIOLATES_POLICY.value:return KLMallCartValidationCode.PRODUCT_VIOLATES_POLICY;
            case KLMallCartValidationCode.EXCEED_PURCHASE_LIMIT.value:return KLMallCartValidationCode.EXCEED_PURCHASE_LIMIT;
            case KLMallCartValidationCode.BELOW_MIN_ORDER_QTY.value:return KLMallCartValidationCode.BELOW_MIN_ORDER_QTY;
            case KLMallCartValidationCode.EXCEED_ORDER_AMOUNT_LIMIT.value:return KLMallCartValidationCode.EXCEED_ORDER_AMOUNT_LIMIT;
            case KLMallCartValidationCode.DUPLICATE_PURCHASE_RESTRICTED.value:return KLMallCartValidationCode.DUPLICATE_PURCHASE_RESTRICTED;
            case KLMallCartValidationCode.PRESALE_NOT_STARTED.value:return KLMallCartValidationCode.PRESALE_NOT_STARTED;
            case KLMallCartValidationCode.ATTRIBUTE_CHANGED.value:return KLMallCartValidationCode.ATTRIBUTE_CHANGED;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallCategoryTagIsFeatured extends KLEnum<string>{

    // 普通
    static readonly NO = new KLMallCategoryTagIsFeatured('NO','NO','普通');

    // 精选
    static readonly YES = new KLMallCategoryTagIsFeatured('YES','YES','精选');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallCategoryTagIsFeatured.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NO','NO','普通'),
            new KLEnumCase<string>('YES','YES','精选'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallCategoryTagIsFeatured|null {
        switch (val) {
            case KLMallCategoryTagIsFeatured.NO.value:return KLMallCategoryTagIsFeatured.NO;
            case KLMallCategoryTagIsFeatured.YES.value:return KLMallCategoryTagIsFeatured.YES;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallCategoryTagStatus extends KLEnum<string>{

    // 启用
    static readonly ENABLED = new KLMallCategoryTagStatus('ENABLED','ENABLED','启用');

    // 禁用
    static readonly DISABLED = new KLMallCategoryTagStatus('DISABLED','DISABLED','禁用');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallCategoryTagStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ENABLED','ENABLED','启用'),
            new KLEnumCase<string>('DISABLED','DISABLED','禁用'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallCategoryTagStatus|null {
        switch (val) {
            case KLMallCategoryTagStatus.ENABLED.value:return KLMallCategoryTagStatus.ENABLED;
            case KLMallCategoryTagStatus.DISABLED.value:return KLMallCategoryTagStatus.DISABLED;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallGoodsAuditEditMode extends KLEnum<string>{

    // 新建
    static readonly CREATE = new KLMallGoodsAuditEditMode('CREATE','CREATE','新建');

    // 编辑
    static readonly EDIT = new KLMallGoodsAuditEditMode('EDIT','EDIT','编辑');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsAuditEditMode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CREATE','CREATE','新建'),
            new KLEnumCase<string>('EDIT','EDIT','编辑'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsAuditEditMode|null {
        switch (val) {
            case KLMallGoodsAuditEditMode.CREATE.value:return KLMallGoodsAuditEditMode.CREATE;
            case KLMallGoodsAuditEditMode.EDIT.value:return KLMallGoodsAuditEditMode.EDIT;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallGoodsAuditStatus extends KLEnum<string>{

    // Awaiting trial
    static readonly NONE = new KLMallGoodsAuditStatus('NONE','NONE','Awaiting trial');

    // Pending
    static readonly PENDING = new KLMallGoodsAuditStatus('PENDING','PENDING','Pending');

    // Approved
    static readonly APPROVED = new KLMallGoodsAuditStatus('APPROVED','APPROVED','Approved');

    // Rejected
    static readonly REJECTED = new KLMallGoodsAuditStatus('REJECTED','REJECTED','Rejected');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsAuditStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NONE','NONE','Awaiting trial'),
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('APPROVED','APPROVED','Approved'),
            new KLEnumCase<string>('REJECTED','REJECTED','Rejected'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsAuditStatus|null {
        switch (val) {
            case KLMallGoodsAuditStatus.NONE.value:return KLMallGoodsAuditStatus.NONE;
            case KLMallGoodsAuditStatus.PENDING.value:return KLMallGoodsAuditStatus.PENDING;
            case KLMallGoodsAuditStatus.APPROVED.value:return KLMallGoodsAuditStatus.APPROVED;
            case KLMallGoodsAuditStatus.REJECTED.value:return KLMallGoodsAuditStatus.REJECTED;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallGoodsSkuInvChangeType extends KLEnum<string>{

    // Restock
    static readonly RESTOCK = new KLMallGoodsSkuInvChangeType('RESTOCK','RESTOCK','Restock');

    // Decrease Stock
    static readonly DECREASE = new KLMallGoodsSkuInvChangeType('DECREASE','DECREASE','Decrease Stock');

    // Lock Stock
    static readonly LOCK = new KLMallGoodsSkuInvChangeType('LOCK','LOCK','Lock Stock');

    // Release Stock Lock
    static readonly UNLOCK = new KLMallGoodsSkuInvChangeType('UNLOCK','UNLOCK','Release Stock Lock');

    // Deduct Stock
    static readonly DEDUCT = new KLMallGoodsSkuInvChangeType('DEDUCT','DEDUCT','Deduct Stock');

    // Reset Stock
    static readonly RESET = new KLMallGoodsSkuInvChangeType('RESET','RESET','Reset Stock');

    // Out-of-Stock Registration
    static readonly LOSS = new KLMallGoodsSkuInvChangeType('LOSS','LOSS','Out-of-Stock Registration');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsSkuInvChangeType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('RESTOCK','RESTOCK','Restock'),
            new KLEnumCase<string>('DECREASE','DECREASE','Decrease Stock'),
            new KLEnumCase<string>('LOCK','LOCK','Lock Stock'),
            new KLEnumCase<string>('UNLOCK','UNLOCK','Release Stock Lock'),
            new KLEnumCase<string>('DEDUCT','DEDUCT','Deduct Stock'),
            new KLEnumCase<string>('RESET','RESET','Reset Stock'),
            new KLEnumCase<string>('LOSS','LOSS','Out-of-Stock Registration'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsSkuInvChangeType|null {
        switch (val) {
            case KLMallGoodsSkuInvChangeType.RESTOCK.value:return KLMallGoodsSkuInvChangeType.RESTOCK;
            case KLMallGoodsSkuInvChangeType.DECREASE.value:return KLMallGoodsSkuInvChangeType.DECREASE;
            case KLMallGoodsSkuInvChangeType.LOCK.value:return KLMallGoodsSkuInvChangeType.LOCK;
            case KLMallGoodsSkuInvChangeType.UNLOCK.value:return KLMallGoodsSkuInvChangeType.UNLOCK;
            case KLMallGoodsSkuInvChangeType.DEDUCT.value:return KLMallGoodsSkuInvChangeType.DEDUCT;
            case KLMallGoodsSkuInvChangeType.RESET.value:return KLMallGoodsSkuInvChangeType.RESET;
            case KLMallGoodsSkuInvChangeType.LOSS.value:return KLMallGoodsSkuInvChangeType.LOSS;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallGoodsSpuAuditStatus extends KLEnum<string>{

    // Awaiting trial
    static readonly NONE = new KLMallGoodsSpuAuditStatus('NONE','NONE','Awaiting trial');

    // Pending
    static readonly PENDING = new KLMallGoodsSpuAuditStatus('PENDING','PENDING','Pending');

    // Approved
    static readonly APPROVED = new KLMallGoodsSpuAuditStatus('APPROVED','APPROVED','Approved');

    // Rejected
    static readonly REJECTED = new KLMallGoodsSpuAuditStatus('REJECTED','REJECTED','Rejected');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsSpuAuditStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NONE','NONE','Awaiting trial'),
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('APPROVED','APPROVED','Approved'),
            new KLEnumCase<string>('REJECTED','REJECTED','Rejected'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsSpuAuditStatus|null {
        switch (val) {
            case KLMallGoodsSpuAuditStatus.NONE.value:return KLMallGoodsSpuAuditStatus.NONE;
            case KLMallGoodsSpuAuditStatus.PENDING.value:return KLMallGoodsSpuAuditStatus.PENDING;
            case KLMallGoodsSpuAuditStatus.APPROVED.value:return KLMallGoodsSpuAuditStatus.APPROVED;
            case KLMallGoodsSpuAuditStatus.REJECTED.value:return KLMallGoodsSpuAuditStatus.REJECTED;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallGoodsSpuStatus extends KLEnum<string>{

    // Unpublished
    static readonly UNPUBLISHED = new KLMallGoodsSpuStatus('UNPUBLISHED','UNPUBLISHED','Unpublished');

    // Normal
    static readonly NORMAL = new KLMallGoodsSpuStatus('NORMAL','NORMAL','Normal');

    // Shelved
    static readonly SHELVED = new KLMallGoodsSpuStatus('SHELVED','SHELVED','Shelved');

    // Banned
    static readonly BANNED = new KLMallGoodsSpuStatus('BANNED','BANNED','Banned');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsSpuStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNPUBLISHED','UNPUBLISHED','Unpublished'),
            new KLEnumCase<string>('NORMAL','NORMAL','Normal'),
            new KLEnumCase<string>('SHELVED','SHELVED','Shelved'),
            new KLEnumCase<string>('BANNED','BANNED','Banned'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsSpuStatus|null {
        switch (val) {
            case KLMallGoodsSpuStatus.UNPUBLISHED.value:return KLMallGoodsSpuStatus.UNPUBLISHED;
            case KLMallGoodsSpuStatus.NORMAL.value:return KLMallGoodsSpuStatus.NORMAL;
            case KLMallGoodsSpuStatus.SHELVED.value:return KLMallGoodsSpuStatus.SHELVED;
            case KLMallGoodsSpuStatus.BANNED.value:return KLMallGoodsSpuStatus.BANNED;
        }
        return null;
    }
}

/**
 * 商品库存筛选类型
*/
export class KLMallGoodsSpuStockFilterType extends KLEnum<string>{

    // All
    static readonly ALL = new KLMallGoodsSpuStockFilterType('ALL','All','All');

    // Normal
    static readonly NORMAL = new KLMallGoodsSpuStockFilterType('NORMAL','Normal','Normal');

    // Out of stock
    static readonly LOW = new KLMallGoodsSpuStockFilterType('LOW','Low','Out of stock');

    // Inventory warning
    static readonly WARNING = new KLMallGoodsSpuStockFilterType('WARNING','Warning','Inventory warning');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsSpuStockFilterType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','All','All'),
            new KLEnumCase<string>('NORMAL','Normal','Normal'),
            new KLEnumCase<string>('LOW','Low','Out of stock'),
            new KLEnumCase<string>('WARNING','Warning','Inventory warning'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsSpuStockFilterType|null {
        switch (val) {
            case KLMallGoodsSpuStockFilterType.ALL.value:return KLMallGoodsSpuStockFilterType.ALL;
            case KLMallGoodsSpuStockFilterType.NORMAL.value:return KLMallGoodsSpuStockFilterType.NORMAL;
            case KLMallGoodsSpuStockFilterType.LOW.value:return KLMallGoodsSpuStockFilterType.LOW;
            case KLMallGoodsSpuStockFilterType.WARNING.value:return KLMallGoodsSpuStockFilterType.WARNING;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMallGoodsTagStatus extends KLEnum<string>{

    // 上线
    static readonly ONLINE = new KLMallGoodsTagStatus('ONLINE','ONLINE','上线');

    // 下线
    static readonly OFFLINE = new KLMallGoodsTagStatus('OFFLINE','OFFLINE','下线');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallGoodsTagStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','上线'),
            new KLEnumCase<string>('OFFLINE','OFFLINE','下线'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallGoodsTagStatus|null {
        switch (val) {
            case KLMallGoodsTagStatus.ONLINE.value:return KLMallGoodsTagStatus.ONLINE;
            case KLMallGoodsTagStatus.OFFLINE.value:return KLMallGoodsTagStatus.OFFLINE;
        }
        return null;
    }
}

/**
 * 订单操作记录操作类型
*/
export class KLMallOrderActionActionType extends KLEnum<string>{

    // Order
    static readonly ORDER = new KLMallOrderActionActionType('ORDER','ORDER','Order');

    // 配送
    static readonly DELIVERY = new KLMallOrderActionActionType('DELIVERY','DELIVERY','配送');

    // 售后
    static readonly AFTER_SALE = new KLMallOrderActionActionType('AFTER_SALE','AFTER_SALE','售后');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderActionActionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ORDER','ORDER','Order'),
            new KLEnumCase<string>('DELIVERY','DELIVERY','配送'),
            new KLEnumCase<string>('AFTER_SALE','AFTER_SALE','售后'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderActionActionType|null {
        switch (val) {
            case KLMallOrderActionActionType.ORDER.value:return KLMallOrderActionActionType.ORDER;
            case KLMallOrderActionActionType.DELIVERY.value:return KLMallOrderActionActionType.DELIVERY;
            case KLMallOrderActionActionType.AFTER_SALE.value:return KLMallOrderActionActionType.AFTER_SALE;
        }
        return null;
    }
}

/**
 * 订单操作状态枚举
*/
export class KLMallOrderActionOrderStatus extends KLEnum<string>{

    // PENDING_PAYMENT
    static readonly PENDING_PAYMENT = new KLMallOrderActionOrderStatus('PENDING_PAYMENT','PENDING_PAYMENT','PENDING_PAYMENT');

    // PAID
    static readonly PAID = new KLMallOrderActionOrderStatus('PAID','PAID','PAID');

    // AWAITING_STOCK
    static readonly AWAITING_STOCK = new KLMallOrderActionOrderStatus('AWAITING_STOCK','AWAITING_STOCK','AWAITING_STOCK');

    // SHIPPED
    static readonly SHIPPED = new KLMallOrderActionOrderStatus('SHIPPED','SHIPPED','SHIPPED');

    // COMPLETED
    static readonly COMPLETED = new KLMallOrderActionOrderStatus('COMPLETED','COMPLETED','COMPLETED');

    // CANCELLED
    static readonly CANCELLED = new KLMallOrderActionOrderStatus('CANCELLED','CANCELLED','CANCELLED');

    // REFUNDING
    static readonly REFUNDING = new KLMallOrderActionOrderStatus('REFUNDING','REFUNDING','REFUNDING');

    // REFUNDED
    static readonly REFUNDED = new KLMallOrderActionOrderStatus('REFUNDED','REFUNDED','REFUNDED');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderActionOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING_PAYMENT','PENDING_PAYMENT','PENDING_PAYMENT'),
            new KLEnumCase<string>('PAID','PAID','PAID'),
            new KLEnumCase<string>('AWAITING_STOCK','AWAITING_STOCK','AWAITING_STOCK'),
            new KLEnumCase<string>('SHIPPED','SHIPPED','SHIPPED'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','COMPLETED'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','CANCELLED'),
            new KLEnumCase<string>('REFUNDING','REFUNDING','REFUNDING'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','REFUNDED'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderActionOrderStatus|null {
        switch (val) {
            case KLMallOrderActionOrderStatus.PENDING_PAYMENT.value:return KLMallOrderActionOrderStatus.PENDING_PAYMENT;
            case KLMallOrderActionOrderStatus.PAID.value:return KLMallOrderActionOrderStatus.PAID;
            case KLMallOrderActionOrderStatus.AWAITING_STOCK.value:return KLMallOrderActionOrderStatus.AWAITING_STOCK;
            case KLMallOrderActionOrderStatus.SHIPPED.value:return KLMallOrderActionOrderStatus.SHIPPED;
            case KLMallOrderActionOrderStatus.COMPLETED.value:return KLMallOrderActionOrderStatus.COMPLETED;
            case KLMallOrderActionOrderStatus.CANCELLED.value:return KLMallOrderActionOrderStatus.CANCELLED;
            case KLMallOrderActionOrderStatus.REFUNDING.value:return KLMallOrderActionOrderStatus.REFUNDING;
            case KLMallOrderActionOrderStatus.REFUNDED.value:return KLMallOrderActionOrderStatus.REFUNDED;
        }
        return null;
    }
}

/**
 * 订单操作记录用户类型
*/
export class KLMallOrderActionUserType extends KLEnum<string>{

    // 用户
    static readonly USER = new KLMallOrderActionUserType('USER','USER','用户');

    // 管理员
    static readonly ADMIN = new KLMallOrderActionUserType('ADMIN','ADMIN','管理员');

    // 商家
    static readonly MERCHANT = new KLMallOrderActionUserType('MERCHANT','MERCHANT','商家');

    // 商家子账号
    static readonly MERCHANT_SUB_ACCOUNT = new KLMallOrderActionUserType('MERCHANT_SUB_ACCOUNT','MERCHANT_SUB_ACCOUNT','商家子账号');

    // 系统
    static readonly SYSTEM = new KLMallOrderActionUserType('SYSTEM','SYSTEM','系统');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderActionUserType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER','USER','用户'),
            new KLEnumCase<string>('ADMIN','ADMIN','管理员'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','商家'),
            new KLEnumCase<string>('MERCHANT_SUB_ACCOUNT','MERCHANT_SUB_ACCOUNT','商家子账号'),
            new KLEnumCase<string>('SYSTEM','SYSTEM','系统'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderActionUserType|null {
        switch (val) {
            case KLMallOrderActionUserType.USER.value:return KLMallOrderActionUserType.USER;
            case KLMallOrderActionUserType.ADMIN.value:return KLMallOrderActionUserType.ADMIN;
            case KLMallOrderActionUserType.MERCHANT.value:return KLMallOrderActionUserType.MERCHANT;
            case KLMallOrderActionUserType.MERCHANT_SUB_ACCOUNT.value:return KLMallOrderActionUserType.MERCHANT_SUB_ACCOUNT;
            case KLMallOrderActionUserType.SYSTEM.value:return KLMallOrderActionUserType.SYSTEM;
        }
        return null;
    }
}

/**
 * 售后状态状态
*/
export class KLMallOrderAfterSaleStatus extends KLEnum<string>{

    // 未申请取消
    static readonly NOT_APPLIED = new KLMallOrderAfterSaleStatus('NOT_APPLIED','NOT_APPLIED','未申请取消');

    // 已提交申请
    static readonly APPLYING = new KLMallOrderAfterSaleStatus('APPLYING','APPLYING','已提交申请');

    // 处理中
    static readonly PROCESSING = new KLMallOrderAfterSaleStatus('PROCESSING','PROCESSING','处理中');

    // 已驳回
    static readonly REJECTED = new KLMallOrderAfterSaleStatus('REJECTED','REJECTED','已驳回');

    // 已完成
    static readonly COMPLETED = new KLMallOrderAfterSaleStatus('COMPLETED','COMPLETED','已完成');

    // 已取消
    static readonly CANCELLED = new KLMallOrderAfterSaleStatus('CANCELLED','CANCELLED','已取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderAfterSaleStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_APPLIED','NOT_APPLIED','未申请取消'),
            new KLEnumCase<string>('APPLYING','APPLYING','已提交申请'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','处理中'),
            new KLEnumCase<string>('REJECTED','REJECTED','已驳回'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','已完成'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','已取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderAfterSaleStatus|null {
        switch (val) {
            case KLMallOrderAfterSaleStatus.NOT_APPLIED.value:return KLMallOrderAfterSaleStatus.NOT_APPLIED;
            case KLMallOrderAfterSaleStatus.APPLYING.value:return KLMallOrderAfterSaleStatus.APPLYING;
            case KLMallOrderAfterSaleStatus.PROCESSING.value:return KLMallOrderAfterSaleStatus.PROCESSING;
            case KLMallOrderAfterSaleStatus.REJECTED.value:return KLMallOrderAfterSaleStatus.REJECTED;
            case KLMallOrderAfterSaleStatus.COMPLETED.value:return KLMallOrderAfterSaleStatus.COMPLETED;
            case KLMallOrderAfterSaleStatus.CANCELLED.value:return KLMallOrderAfterSaleStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 订单取消申请人类型
*/
export class KLMallOrderCancelApplyApplicantType extends KLEnum<string>{

    // User
    static readonly USER = new KLMallOrderCancelApplyApplicantType('USER','USER','User');

    // Merchant
    static readonly MERCHANT = new KLMallOrderCancelApplyApplicantType('MERCHANT','MERCHANT','Merchant');

    // System
    static readonly SYSTEM = new KLMallOrderCancelApplyApplicantType('SYSTEM','SYSTEM','System');

    // Admin
    static readonly ADMIN = new KLMallOrderCancelApplyApplicantType('ADMIN','ADMIN','Admin');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCancelApplyApplicantType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER','USER','User'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','Merchant'),
            new KLEnumCase<string>('SYSTEM','SYSTEM','System'),
            new KLEnumCase<string>('ADMIN','ADMIN','Admin'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCancelApplyApplicantType|null {
        switch (val) {
            case KLMallOrderCancelApplyApplicantType.USER.value:return KLMallOrderCancelApplyApplicantType.USER;
            case KLMallOrderCancelApplyApplicantType.MERCHANT.value:return KLMallOrderCancelApplyApplicantType.MERCHANT;
            case KLMallOrderCancelApplyApplicantType.SYSTEM.value:return KLMallOrderCancelApplyApplicantType.SYSTEM;
            case KLMallOrderCancelApplyApplicantType.ADMIN.value:return KLMallOrderCancelApplyApplicantType.ADMIN;
        }
        return null;
    }
}

/**
 * 订单取消申请审核状态
*/
export class KLMallOrderCancelApplyAuditStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING = new KLMallOrderCancelApplyAuditStatus('PENDING','PENDING','Pending');

    // Approved
    static readonly APPROVED = new KLMallOrderCancelApplyAuditStatus('APPROVED','APPROVED','Approved');

    // Rejected
    static readonly REJECTED = new KLMallOrderCancelApplyAuditStatus('REJECTED','REJECTED','Rejected');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCancelApplyAuditStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('APPROVED','APPROVED','Approved'),
            new KLEnumCase<string>('REJECTED','REJECTED','Rejected'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCancelApplyAuditStatus|null {
        switch (val) {
            case KLMallOrderCancelApplyAuditStatus.PENDING.value:return KLMallOrderCancelApplyAuditStatus.PENDING;
            case KLMallOrderCancelApplyAuditStatus.APPROVED.value:return KLMallOrderCancelApplyAuditStatus.APPROVED;
            case KLMallOrderCancelApplyAuditStatus.REJECTED.value:return KLMallOrderCancelApplyAuditStatus.REJECTED;
        }
        return null;
    }
}

/**
 * 订单取消原因
*/
export class KLMallOrderCancelReason extends KLEnum<string>{

    // Do not want it anymore
    static readonly DONT_WANT = new KLMallOrderCancelReason('DONT_WANT','DONT_WANT','Do not want it anymore');

    // Out of stock
    static readonly OUT_OF_STOCK = new KLMallOrderCancelReason('OUT_OF_STOCK','OUT_OF_STOCK','Out of stock');

    // Unable to deliver
    static readonly UNABLE_DELIVER = new KLMallOrderCancelReason('UNABLE_DELIVER','UNABLE_DELIVER','Unable to deliver');

    // Incorrect order information
    static readonly INCORRECT_INFO = new KLMallOrderCancelReason('INCORRECT_INFO','INCORRECT_INFO','Incorrect order information');

    // Other reasons
    static readonly OTHER = new KLMallOrderCancelReason('OTHER','OTHER','Other reasons');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCancelReason.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DONT_WANT','DONT_WANT','Do not want it anymore'),
            new KLEnumCase<string>('OUT_OF_STOCK','OUT_OF_STOCK','Out of stock'),
            new KLEnumCase<string>('UNABLE_DELIVER','UNABLE_DELIVER','Unable to deliver'),
            new KLEnumCase<string>('INCORRECT_INFO','INCORRECT_INFO','Incorrect order information'),
            new KLEnumCase<string>('OTHER','OTHER','Other reasons'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCancelReason|null {
        switch (val) {
            case KLMallOrderCancelReason.DONT_WANT.value:return KLMallOrderCancelReason.DONT_WANT;
            case KLMallOrderCancelReason.OUT_OF_STOCK.value:return KLMallOrderCancelReason.OUT_OF_STOCK;
            case KLMallOrderCancelReason.UNABLE_DELIVER.value:return KLMallOrderCancelReason.UNABLE_DELIVER;
            case KLMallOrderCancelReason.INCORRECT_INFO.value:return KLMallOrderCancelReason.INCORRECT_INFO;
            case KLMallOrderCancelReason.OTHER.value:return KLMallOrderCancelReason.OTHER;
        }
        return null;
    }
}

/**
 * 订单取消状态
*/
export class KLMallOrderCancelStatus extends KLEnum<string>{

    // Not applied
    static readonly NOT_APPLIED = new KLMallOrderCancelStatus('NOT_APPLIED','NOT_APPLIED','Not applied');

    // Applying
    static readonly APPLYING = new KLMallOrderCancelStatus('APPLYING','APPLYING','Applying');

    // Auditing
    static readonly AUDITING = new KLMallOrderCancelStatus('AUDITING','AUDITING','Auditing');

    // Passed
    static readonly AUDIT_PASSED = new KLMallOrderCancelStatus('AUDIT_PASSED','AUDIT_PASSED','Passed');

    // Rejected
    static readonly AUDIT_REJECTED = new KLMallOrderCancelStatus('AUDIT_REJECTED','AUDIT_REJECTED','Rejected');

    // Cancelled
    static readonly CANCELLED = new KLMallOrderCancelStatus('CANCELLED','CANCELLED','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCancelStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_APPLIED','NOT_APPLIED','Not applied'),
            new KLEnumCase<string>('APPLYING','APPLYING','Applying'),
            new KLEnumCase<string>('AUDITING','AUDITING','Auditing'),
            new KLEnumCase<string>('AUDIT_PASSED','AUDIT_PASSED','Passed'),
            new KLEnumCase<string>('AUDIT_REJECTED','AUDIT_REJECTED','Rejected'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCancelStatus|null {
        switch (val) {
            case KLMallOrderCancelStatus.NOT_APPLIED.value:return KLMallOrderCancelStatus.NOT_APPLIED;
            case KLMallOrderCancelStatus.APPLYING.value:return KLMallOrderCancelStatus.APPLYING;
            case KLMallOrderCancelStatus.AUDITING.value:return KLMallOrderCancelStatus.AUDITING;
            case KLMallOrderCancelStatus.AUDIT_PASSED.value:return KLMallOrderCancelStatus.AUDIT_PASSED;
            case KLMallOrderCancelStatus.AUDIT_REJECTED.value:return KLMallOrderCancelStatus.AUDIT_REJECTED;
            case KLMallOrderCancelStatus.CANCELLED.value:return KLMallOrderCancelStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 客户端操作系统
*/
export class KLMallOrderClientOs extends KLEnum<string>{

    // ANDROID
    static readonly ANDROID = new KLMallOrderClientOs('ANDROID','ANDROID','ANDROID');

    // IOS
    static readonly IOS = new KLMallOrderClientOs('IOS','IOS','IOS');

    // HARMONY
    static readonly HARMONY = new KLMallOrderClientOs('HARMONY','HARMONY','HARMONY');

    // WINDOWS
    static readonly WINDOWS = new KLMallOrderClientOs('WINDOWS','WINDOWS','WINDOWS');

    // MACOS
    static readonly MACOS = new KLMallOrderClientOs('MACOS','MACOS','MACOS');

    // LINUX
    static readonly LINUX = new KLMallOrderClientOs('LINUX','LINUX','LINUX');

    // UNKNOWN
    static readonly UNKNOWN = new KLMallOrderClientOs('UNKNOWN','UNKNOWN','UNKNOWN');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderClientOs.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ANDROID','ANDROID','ANDROID'),
            new KLEnumCase<string>('IOS','IOS','IOS'),
            new KLEnumCase<string>('HARMONY','HARMONY','HARMONY'),
            new KLEnumCase<string>('WINDOWS','WINDOWS','WINDOWS'),
            new KLEnumCase<string>('MACOS','MACOS','MACOS'),
            new KLEnumCase<string>('LINUX','LINUX','LINUX'),
            new KLEnumCase<string>('UNKNOWN','UNKNOWN','UNKNOWN'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderClientOs|null {
        switch (val) {
            case KLMallOrderClientOs.ANDROID.value:return KLMallOrderClientOs.ANDROID;
            case KLMallOrderClientOs.IOS.value:return KLMallOrderClientOs.IOS;
            case KLMallOrderClientOs.HARMONY.value:return KLMallOrderClientOs.HARMONY;
            case KLMallOrderClientOs.WINDOWS.value:return KLMallOrderClientOs.WINDOWS;
            case KLMallOrderClientOs.MACOS.value:return KLMallOrderClientOs.MACOS;
            case KLMallOrderClientOs.LINUX.value:return KLMallOrderClientOs.LINUX;
            case KLMallOrderClientOs.UNKNOWN.value:return KLMallOrderClientOs.UNKNOWN;
        }
        return null;
    }
}

/**
 * 商城订单评价显示的配送方式
*/
export class KLMallOrderCommentDeliveryType extends KLEnum<string>{

    // Platform Delivery
    static readonly PLATFORM = new KLMallOrderCommentDeliveryType('PLATFORM','PLATFORM','Platform Delivery');

    // Merchant Delivery
    static readonly MERCHANT = new KLMallOrderCommentDeliveryType('MERCHANT','MERCHANT','Merchant Delivery');

    // 3rd Party Delivery
    static readonly THIRD = new KLMallOrderCommentDeliveryType('THIRD','THIRD','3rd Party Delivery');

    // Self Pickup
    static readonly SELF_PICKUP = new KLMallOrderCommentDeliveryType('SELF_PICKUP','SELF_PICKUP','Self Pickup');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCommentDeliveryType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PLATFORM','PLATFORM','Platform Delivery'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','Merchant Delivery'),
            new KLEnumCase<string>('THIRD','THIRD','3rd Party Delivery'),
            new KLEnumCase<string>('SELF_PICKUP','SELF_PICKUP','Self Pickup'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCommentDeliveryType|null {
        switch (val) {
            case KLMallOrderCommentDeliveryType.PLATFORM.value:return KLMallOrderCommentDeliveryType.PLATFORM;
            case KLMallOrderCommentDeliveryType.MERCHANT.value:return KLMallOrderCommentDeliveryType.MERCHANT;
            case KLMallOrderCommentDeliveryType.THIRD.value:return KLMallOrderCommentDeliveryType.THIRD;
            case KLMallOrderCommentDeliveryType.SELF_PICKUP.value:return KLMallOrderCommentDeliveryType.SELF_PICKUP;
        }
        return null;
    }
}

/**
 * 订单评价标签分类
*/
export class KLMallOrderCommentTagCategory extends KLEnum<string>{

    // 好评
    static readonly POSITIVE = new KLMallOrderCommentTagCategory('POSITIVE','POSITIVE','好评');

    // 差评
    static readonly NEGATIVE = new KLMallOrderCommentTagCategory('NEGATIVE','NEGATIVE','差评');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCommentTagCategory.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('POSITIVE','POSITIVE','好评'),
            new KLEnumCase<string>('NEGATIVE','NEGATIVE','差评'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCommentTagCategory|null {
        switch (val) {
            case KLMallOrderCommentTagCategory.POSITIVE.value:return KLMallOrderCommentTagCategory.POSITIVE;
            case KLMallOrderCommentTagCategory.NEGATIVE.value:return KLMallOrderCommentTagCategory.NEGATIVE;
        }
        return null;
    }
}

/**
 * 订单评价标签类型
*/
export class KLMallOrderCommentTagType extends KLEnum<string>{

    // 骑手
    static readonly RIDER = new KLMallOrderCommentTagType('RIDER','RIDER','骑手');

    // 商品
    static readonly PRODUCT = new KLMallOrderCommentTagType('PRODUCT','PRODUCT','商品');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCommentTagType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('RIDER','RIDER','骑手'),
            new KLEnumCase<string>('PRODUCT','PRODUCT','商品'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCommentTagType|null {
        switch (val) {
            case KLMallOrderCommentTagType.RIDER.value:return KLMallOrderCommentTagType.RIDER;
            case KLMallOrderCommentTagType.PRODUCT.value:return KLMallOrderCommentTagType.PRODUCT;
        }
        return null;
    }
}

/**
 * 订单评价类型
*/
export class KLMallOrderCommentType extends KLEnum<string>{

    // 骑手评价
    static readonly RIDER = new KLMallOrderCommentType('RIDER','RIDER','骑手评价');

    // 商品评价
    static readonly PRODUCT = new KLMallOrderCommentType('PRODUCT','PRODUCT','商品评价');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderCommentType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('RIDER','RIDER','骑手评价'),
            new KLEnumCase<string>('PRODUCT','PRODUCT','商品评价'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderCommentType|null {
        switch (val) {
            case KLMallOrderCommentType.RIDER.value:return KLMallOrderCommentType.RIDER;
            case KLMallOrderCommentType.PRODUCT.value:return KLMallOrderCommentType.PRODUCT;
        }
        return null;
    }
}

/**
 * 配送方式
*/
export class KLMallOrderDeliveryType extends KLEnum<string>{

    // Platform
    static readonly PLATFORM = new KLMallOrderDeliveryType('PLATFORM','PLATFORM','Platform');

    // Merchant
    static readonly MERCHANT = new KLMallOrderDeliveryType('MERCHANT','MERCHANT','Merchant');

    // 3rd Party
    static readonly THIRD = new KLMallOrderDeliveryType('THIRD','THIRD','3rd Party');

    // Self Pickup
    static readonly SELF_PICKUP = new KLMallOrderDeliveryType('SELF_PICKUP','SELF_PICKUP','Self Pickup');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderDeliveryType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PLATFORM','PLATFORM','Platform'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','Merchant'),
            new KLEnumCase<string>('THIRD','THIRD','3rd Party'),
            new KLEnumCase<string>('SELF_PICKUP','SELF_PICKUP','Self Pickup'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderDeliveryType|null {
        switch (val) {
            case KLMallOrderDeliveryType.PLATFORM.value:return KLMallOrderDeliveryType.PLATFORM;
            case KLMallOrderDeliveryType.MERCHANT.value:return KLMallOrderDeliveryType.MERCHANT;
            case KLMallOrderDeliveryType.THIRD.value:return KLMallOrderDeliveryType.THIRD;
            case KLMallOrderDeliveryType.SELF_PICKUP.value:return KLMallOrderDeliveryType.SELF_PICKUP;
        }
        return null;
    }
}

/**
 * 订单商品已退款范围
*/
export class KLMallOrderItemReturnedScope extends KLEnum<string>{

    // None
    static readonly NONE = new KLMallOrderItemReturnedScope('NONE','NONE','None');

    // Partial
    static readonly PARTIAL = new KLMallOrderItemReturnedScope('PARTIAL','PARTIAL','Partial');

    // Full
    static readonly FULL = new KLMallOrderItemReturnedScope('FULL','FULL','Full');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderItemReturnedScope.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NONE','NONE','None'),
            new KLEnumCase<string>('PARTIAL','PARTIAL','Partial'),
            new KLEnumCase<string>('FULL','FULL','Full'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderItemReturnedScope|null {
        switch (val) {
            case KLMallOrderItemReturnedScope.NONE.value:return KLMallOrderItemReturnedScope.NONE;
            case KLMallOrderItemReturnedScope.PARTIAL.value:return KLMallOrderItemReturnedScope.PARTIAL;
            case KLMallOrderItemReturnedScope.FULL.value:return KLMallOrderItemReturnedScope.FULL;
        }
        return null;
    }
}

/**
 * 订单通知事件类型
*/
export class KLMallOrderNotificationEventType extends KLEnum<string>{

    // 订单待支付通知
    static readonly PENDING = new KLMallOrderNotificationEventType('PENDING','PENDING','订单待支付通知');

    // 商品缺货
    static readonly PRODUCT_OUT_OF_STOCK = new KLMallOrderNotificationEventType('PRODUCT_OUT_OF_STOCK','PRODUCT_OUT_OF_STOCK','商品缺货');

    // 售后提交
    static readonly AFTER_SALE_SUBMITTED = new KLMallOrderNotificationEventType('AFTER_SALE_SUBMITTED','AFTER_SALE_SUBMITTED','售后提交');

    // 售后审核通过
    static readonly AFTER_SALE_APPROVED = new KLMallOrderNotificationEventType('AFTER_SALE_APPROVED','AFTER_SALE_APPROVED','售后审核通过');

    // 售后审核拒绝
    static readonly AFTER_SALE_REJECTED = new KLMallOrderNotificationEventType('AFTER_SALE_REJECTED','AFTER_SALE_REJECTED','售后审核拒绝');

    // 订单未支付超时取消
    static readonly ORDER_PAY_EXPIRE_CANCELLED = new KLMallOrderNotificationEventType('ORDER_PAY_EXPIRE_CANCELLED','ORDER_PAY_EXPIRE_CANCELLED','订单未支付超时取消');

    // 订单超出原有的配送时间
    static readonly ORDER_DELIVERY_TIME_EXPIRED = new KLMallOrderNotificationEventType('ORDER_DELIVERY_TIME_EXPIRED','ORDER_DELIVERY_TIME_EXPIRED','订单超出原有的配送时间');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderNotificationEventType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','订单待支付通知'),
            new KLEnumCase<string>('PRODUCT_OUT_OF_STOCK','PRODUCT_OUT_OF_STOCK','商品缺货'),
            new KLEnumCase<string>('AFTER_SALE_SUBMITTED','AFTER_SALE_SUBMITTED','售后提交'),
            new KLEnumCase<string>('AFTER_SALE_APPROVED','AFTER_SALE_APPROVED','售后审核通过'),
            new KLEnumCase<string>('AFTER_SALE_REJECTED','AFTER_SALE_REJECTED','售后审核拒绝'),
            new KLEnumCase<string>('ORDER_PAY_EXPIRE_CANCELLED','ORDER_PAY_EXPIRE_CANCELLED','订单未支付超时取消'),
            new KLEnumCase<string>('ORDER_DELIVERY_TIME_EXPIRED','ORDER_DELIVERY_TIME_EXPIRED','订单超出原有的配送时间'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderNotificationEventType|null {
        switch (val) {
            case KLMallOrderNotificationEventType.PENDING.value:return KLMallOrderNotificationEventType.PENDING;
            case KLMallOrderNotificationEventType.PRODUCT_OUT_OF_STOCK.value:return KLMallOrderNotificationEventType.PRODUCT_OUT_OF_STOCK;
            case KLMallOrderNotificationEventType.AFTER_SALE_SUBMITTED.value:return KLMallOrderNotificationEventType.AFTER_SALE_SUBMITTED;
            case KLMallOrderNotificationEventType.AFTER_SALE_APPROVED.value:return KLMallOrderNotificationEventType.AFTER_SALE_APPROVED;
            case KLMallOrderNotificationEventType.AFTER_SALE_REJECTED.value:return KLMallOrderNotificationEventType.AFTER_SALE_REJECTED;
            case KLMallOrderNotificationEventType.ORDER_PAY_EXPIRE_CANCELLED.value:return KLMallOrderNotificationEventType.ORDER_PAY_EXPIRE_CANCELLED;
            case KLMallOrderNotificationEventType.ORDER_DELIVERY_TIME_EXPIRED.value:return KLMallOrderNotificationEventType.ORDER_DELIVERY_TIME_EXPIRED;
        }
        return null;
    }
}

/**
 * 订单已支付取消操作类型
*/
export class KLMallOrderPaidCancelledOperationType extends KLEnum<string>{

    // 用户取消
    static readonly USER_CANCELLED = new KLMallOrderPaidCancelledOperationType('USER_CANCELLED','USER_CANCELLED','用户取消');

    // 管理员取消
    static readonly ADMIN_CANCELLED = new KLMallOrderPaidCancelledOperationType('ADMIN_CANCELLED','ADMIN_CANCELLED','管理员取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPaidCancelledOperationType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER_CANCELLED','USER_CANCELLED','用户取消'),
            new KLEnumCase<string>('ADMIN_CANCELLED','ADMIN_CANCELLED','管理员取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPaidCancelledOperationType|null {
        switch (val) {
            case KLMallOrderPaidCancelledOperationType.USER_CANCELLED.value:return KLMallOrderPaidCancelledOperationType.USER_CANCELLED;
            case KLMallOrderPaidCancelledOperationType.ADMIN_CANCELLED.value:return KLMallOrderPaidCancelledOperationType.ADMIN_CANCELLED;
        }
        return null;
    }
}

/**
 * 商城订单支付方式
*/
export class KLMallOrderPayMethod extends KLEnum<string>{

    // Online
    static readonly ONLINE = new KLMallOrderPayMethod('ONLINE','ONLINE','Online');

    // COD
    static readonly COD = new KLMallOrderPayMethod('COD','COD','COD');

    // Balance
    static readonly BALANCE = new KLMallOrderPayMethod('BALANCE','BALANCE','Balance');

    // Mixed
    static readonly MIXED = new KLMallOrderPayMethod('MIXED','MIXED','Mixed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPayMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','Online'),
            new KLEnumCase<string>('COD','COD','COD'),
            new KLEnumCase<string>('BALANCE','BALANCE','Balance'),
            new KLEnumCase<string>('MIXED','MIXED','Mixed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPayMethod|null {
        switch (val) {
            case KLMallOrderPayMethod.ONLINE.value:return KLMallOrderPayMethod.ONLINE;
            case KLMallOrderPayMethod.COD.value:return KLMallOrderPayMethod.COD;
            case KLMallOrderPayMethod.BALANCE.value:return KLMallOrderPayMethod.BALANCE;
            case KLMallOrderPayMethod.MIXED.value:return KLMallOrderPayMethod.MIXED;
        }
        return null;
    }
}

/**
 * 订单支付状态
*/
export class KLMallOrderPayStatus extends KLEnum<string>{

    // 未支付
    static readonly NOT_PAID = new KLMallOrderPayStatus('NOT_PAID','NOT_PAID','未支付');

    // 已支付
    static readonly PAID = new KLMallOrderPayStatus('PAID','PAID','已支付');

    // 部分退款
    static readonly PARTIALLY_REFUNDED = new KLMallOrderPayStatus('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','部分退款');

    // 已退款
    static readonly REFUNDED = new KLMallOrderPayStatus('REFUNDED','REFUNDED','已退款');

    // 已取消
    static readonly CANCELLED = new KLMallOrderPayStatus('CANCELLED','CANCELLED','已取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPayStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_PAID','NOT_PAID','未支付'),
            new KLEnumCase<string>('PAID','PAID','已支付'),
            new KLEnumCase<string>('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','部分退款'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','已退款'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','已取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPayStatus|null {
        switch (val) {
            case KLMallOrderPayStatus.NOT_PAID.value:return KLMallOrderPayStatus.NOT_PAID;
            case KLMallOrderPayStatus.PAID.value:return KLMallOrderPayStatus.PAID;
            case KLMallOrderPayStatus.PARTIALLY_REFUNDED.value:return KLMallOrderPayStatus.PARTIALLY_REFUNDED;
            case KLMallOrderPayStatus.REFUNDED.value:return KLMallOrderPayStatus.REFUNDED;
            case KLMallOrderPayStatus.CANCELLED.value:return KLMallOrderPayStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 取件码显示模式
*/
export class KLMallOrderPickupCodeVisibility extends KLEnum<string>{

    // Module
    static readonly MODULE = new KLMallOrderPickupCodeVisibility('MODULE','MODULE','Module');

    // Hidden
    static readonly HIDDEN = new KLMallOrderPickupCodeVisibility('HIDDEN','HIDDEN','Hidden');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPickupCodeVisibility.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MODULE','MODULE','Module'),
            new KLEnumCase<string>('HIDDEN','HIDDEN','Hidden'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPickupCodeVisibility|null {
        switch (val) {
            case KLMallOrderPickupCodeVisibility.MODULE.value:return KLMallOrderPickupCodeVisibility.MODULE;
            case KLMallOrderPickupCodeVisibility.HIDDEN.value:return KLMallOrderPickupCodeVisibility.HIDDEN;
        }
        return null;
    }
}

/**
 * 打印机类型
*/
export class KLMallOrderPrinterType extends KLEnum<string>{

    // 飞鹅打印机
    static readonly FEI_E = new KLMallOrderPrinterType('FEI_E','FEI_E','飞鹅打印机');

    // 易联云打印机
    static readonly YLY = new KLMallOrderPrinterType('YLY','YLY','易联云打印机');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPrinterType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FEI_E','FEI_E','飞鹅打印机'),
            new KLEnumCase<string>('YLY','YLY','易联云打印机'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPrinterType|null {
        switch (val) {
            case KLMallOrderPrinterType.FEI_E.value:return KLMallOrderPrinterType.FEI_E;
            case KLMallOrderPrinterType.YLY.value:return KLMallOrderPrinterType.YLY;
        }
        return null;
    }
}

/**
 * 打印记录状态
*/
export class KLMallOrderPrintRecordStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING = new KLMallOrderPrintRecordStatus('PENDING','PENDING','Pending');

    // Done
    static readonly DONE = new KLMallOrderPrintRecordStatus('DONE','DONE','Done');

    // Fail
    static readonly FAIL = new KLMallOrderPrintRecordStatus('FAIL','FAIL','Fail');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPrintRecordStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('DONE','DONE','Done'),
            new KLEnumCase<string>('FAIL','FAIL','Fail'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPrintRecordStatus|null {
        switch (val) {
            case KLMallOrderPrintRecordStatus.PENDING.value:return KLMallOrderPrintRecordStatus.PENDING;
            case KLMallOrderPrintRecordStatus.DONE.value:return KLMallOrderPrintRecordStatus.DONE;
            case KLMallOrderPrintRecordStatus.FAIL.value:return KLMallOrderPrintRecordStatus.FAIL;
        }
        return null;
    }
}

/**
 * 订单打印类型
*/
export class KLMallOrderPrintType extends KLEnum<string>{

    // 首次小票
    static readonly FIRST = new KLMallOrderPrintType('FIRST','FIRST','首次小票');

    // COD转余额支付
    static readonly UPDATE_PAY_BALANCE = new KLMallOrderPrintType('UPDATE_PAY_BALANCE','UPDATE_PAY_BALANCE','COD转余额支付');

    // COD转在线支付
    static readonly UPDATE_PAY_ONLINE = new KLMallOrderPrintType('UPDATE_PAY_ONLINE','UPDATE_PAY_ONLINE','COD转在线支付');

    // 取消小票
    static readonly CANCEL = new KLMallOrderPrintType('CANCEL','CANCEL','取消小票');

    // 缺货调整
    static readonly UPDATE_STOCKOUT = new KLMallOrderPrintType('UPDATE_STOCKOUT','UPDATE_STOCK','缺货调整');

    // 预订单首次
    static readonly PREORDER_FIRST = new KLMallOrderPrintType('PREORDER_FIRST','PRE_FIRST','预订单首次');

    // 预订单提醒
    static readonly PREORDER_REMINDER = new KLMallOrderPrintType('PREORDER_REMINDER','PRE_REMIND','预订单提醒');

    // 预订单时间变更
    static readonly PREORDER_TIME_CHANGE = new KLMallOrderPrintType('PREORDER_TIME_CHANGE','PRE_TIME','预订单时间变更');

    // 手动打印
    static readonly MANUAL_PRINT = new KLMallOrderPrintType('MANUAL_PRINT','MANUAL_PRINT','手动打印');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderPrintType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FIRST','FIRST','首次小票'),
            new KLEnumCase<string>('UPDATE_PAY_BALANCE','UPDATE_PAY_BALANCE','COD转余额支付'),
            new KLEnumCase<string>('UPDATE_PAY_ONLINE','UPDATE_PAY_ONLINE','COD转在线支付'),
            new KLEnumCase<string>('CANCEL','CANCEL','取消小票'),
            new KLEnumCase<string>('UPDATE_STOCKOUT','UPDATE_STOCK','缺货调整'),
            new KLEnumCase<string>('PREORDER_FIRST','PRE_FIRST','预订单首次'),
            new KLEnumCase<string>('PREORDER_REMINDER','PRE_REMIND','预订单提醒'),
            new KLEnumCase<string>('PREORDER_TIME_CHANGE','PRE_TIME','预订单时间变更'),
            new KLEnumCase<string>('MANUAL_PRINT','MANUAL_PRINT','手动打印'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderPrintType|null {
        switch (val) {
            case KLMallOrderPrintType.FIRST.value:return KLMallOrderPrintType.FIRST;
            case KLMallOrderPrintType.UPDATE_PAY_BALANCE.value:return KLMallOrderPrintType.UPDATE_PAY_BALANCE;
            case KLMallOrderPrintType.UPDATE_PAY_ONLINE.value:return KLMallOrderPrintType.UPDATE_PAY_ONLINE;
            case KLMallOrderPrintType.CANCEL.value:return KLMallOrderPrintType.CANCEL;
            case KLMallOrderPrintType.UPDATE_STOCKOUT.value:return KLMallOrderPrintType.UPDATE_STOCKOUT;
            case KLMallOrderPrintType.PREORDER_FIRST.value:return KLMallOrderPrintType.PREORDER_FIRST;
            case KLMallOrderPrintType.PREORDER_REMINDER.value:return KLMallOrderPrintType.PREORDER_REMINDER;
            case KLMallOrderPrintType.PREORDER_TIME_CHANGE.value:return KLMallOrderPrintType.PREORDER_TIME_CHANGE;
            case KLMallOrderPrintType.MANUAL_PRINT.value:return KLMallOrderPrintType.MANUAL_PRINT;
        }
        return null;
    }
}

/**
 * 订单退款范围
*/
export class KLMallOrderReturnedScope extends KLEnum<string>{

    // None
    static readonly NONE = new KLMallOrderReturnedScope('NONE','NONE','None');

    // Partial
    static readonly PARTIAL = new KLMallOrderReturnedScope('PARTIAL','PARTIAL','Partial');

    // Full
    static readonly FULL = new KLMallOrderReturnedScope('FULL','FULL','Full');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderReturnedScope.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NONE','NONE','None'),
            new KLEnumCase<string>('PARTIAL','PARTIAL','Partial'),
            new KLEnumCase<string>('FULL','FULL','Full'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderReturnedScope|null {
        switch (val) {
            case KLMallOrderReturnedScope.NONE.value:return KLMallOrderReturnedScope.NONE;
            case KLMallOrderReturnedScope.PARTIAL.value:return KLMallOrderReturnedScope.PARTIAL;
            case KLMallOrderReturnedScope.FULL.value:return KLMallOrderReturnedScope.FULL;
        }
        return null;
    }
}

/**
 * 商城订单配送状态
*/
export class KLMallOrderShippingStatus extends KLEnum<string>{

    // 未配送
    static readonly NOT_SHIPPED = new KLMallOrderShippingStatus('NOT_SHIPPED','NOT_SHIPPED','未配送');

    // 打包中-骑手未接单
    static readonly PACKING_PENDING = new KLMallOrderShippingStatus('PACKING_PENDING','PACKING_PENDING','打包中-骑手未接单');

    // 打包中-骑手已接单
    static readonly PACKING_ACCEPTED = new KLMallOrderShippingStatus('PACKING_ACCEPTED','PACKING_ACCEPTED','打包中-骑手已接单');

    // 取货中
    static readonly PICKING_UP = new KLMallOrderShippingStatus('PICKING_UP','PICKING_UP','取货中');

    // 配送中
    static readonly DELIVERING = new KLMallOrderShippingStatus('DELIVERING','DELIVERING','配送中');

    // 已到达
    static readonly ARRIVED = new KLMallOrderShippingStatus('ARRIVED','ARRIVED','已到达');

    // 已送达
    static readonly DELIVERED = new KLMallOrderShippingStatus('DELIVERED','DELIVERED','已送达');

    // 自提
    static readonly SELF_PICKUP = new KLMallOrderShippingStatus('SELF_PICKUP','SELF_PICKUP','自提');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderShippingStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_SHIPPED','NOT_SHIPPED','未配送'),
            new KLEnumCase<string>('PACKING_PENDING','PACKING_PENDING','打包中-骑手未接单'),
            new KLEnumCase<string>('PACKING_ACCEPTED','PACKING_ACCEPTED','打包中-骑手已接单'),
            new KLEnumCase<string>('PICKING_UP','PICKING_UP','取货中'),
            new KLEnumCase<string>('DELIVERING','DELIVERING','配送中'),
            new KLEnumCase<string>('ARRIVED','ARRIVED','已到达'),
            new KLEnumCase<string>('DELIVERED','DELIVERED','已送达'),
            new KLEnumCase<string>('SELF_PICKUP','SELF_PICKUP','自提'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderShippingStatus|null {
        switch (val) {
            case KLMallOrderShippingStatus.NOT_SHIPPED.value:return KLMallOrderShippingStatus.NOT_SHIPPED;
            case KLMallOrderShippingStatus.PACKING_PENDING.value:return KLMallOrderShippingStatus.PACKING_PENDING;
            case KLMallOrderShippingStatus.PACKING_ACCEPTED.value:return KLMallOrderShippingStatus.PACKING_ACCEPTED;
            case KLMallOrderShippingStatus.PICKING_UP.value:return KLMallOrderShippingStatus.PICKING_UP;
            case KLMallOrderShippingStatus.DELIVERING.value:return KLMallOrderShippingStatus.DELIVERING;
            case KLMallOrderShippingStatus.ARRIVED.value:return KLMallOrderShippingStatus.ARRIVED;
            case KLMallOrderShippingStatus.DELIVERED.value:return KLMallOrderShippingStatus.DELIVERED;
            case KLMallOrderShippingStatus.SELF_PICKUP.value:return KLMallOrderShippingStatus.SELF_PICKUP;
        }
        return null;
    }
}

/**
 * 订单来源
*/
export class KLMallOrderSource extends KLEnum<string>{

    // APP
    static readonly APP = new KLMallOrderSource('APP','APP','APP');

    // PC
    static readonly PC = new KLMallOrderSource('PC','PC','PC');

    // WAP
    static readonly WAP = new KLMallOrderSource('WAP','WAP','WAP');

    // 小程序
    static readonly APPLET = new KLMallOrderSource('APPLET','APPLET','小程序');

    // 其他
    static readonly OTHER = new KLMallOrderSource('OTHER','OTHER','其他');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderSource.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('APP','APP','APP'),
            new KLEnumCase<string>('PC','PC','PC'),
            new KLEnumCase<string>('WAP','WAP','WAP'),
            new KLEnumCase<string>('APPLET','APPLET','小程序'),
            new KLEnumCase<string>('OTHER','OTHER','其他'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderSource|null {
        switch (val) {
            case KLMallOrderSource.APP.value:return KLMallOrderSource.APP;
            case KLMallOrderSource.PC.value:return KLMallOrderSource.PC;
            case KLMallOrderSource.WAP.value:return KLMallOrderSource.WAP;
            case KLMallOrderSource.APPLET.value:return KLMallOrderSource.APPLET;
            case KLMallOrderSource.OTHER.value:return KLMallOrderSource.OTHER;
        }
        return null;
    }
}

/**
 * 订单状态
*/
export class KLMallOrderStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING = new KLMallOrderStatus('PENDING','PENDING','Pending');

    // Awaiting Stock
    static readonly AWAITING_STOCK = new KLMallOrderStatus('AWAITING_STOCK','AWAITING_STOCK','Awaiting Stock');

    // Shipped
    static readonly SHIPPED = new KLMallOrderStatus('SHIPPED','SHIPPED','Shipped');

    // Completed
    static readonly COMPLETED = new KLMallOrderStatus('COMPLETED','COMPLETED','Completed');

    // Cancelled
    static readonly CANCELLED = new KLMallOrderStatus('CANCELLED','CANCELLED','Cancelled');

    // Refunded
    static readonly REFUNDED = new KLMallOrderStatus('REFUNDED','REFUNDED','Refunded');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('AWAITING_STOCK','AWAITING_STOCK','Awaiting Stock'),
            new KLEnumCase<string>('SHIPPED','SHIPPED','Shipped'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderStatus|null {
        switch (val) {
            case KLMallOrderStatus.PENDING.value:return KLMallOrderStatus.PENDING;
            case KLMallOrderStatus.AWAITING_STOCK.value:return KLMallOrderStatus.AWAITING_STOCK;
            case KLMallOrderStatus.SHIPPED.value:return KLMallOrderStatus.SHIPPED;
            case KLMallOrderStatus.COMPLETED.value:return KLMallOrderStatus.COMPLETED;
            case KLMallOrderStatus.CANCELLED.value:return KLMallOrderStatus.CANCELLED;
            case KLMallOrderStatus.REFUNDED.value:return KLMallOrderStatus.REFUNDED;
        }
        return null;
    }
}

/**
 * 订单状态变更类型
*/
export class KLMallOrderStatusChangeType extends KLEnum<string>{

    // 已支付
    static readonly PAID = new KLMallOrderStatusChangeType('PAID','PAID','已支付');

    // 已发货
    static readonly SHIPPED = new KLMallOrderStatusChangeType('SHIPPED','SHIPPED','已发货');

    // 已到达
    static readonly ARRIVED = new KLMallOrderStatusChangeType('ARRIVED','ARRIVED','已到达');

    // 已完成
    static readonly COMPLETED = new KLMallOrderStatusChangeType('COMPLETED','COMPLETED','已完成');

    // 已退款
    static readonly REFUNDED = new KLMallOrderStatusChangeType('REFUNDED','REFUNDED','已退款');

    // 退款审核通过
    static readonly REFUND_APPROVED = new KLMallOrderStatusChangeType('REFUND_APPROVED','REFUND_APPROVED','退款审核通过');

    // 退款审核拒绝
    static readonly REFUND_REJECTED = new KLMallOrderStatusChangeType('REFUND_REJECTED','REFUND_REJECTED','退款审核拒绝');

    // 已取消
    static readonly CANCELLED = new KLMallOrderStatusChangeType('CANCELLED','CANCELLED','已取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderStatusChangeType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PAID','PAID','已支付'),
            new KLEnumCase<string>('SHIPPED','SHIPPED','已发货'),
            new KLEnumCase<string>('ARRIVED','ARRIVED','已到达'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','已完成'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','已退款'),
            new KLEnumCase<string>('REFUND_APPROVED','REFUND_APPROVED','退款审核通过'),
            new KLEnumCase<string>('REFUND_REJECTED','REFUND_REJECTED','退款审核拒绝'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','已取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderStatusChangeType|null {
        switch (val) {
            case KLMallOrderStatusChangeType.PAID.value:return KLMallOrderStatusChangeType.PAID;
            case KLMallOrderStatusChangeType.SHIPPED.value:return KLMallOrderStatusChangeType.SHIPPED;
            case KLMallOrderStatusChangeType.ARRIVED.value:return KLMallOrderStatusChangeType.ARRIVED;
            case KLMallOrderStatusChangeType.COMPLETED.value:return KLMallOrderStatusChangeType.COMPLETED;
            case KLMallOrderStatusChangeType.REFUNDED.value:return KLMallOrderStatusChangeType.REFUNDED;
            case KLMallOrderStatusChangeType.REFUND_APPROVED.value:return KLMallOrderStatusChangeType.REFUND_APPROVED;
            case KLMallOrderStatusChangeType.REFUND_REJECTED.value:return KLMallOrderStatusChangeType.REFUND_REJECTED;
            case KLMallOrderStatusChangeType.CANCELLED.value:return KLMallOrderStatusChangeType.CANCELLED;
        }
        return null;
    }
}

/**
 * 缺货退款操作人类型
*/
export class KLMallOrderStockoutOperatorType extends KLEnum<string>{

    // Merchant
    static readonly MERCHANT = new KLMallOrderStockoutOperatorType('MERCHANT','MERCHANT','Merchant');

    // Admin
    static readonly ADMIN = new KLMallOrderStockoutOperatorType('ADMIN','ADMIN','Admin');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderStockoutOperatorType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MERCHANT','MERCHANT','Merchant'),
            new KLEnumCase<string>('ADMIN','ADMIN','Admin'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderStockoutOperatorType|null {
        switch (val) {
            case KLMallOrderStockoutOperatorType.MERCHANT.value:return KLMallOrderStockoutOperatorType.MERCHANT;
            case KLMallOrderStockoutOperatorType.ADMIN.value:return KLMallOrderStockoutOperatorType.ADMIN;
        }
        return null;
    }
}

/**
 * 缺货退款原支付方式
*/
export class KLMallOrderStockoutOriginalPayMethod extends KLEnum<string>{

    // Online
    static readonly ONLINE = new KLMallOrderStockoutOriginalPayMethod('ONLINE','ONLINE','Online');

    // COD
    static readonly COD = new KLMallOrderStockoutOriginalPayMethod('COD','COD','COD');

    // Balance
    static readonly BALANCE = new KLMallOrderStockoutOriginalPayMethod('BALANCE','BALANCE','Balance');

    // Mixed
    static readonly MIXED = new KLMallOrderStockoutOriginalPayMethod('MIXED','MIXED','Mixed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderStockoutOriginalPayMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','Online'),
            new KLEnumCase<string>('COD','COD','COD'),
            new KLEnumCase<string>('BALANCE','BALANCE','Balance'),
            new KLEnumCase<string>('MIXED','MIXED','Mixed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderStockoutOriginalPayMethod|null {
        switch (val) {
            case KLMallOrderStockoutOriginalPayMethod.ONLINE.value:return KLMallOrderStockoutOriginalPayMethod.ONLINE;
            case KLMallOrderStockoutOriginalPayMethod.COD.value:return KLMallOrderStockoutOriginalPayMethod.COD;
            case KLMallOrderStockoutOriginalPayMethod.BALANCE.value:return KLMallOrderStockoutOriginalPayMethod.BALANCE;
            case KLMallOrderStockoutOriginalPayMethod.MIXED.value:return KLMallOrderStockoutOriginalPayMethod.MIXED;
        }
        return null;
    }
}

/**
 * 缺货退款范围
*/
export class KLMallOrderStockoutRefundScope extends KLEnum<string>{

    // Full
    static readonly FULL = new KLMallOrderStockoutRefundScope('FULL','FULL','Full');

    // Partial
    static readonly PARTIAL = new KLMallOrderStockoutRefundScope('PARTIAL','PARTIAL','Partial');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderStockoutRefundScope.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FULL','FULL','Full'),
            new KLEnumCase<string>('PARTIAL','PARTIAL','Partial'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderStockoutRefundScope|null {
        switch (val) {
            case KLMallOrderStockoutRefundScope.FULL.value:return KLMallOrderStockoutRefundScope.FULL;
            case KLMallOrderStockoutRefundScope.PARTIAL.value:return KLMallOrderStockoutRefundScope.PARTIAL;
        }
        return null;
    }
}

/**
 * 订单缺货退款状态
*/
export class KLMallOrderStockoutRefundStatus extends KLEnum<string>{

    // Processing
    static readonly PROCESSING = new KLMallOrderStockoutRefundStatus('PROCESSING','PROCESSING','Processing');

    // Completed
    static readonly COMPLETED = new KLMallOrderStockoutRefundStatus('COMPLETED','COMPLETED','Completed');

    // Failed
    static readonly FAILED = new KLMallOrderStockoutRefundStatus('FAILED','FAILED','Failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallOrderStockoutRefundStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PROCESSING','PROCESSING','Processing'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallOrderStockoutRefundStatus|null {
        switch (val) {
            case KLMallOrderStockoutRefundStatus.PROCESSING.value:return KLMallOrderStockoutRefundStatus.PROCESSING;
            case KLMallOrderStockoutRefundStatus.COMPLETED.value:return KLMallOrderStockoutRefundStatus.COMPLETED;
            case KLMallOrderStockoutRefundStatus.FAILED.value:return KLMallOrderStockoutRefundStatus.FAILED;
        }
        return null;
    }
}

/**
 * 店铺配送方式
*/
export class KLMallStoreDeliveryConfMethod extends KLEnum<string>{

    // 物流配送
    static readonly LOGISTICS = new KLMallStoreDeliveryConfMethod('LOGISTICS','LOGISTICS','物流配送');

    // 即时配送
    static readonly ON_TIME = new KLMallStoreDeliveryConfMethod('ON_TIME','ON_TIME','即时配送');

    // 商家自配送
    static readonly SELF_DELIVERY = new KLMallStoreDeliveryConfMethod('SELF_DELIVERY','SELF_DELIVERY','商家自配送');

    // 用户自提
    static readonly SELF_PICKUP = new KLMallStoreDeliveryConfMethod('SELF_PICKUP','SELF_PICKUP','用户自提');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallStoreDeliveryConfMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('LOGISTICS','LOGISTICS','物流配送'),
            new KLEnumCase<string>('ON_TIME','ON_TIME','即时配送'),
            new KLEnumCase<string>('SELF_DELIVERY','SELF_DELIVERY','商家自配送'),
            new KLEnumCase<string>('SELF_PICKUP','SELF_PICKUP','用户自提'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallStoreDeliveryConfMethod|null {
        switch (val) {
            case KLMallStoreDeliveryConfMethod.LOGISTICS.value:return KLMallStoreDeliveryConfMethod.LOGISTICS;
            case KLMallStoreDeliveryConfMethod.ON_TIME.value:return KLMallStoreDeliveryConfMethod.ON_TIME;
            case KLMallStoreDeliveryConfMethod.SELF_DELIVERY.value:return KLMallStoreDeliveryConfMethod.SELF_DELIVERY;
            case KLMallStoreDeliveryConfMethod.SELF_PICKUP.value:return KLMallStoreDeliveryConfMethod.SELF_PICKUP;
        }
        return null;
    }
}

/**
 * 配送配置状态
*/
export class KLMallStoreDeliveryConfStatus extends KLEnum<string>{

    // 启用
    static readonly ENABLED = new KLMallStoreDeliveryConfStatus('ENABLED','ENABLED','启用');

    // 禁用
    static readonly DISABLED = new KLMallStoreDeliveryConfStatus('DISABLED','DISABLED','禁用');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallStoreDeliveryConfStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ENABLED','ENABLED','启用'),
            new KLEnumCase<string>('DISABLED','DISABLED','禁用'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallStoreDeliveryConfStatus|null {
        switch (val) {
            case KLMallStoreDeliveryConfStatus.ENABLED.value:return KLMallStoreDeliveryConfStatus.ENABLED;
            case KLMallStoreDeliveryConfStatus.DISABLED.value:return KLMallStoreDeliveryConfStatus.DISABLED;
        }
        return null;
    }
}

/**
 * 店铺打印机类型
*/
export class KLMallStorePrinterType extends KLEnum<string>{

    // 飞鹅
    static readonly FEI_E = new KLMallStorePrinterType('FEI_E','FEI_E','飞鹅');

    // 易联云
    static readonly YLY = new KLMallStorePrinterType('YLY','YLY','易联云');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallStorePrinterType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FEI_E','FEI_E','飞鹅'),
            new KLEnumCase<string>('YLY','YLY','易联云'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallStorePrinterType|null {
        switch (val) {
            case KLMallStorePrinterType.FEI_E.value:return KLMallStorePrinterType.FEI_E;
            case KLMallStorePrinterType.YLY.value:return KLMallStorePrinterType.YLY;
        }
        return null;
    }
}

/**
 * 店铺营业状态
*/
export class KLMallStoreStatus extends KLEnum<string>{

    // 营业中
    static readonly OPEN = new KLMallStoreStatus('OPEN','OPEN','营业中');

    // 已闭店
    static readonly CLOSED = new KLMallStoreStatus('CLOSED','CLOSED','已闭店');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMallStoreStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('OPEN','OPEN','营业中'),
            new KLEnumCase<string>('CLOSED','CLOSED','已闭店'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMallStoreStatus|null {
        switch (val) {
            case KLMallStoreStatus.OPEN.value:return KLMallStoreStatus.OPEN;
            case KLMallStoreStatus.CLOSED.value:return KLMallStoreStatus.CLOSED;
        }
        return null;
    }
}

/**
 * 拒单支付方式
*/
export class KLOrderRejectionPayMethod extends KLEnum<string>{

    // Online
    static readonly ONLINE = new KLOrderRejectionPayMethod('ONLINE','ONLINE','Online');

    // COD
    static readonly COD = new KLOrderRejectionPayMethod('COD','COD','COD');

    // Balance
    static readonly BALANCE = new KLOrderRejectionPayMethod('BALANCE','BALANCE','Balance');

    // Mixed
    static readonly MIXED = new KLOrderRejectionPayMethod('MIXED','MIXED','Mixed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLOrderRejectionPayMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','Online'),
            new KLEnumCase<string>('COD','COD','COD'),
            new KLEnumCase<string>('BALANCE','BALANCE','Balance'),
            new KLEnumCase<string>('MIXED','MIXED','Mixed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLOrderRejectionPayMethod|null {
        switch (val) {
            case KLOrderRejectionPayMethod.ONLINE.value:return KLOrderRejectionPayMethod.ONLINE;
            case KLOrderRejectionPayMethod.COD.value:return KLOrderRejectionPayMethod.COD;
            case KLOrderRejectionPayMethod.BALANCE.value:return KLOrderRejectionPayMethod.BALANCE;
            case KLOrderRejectionPayMethod.MIXED.value:return KLOrderRejectionPayMethod.MIXED;
        }
        return null;
    }
}

/**
 * 拒单业务类型
*/
export class KLRejectionBusinessTypeEnum extends KLEnum<string>{

    // 充值订单
    static readonly RECHARGE = new KLRejectionBusinessTypeEnum('RECHARGE','RECHARGE','充值订单');

    // 商城订单
    static readonly MALL = new KLRejectionBusinessTypeEnum('MALL','MALL','商城订单');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRejectionBusinessTypeEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('RECHARGE','RECHARGE','充值订单'),
            new KLEnumCase<string>('MALL','MALL','商城订单'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRejectionBusinessTypeEnum|null {
        switch (val) {
            case KLRejectionBusinessTypeEnum.RECHARGE.value:return KLRejectionBusinessTypeEnum.RECHARGE;
            case KLRejectionBusinessTypeEnum.MALL.value:return KLRejectionBusinessTypeEnum.MALL;
        }
        return null;
    }
}

/**
 * 拒单限制类型
*/
export class KLRejectionLimitTypeEnum extends KLEnum<number>{

    // 不限制
    static readonly NONE = new KLRejectionLimitTypeEnum('NONE',0,'不限制');

    // 不允许下单
    static readonly NO_ORDER = new KLRejectionLimitTypeEnum('NO_ORDER',1,'不允许下单');

    // 仅允许在线支付
    static readonly ONLINE_ONLY = new KLRejectionLimitTypeEnum('ONLINE_ONLY',2,'仅允许在线支付');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLRejectionLimitTypeEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('NONE',0,'不限制'),
            new KLEnumCase<number>('NO_ORDER',1,'不允许下单'),
            new KLEnumCase<number>('ONLINE_ONLY',2,'仅允许在线支付'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLRejectionLimitTypeEnum|null {
        switch (val) {
            case KLRejectionLimitTypeEnum.NONE.value:return KLRejectionLimitTypeEnum.NONE;
            case KLRejectionLimitTypeEnum.NO_ORDER.value:return KLRejectionLimitTypeEnum.NO_ORDER;
            case KLRejectionLimitTypeEnum.ONLINE_ONLY.value:return KLRejectionLimitTypeEnum.ONLINE_ONLY;
        }
        return null;
    }
}

/**
 * 拒单来源
*/
export class KLRejectionRejectTypeEnum extends KLEnum<string>{

    // 商家拒单
    static readonly MERCHANT = new KLRejectionRejectTypeEnum('MERCHANT','MERCHANT','商家拒单');

    // 用户拒收
    static readonly USER = new KLRejectionRejectTypeEnum('USER','USER','用户拒收');

    // 平台拒单
    static readonly PLATFORM = new KLRejectionRejectTypeEnum('PLATFORM','PLATFORM','平台拒单');

    // 其他
    static readonly OTHER = new KLRejectionRejectTypeEnum('OTHER','OTHER','其他');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRejectionRejectTypeEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MERCHANT','MERCHANT','商家拒单'),
            new KLEnumCase<string>('USER','USER','用户拒收'),
            new KLEnumCase<string>('PLATFORM','PLATFORM','平台拒单'),
            new KLEnumCase<string>('OTHER','OTHER','其他'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRejectionRejectTypeEnum|null {
        switch (val) {
            case KLRejectionRejectTypeEnum.MERCHANT.value:return KLRejectionRejectTypeEnum.MERCHANT;
            case KLRejectionRejectTypeEnum.USER.value:return KLRejectionRejectTypeEnum.USER;
            case KLRejectionRejectTypeEnum.PLATFORM.value:return KLRejectionRejectTypeEnum.PLATFORM;
            case KLRejectionRejectTypeEnum.OTHER.value:return KLRejectionRejectTypeEnum.OTHER;
        }
        return null;
    }
}

/**
 * 管理员性别
*/
export class KLSysAdminGender extends KLEnum<string>{

    // 未知
    static readonly UNKNOWN = new KLSysAdminGender('UNKNOWN','UNKNOWN','未知');

    // 男
    static readonly MALE = new KLSysAdminGender('MALE','MALE','男');

    // 女
    static readonly FEMALE = new KLSysAdminGender('FEMALE','FEMALE','女');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSysAdminGender.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNKNOWN','UNKNOWN','未知'),
            new KLEnumCase<string>('MALE','MALE','男'),
            new KLEnumCase<string>('FEMALE','FEMALE','女'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSysAdminGender|null {
        switch (val) {
            case KLSysAdminGender.UNKNOWN.value:return KLSysAdminGender.UNKNOWN;
            case KLSysAdminGender.MALE.value:return KLSysAdminGender.MALE;
            case KLSysAdminGender.FEMALE.value:return KLSysAdminGender.FEMALE;
        }
        return null;
    }
}

/**
 * 管理员状态
*/
export class KLSysAdminStatus extends KLEnum<string>{

    // 正常
    static readonly ACTIVE = new KLSysAdminStatus('ACTIVE','ACTIVE','正常');

    // 锁定
    static readonly LOCKED = new KLSysAdminStatus('LOCKED','LOCKED','锁定');

    // 删除
    static readonly DELETED = new KLSysAdminStatus('DELETED','DELETED','删除');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSysAdminStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ACTIVE','ACTIVE','正常'),
            new KLEnumCase<string>('LOCKED','LOCKED','锁定'),
            new KLEnumCase<string>('DELETED','DELETED','删除'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSysAdminStatus|null {
        switch (val) {
            case KLSysAdminStatus.ACTIVE.value:return KLSysAdminStatus.ACTIVE;
            case KLSysAdminStatus.LOCKED.value:return KLSysAdminStatus.LOCKED;
            case KLSysAdminStatus.DELETED.value:return KLSysAdminStatus.DELETED;
        }
        return null;
    }
}

/**
 * APP版本操作类型
*/
export class KLAppVersionActionType extends KLEnum<string>{

    // 添加
    static readonly ADD = new KLAppVersionActionType('ADD','ADD','添加');

    // 修改
    static readonly MODIFY = new KLAppVersionActionType('MODIFY','MODIFY','修改');

    // 发布
    static readonly RELEASE = new KLAppVersionActionType('RELEASE','RELEASE','发布');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppVersionActionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ADD','ADD','添加'),
            new KLEnumCase<string>('MODIFY','MODIFY','修改'),
            new KLEnumCase<string>('RELEASE','RELEASE','发布'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppVersionActionType|null {
        switch (val) {
            case KLAppVersionActionType.ADD.value:return KLAppVersionActionType.ADD;
            case KLAppVersionActionType.MODIFY.value:return KLAppVersionActionType.MODIFY;
            case KLAppVersionActionType.RELEASE.value:return KLAppVersionActionType.RELEASE;
        }
        return null;
    }
}

/**
 * APP版本发布渠道
*/
export class KLAppVersionChannel extends KLEnum<string>{

    // 华为
    static readonly HUAWEI = new KLAppVersionChannel('HUAWEI','huawei','华为');

    // 小米
    static readonly XIAOMI = new KLAppVersionChannel('XIAOMI','xiaomi','小米');

    // oppo
    static readonly OPPO = new KLAppVersionChannel('OPPO','oppo','oppo');

    // vivo
    static readonly VIVO = new KLAppVersionChannel('VIVO','vivo','vivo');

    // 三星
    static readonly SAMSUNG = new KLAppVersionChannel('SAMSUNG','samsung','三星');

    // 谷歌
    static readonly GOOGLE = new KLAppVersionChannel('GOOGLE','google','谷歌');

    // 应用宝
    static readonly YINGYONGBAO = new KLAppVersionChannel('YINGYONGBAO','yingyongbao','应用宝');

    // 官网
    static readonly STANDARD = new KLAppVersionChannel('STANDARD','standard','官网');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppVersionChannel.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HUAWEI','huawei','华为'),
            new KLEnumCase<string>('XIAOMI','xiaomi','小米'),
            new KLEnumCase<string>('OPPO','oppo','oppo'),
            new KLEnumCase<string>('VIVO','vivo','vivo'),
            new KLEnumCase<string>('SAMSUNG','samsung','三星'),
            new KLEnumCase<string>('GOOGLE','google','谷歌'),
            new KLEnumCase<string>('YINGYONGBAO','yingyongbao','应用宝'),
            new KLEnumCase<string>('STANDARD','standard','官网'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppVersionChannel|null {
        switch (val) {
            case KLAppVersionChannel.HUAWEI.value:return KLAppVersionChannel.HUAWEI;
            case KLAppVersionChannel.XIAOMI.value:return KLAppVersionChannel.XIAOMI;
            case KLAppVersionChannel.OPPO.value:return KLAppVersionChannel.OPPO;
            case KLAppVersionChannel.VIVO.value:return KLAppVersionChannel.VIVO;
            case KLAppVersionChannel.SAMSUNG.value:return KLAppVersionChannel.SAMSUNG;
            case KLAppVersionChannel.GOOGLE.value:return KLAppVersionChannel.GOOGLE;
            case KLAppVersionChannel.YINGYONGBAO.value:return KLAppVersionChannel.YINGYONGBAO;
            case KLAppVersionChannel.STANDARD.value:return KLAppVersionChannel.STANDARD;
        }
        return null;
    }
}

/**
 * 平台类型
*/
export class KLAppVersionPlatform extends KLEnum<string>{

    // iOS
    static readonly IOS = new KLAppVersionPlatform('IOS','IOS','iOS');

    // Android
    static readonly ANDROID = new KLAppVersionPlatform('ANDROID','ANDROID','Android');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppVersionPlatform.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IOS','IOS','iOS'),
            new KLEnumCase<string>('ANDROID','ANDROID','Android'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppVersionPlatform|null {
        switch (val) {
            case KLAppVersionPlatform.IOS.value:return KLAppVersionPlatform.IOS;
            case KLAppVersionPlatform.ANDROID.value:return KLAppVersionPlatform.ANDROID;
        }
        return null;
    }
}

/**
 * APP版本状态
*/
export class KLAppVersionStatus extends KLEnum<string>{

    // Unpublished
    static readonly UNPUBLISHED = new KLAppVersionStatus('UNPUBLISHED','UNPUBLISHED','Unpublished');

    // Published
    static readonly PUBLISHED = new KLAppVersionStatus('PUBLISHED','PUBLISHED','Published');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppVersionStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNPUBLISHED','UNPUBLISHED','Unpublished'),
            new KLEnumCase<string>('PUBLISHED','PUBLISHED','Published'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppVersionStatus|null {
        switch (val) {
            case KLAppVersionStatus.UNPUBLISHED.value:return KLAppVersionStatus.UNPUBLISHED;
            case KLAppVersionStatus.PUBLISHED.value:return KLAppVersionStatus.PUBLISHED;
        }
        return null;
    }
}

/**
 * 应用类型
*/
export class KLAppVersionType extends KLEnum<string>{

    // User
    static readonly USER = new KLAppVersionType('USER','USER','User');

    // Merchant
    static readonly MERCHANT = new KLAppVersionType('MERCHANT','MERCHANT','Merchant');

    // Rider
    static readonly RIDER = new KLAppVersionType('RIDER','RIDER','Rider');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppVersionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER','USER','User'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','Merchant'),
            new KLEnumCase<string>('RIDER','RIDER','Rider'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppVersionType|null {
        switch (val) {
            case KLAppVersionType.USER.value:return KLAppVersionType.USER;
            case KLAppVersionType.MERCHANT.value:return KLAppVersionType.MERCHANT;
            case KLAppVersionType.RIDER.value:return KLAppVersionType.RIDER;
        }
        return null;
    }
}

/**
 * APP版本升级动作
*/
export class KLAppVersionUpgradeAction extends KLEnum<string>{

    // 下载
    static readonly DOWNLOAD = new KLAppVersionUpgradeAction('DOWNLOAD','download','下载');

    // 拉起
    static readonly LAUNCH = new KLAppVersionUpgradeAction('LAUNCH','launch','拉起');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppVersionUpgradeAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DOWNLOAD','download','下载'),
            new KLEnumCase<string>('LAUNCH','launch','拉起'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppVersionUpgradeAction|null {
        switch (val) {
            case KLAppVersionUpgradeAction.DOWNLOAD.value:return KLAppVersionUpgradeAction.DOWNLOAD;
            case KLAppVersionUpgradeAction.LAUNCH.value:return KLAppVersionUpgradeAction.LAUNCH;
        }
        return null;
    }
}

/**
 * 文章类型
*/
export class KLArticlesType extends KLEnum<string>{

    // 隐私协议
    static readonly PRIVACY_POLICY = new KLArticlesType('PRIVACY_POLICY','PRIVACY_POLICY','隐私协议');

    // 用户协议
    static readonly USER_AGREEMENT = new KLArticlesType('USER_AGREEMENT','USER_AGREEMENT','用户协议');

    // 充值协议
    static readonly TOPUP_AGREEMENT = new KLArticlesType('TOPUP_AGREEMENT','TOPUP_AGREEMENT','充值协议');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLArticlesType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PRIVACY_POLICY','PRIVACY_POLICY','隐私协议'),
            new KLEnumCase<string>('USER_AGREEMENT','USER_AGREEMENT','用户协议'),
            new KLEnumCase<string>('TOPUP_AGREEMENT','TOPUP_AGREEMENT','充值协议'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLArticlesType|null {
        switch (val) {
            case KLArticlesType.PRIVACY_POLICY.value:return KLArticlesType.PRIVACY_POLICY;
            case KLArticlesType.USER_AGREEMENT.value:return KLArticlesType.USER_AGREEMENT;
            case KLArticlesType.TOPUP_AGREEMENT.value:return KLArticlesType.TOPUP_AGREEMENT;
        }
        return null;
    }
}

/**
 * 文章业务类型
*/
export class KLArticleTypeEnum extends KLEnum<string>{

    // 文章
    static readonly ARTICLE = new KLArticleTypeEnum('ARTICLE','ARTICLE','文章');

    // 公告
    static readonly NOTICE = new KLArticleTypeEnum('NOTICE','NOTICE','公告');

    // 推送模板
    static readonly PUSH_TEMPLATE = new KLArticleTypeEnum('PUSH_TEMPLATE','PUSH_TEMPLATE','推送模板');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLArticleTypeEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ARTICLE','ARTICLE','文章'),
            new KLEnumCase<string>('NOTICE','NOTICE','公告'),
            new KLEnumCase<string>('PUSH_TEMPLATE','PUSH_TEMPLATE','推送模板'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLArticleTypeEnum|null {
        switch (val) {
            case KLArticleTypeEnum.ARTICLE.value:return KLArticleTypeEnum.ARTICLE;
            case KLArticleTypeEnum.NOTICE.value:return KLArticleTypeEnum.NOTICE;
            case KLArticleTypeEnum.PUSH_TEMPLATE.value:return KLArticleTypeEnum.PUSH_TEMPLATE;
        }
        return null;
    }
}

/**
 * 云打印平台枚举
*/
export class KLCloudPrintPlatformEnum extends KLEnum<string>{

    // 飞鹅云
    static readonly FEIE = new KLCloudPrintPlatformEnum('FEIE','FEI_E','飞鹅云');

    // 易联云
    static readonly YLY = new KLCloudPrintPlatformEnum('YLY','YLY','易联云');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLCloudPrintPlatformEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FEIE','FEI_E','飞鹅云'),
            new KLEnumCase<string>('YLY','YLY','易联云'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLCloudPrintPlatformEnum|null {
        switch (val) {
            case KLCloudPrintPlatformEnum.FEIE.value:return KLCloudPrintPlatformEnum.FEIE;
            case KLCloudPrintPlatformEnum.YLY.value:return KLCloudPrintPlatformEnum.YLY;
        }
        return null;
    }
}

/**
 * 打印内容对齐方式
*/
export class KLPrintAlignEnum extends KLEnum<number>{

    // 左对齐
    static readonly LEFT = new KLPrintAlignEnum('LEFT',1,'左对齐');

    // 居中对齐
    static readonly CENTER = new KLPrintAlignEnum('CENTER',2,'居中对齐');

    // 右对齐
    static readonly RIGHT = new KLPrintAlignEnum('RIGHT',3,'右对齐');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLPrintAlignEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('LEFT',1,'左对齐'),
            new KLEnumCase<number>('CENTER',2,'居中对齐'),
            new KLEnumCase<number>('RIGHT',3,'右对齐'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLPrintAlignEnum|null {
        switch (val) {
            case KLPrintAlignEnum.LEFT.value:return KLPrintAlignEnum.LEFT;
            case KLPrintAlignEnum.CENTER.value:return KLPrintAlignEnum.CENTER;
            case KLPrintAlignEnum.RIGHT.value:return KLPrintAlignEnum.RIGHT;
        }
        return null;
    }
}

/**
 * 
*/
export class KLDeliveryMode extends KLEnum<string>{

    // 即时配送
    static readonly INSTANT = new KLDeliveryMode('INSTANT','INSTANT','即时配送');

    // 标准配送
    static readonly STANDARD = new KLDeliveryMode('STANDARD','STANDARD','标准配送');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLDeliveryMode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('INSTANT','INSTANT','即时配送'),
            new KLEnumCase<string>('STANDARD','STANDARD','标准配送'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLDeliveryMode|null {
        switch (val) {
            case KLDeliveryMode.INSTANT.value:return KLDeliveryMode.INSTANT;
            case KLDeliveryMode.STANDARD.value:return KLDeliveryMode.STANDARD;
        }
        return null;
    }
}

/**
 * 配送订单状态
*/
export class KLDeliveryOrderStatus extends KLEnum<string>{

    // 等待调度
    static readonly WAITING_DISPATCH = new KLDeliveryOrderStatus('WAITING_DISPATCH','WAITING_DISPATCH','等待调度');

    // 已完成调度
    static readonly DISPATCHED = new KLDeliveryOrderStatus('DISPATCHED','DISPATCHED','已完成调度');

    // 可取餐
    static readonly READY_FOR_PICK_UP = new KLDeliveryOrderStatus('READY_FOR_PICK_UP','READY_FOR_PICK_UP','可取餐');

    // 已取餐
    static readonly PICK_UP = new KLDeliveryOrderStatus('PICK_UP','PICK_UP','已取餐');

    // 已到达
    static readonly ARRIVED = new KLDeliveryOrderStatus('ARRIVED','ARRIVED','已到达');

    // 已完成
    static readonly COMPLETED = new KLDeliveryOrderStatus('COMPLETED','COMPLETED','已完成');

    // 已关闭
    static readonly CLOSED = new KLDeliveryOrderStatus('CLOSED','CLOSED','已关闭');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLDeliveryOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('WAITING_DISPATCH','WAITING_DISPATCH','等待调度'),
            new KLEnumCase<string>('DISPATCHED','DISPATCHED','已完成调度'),
            new KLEnumCase<string>('READY_FOR_PICK_UP','READY_FOR_PICK_UP','可取餐'),
            new KLEnumCase<string>('PICK_UP','PICK_UP','已取餐'),
            new KLEnumCase<string>('ARRIVED','ARRIVED','已到达'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','已完成'),
            new KLEnumCase<string>('CLOSED','CLOSED','已关闭'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLDeliveryOrderStatus|null {
        switch (val) {
            case KLDeliveryOrderStatus.WAITING_DISPATCH.value:return KLDeliveryOrderStatus.WAITING_DISPATCH;
            case KLDeliveryOrderStatus.DISPATCHED.value:return KLDeliveryOrderStatus.DISPATCHED;
            case KLDeliveryOrderStatus.READY_FOR_PICK_UP.value:return KLDeliveryOrderStatus.READY_FOR_PICK_UP;
            case KLDeliveryOrderStatus.PICK_UP.value:return KLDeliveryOrderStatus.PICK_UP;
            case KLDeliveryOrderStatus.ARRIVED.value:return KLDeliveryOrderStatus.ARRIVED;
            case KLDeliveryOrderStatus.COMPLETED.value:return KLDeliveryOrderStatus.COMPLETED;
            case KLDeliveryOrderStatus.CLOSED.value:return KLDeliveryOrderStatus.CLOSED;
        }
        return null;
    }
}

/**
 * 配送订单类型
*/
export class KLDeliveryOrderType extends KLEnum<string>{

    // 充值订单
    static readonly RECHARGE = new KLDeliveryOrderType('RECHARGE','RECHARGE','充值订单');

    // 商城订单
    static readonly MALL = new KLDeliveryOrderType('MALL','MALL','商城订单');

    // 商城合并订单
    static readonly MALL_MERGE = new KLDeliveryOrderType('MALL_MERGE','MALL_MERGE','商城合并订单');

    // 商城售后订单
    static readonly MALL_RETURN = new KLDeliveryOrderType('MALL_RETURN','MALL_RETURN','商城售后订单');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLDeliveryOrderType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('RECHARGE','RECHARGE','充值订单'),
            new KLEnumCase<string>('MALL','MALL','商城订单'),
            new KLEnumCase<string>('MALL_MERGE','MALL_MERGE','商城合并订单'),
            new KLEnumCase<string>('MALL_RETURN','MALL_RETURN','商城售后订单'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLDeliveryOrderType|null {
        switch (val) {
            case KLDeliveryOrderType.RECHARGE.value:return KLDeliveryOrderType.RECHARGE;
            case KLDeliveryOrderType.MALL.value:return KLDeliveryOrderType.MALL;
            case KLDeliveryOrderType.MALL_MERGE.value:return KLDeliveryOrderType.MALL_MERGE;
            case KLDeliveryOrderType.MALL_RETURN.value:return KLDeliveryOrderType.MALL_RETURN;
        }
        return null;
    }
}

/**
 * 
*/
export class KLDeliveryPlatformEnum extends KLEnum<string>{

    // KRIDER
    static readonly KRIDER = new KLDeliveryPlatformEnum('KRIDER','KRIDER','KRIDER');

    // Lalamove
    static readonly LALAMOVE = new KLDeliveryPlatformEnum('LALAMOVE','LALAMOVE','Lalamove');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLDeliveryPlatformEnum.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('KRIDER','KRIDER','KRIDER'),
            new KLEnumCase<string>('LALAMOVE','LALAMOVE','Lalamove'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLDeliveryPlatformEnum|null {
        switch (val) {
            case KLDeliveryPlatformEnum.KRIDER.value:return KLDeliveryPlatformEnum.KRIDER;
            case KLDeliveryPlatformEnum.LALAMOVE.value:return KLDeliveryPlatformEnum.LALAMOVE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLKRiderApiMethod extends KLEnum<string>{

    // DELIVERY_ON_RIDER_PICKUP
    static readonly DELIVERY_ON_RIDER_PICKUP = new KLKRiderApiMethod('DELIVERY_ON_RIDER_PICKUP','DELIVERY_ON_RIDER_PICKUP','DELIVERY_ON_RIDER_PICKUP');

    // DELIVERY_ON_RIDER_ASSIGN
    static readonly DELIVERY_ON_RIDER_ASSIGN = new KLKRiderApiMethod('DELIVERY_ON_RIDER_ASSIGN','DELIVERY_ON_RIDER_ASSIGN','DELIVERY_ON_RIDER_ASSIGN');

    // MODIFY_ETA
    static readonly MODIFY_ETA = new KLKRiderApiMethod('MODIFY_ETA','MODIFY_ETA','MODIFY_ETA');

    // CONFIRM_STORE_ARRIVAL
    static readonly CONFIRM_STORE_ARRIVAL = new KLKRiderApiMethod('CONFIRM_STORE_ARRIVAL','CONFIRM_STORE_ARRIVAL','CONFIRM_STORE_ARRIVAL');

    // CONFIRM_PICKUP
    static readonly CONFIRM_PICKUP = new KLKRiderApiMethod('CONFIRM_PICKUP','CONFIRM_PICKUP','CONFIRM_PICKUP');

    // CONFIRM_USER_ARRIVAL
    static readonly CONFIRM_USER_ARRIVAL = new KLKRiderApiMethod('CONFIRM_USER_ARRIVAL','CONFIRM_USER_ARRIVAL','CONFIRM_USER_ARRIVAL');

    // CONFIRM_COMPLETION
    static readonly CONFIRM_COMPLETION = new KLKRiderApiMethod('CONFIRM_COMPLETION','CONFIRM_COMPLETION','CONFIRM_COMPLETION');

    // UPDATE_DELIVERY_TIME
    static readonly UPDATE_DELIVERY_TIME = new KLKRiderApiMethod('UPDATE_DELIVERY_TIME','UPDATE_DELIVERY_TIME','UPDATE_DELIVERY_TIME');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLKRiderApiMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DELIVERY_ON_RIDER_PICKUP','DELIVERY_ON_RIDER_PICKUP','DELIVERY_ON_RIDER_PICKUP'),
            new KLEnumCase<string>('DELIVERY_ON_RIDER_ASSIGN','DELIVERY_ON_RIDER_ASSIGN','DELIVERY_ON_RIDER_ASSIGN'),
            new KLEnumCase<string>('MODIFY_ETA','MODIFY_ETA','MODIFY_ETA'),
            new KLEnumCase<string>('CONFIRM_STORE_ARRIVAL','CONFIRM_STORE_ARRIVAL','CONFIRM_STORE_ARRIVAL'),
            new KLEnumCase<string>('CONFIRM_PICKUP','CONFIRM_PICKUP','CONFIRM_PICKUP'),
            new KLEnumCase<string>('CONFIRM_USER_ARRIVAL','CONFIRM_USER_ARRIVAL','CONFIRM_USER_ARRIVAL'),
            new KLEnumCase<string>('CONFIRM_COMPLETION','CONFIRM_COMPLETION','CONFIRM_COMPLETION'),
            new KLEnumCase<string>('UPDATE_DELIVERY_TIME','UPDATE_DELIVERY_TIME','UPDATE_DELIVERY_TIME'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLKRiderApiMethod|null {
        switch (val) {
            case KLKRiderApiMethod.DELIVERY_ON_RIDER_PICKUP.value:return KLKRiderApiMethod.DELIVERY_ON_RIDER_PICKUP;
            case KLKRiderApiMethod.DELIVERY_ON_RIDER_ASSIGN.value:return KLKRiderApiMethod.DELIVERY_ON_RIDER_ASSIGN;
            case KLKRiderApiMethod.MODIFY_ETA.value:return KLKRiderApiMethod.MODIFY_ETA;
            case KLKRiderApiMethod.CONFIRM_STORE_ARRIVAL.value:return KLKRiderApiMethod.CONFIRM_STORE_ARRIVAL;
            case KLKRiderApiMethod.CONFIRM_PICKUP.value:return KLKRiderApiMethod.CONFIRM_PICKUP;
            case KLKRiderApiMethod.CONFIRM_USER_ARRIVAL.value:return KLKRiderApiMethod.CONFIRM_USER_ARRIVAL;
            case KLKRiderApiMethod.CONFIRM_COMPLETION.value:return KLKRiderApiMethod.CONFIRM_COMPLETION;
            case KLKRiderApiMethod.UPDATE_DELIVERY_TIME.value:return KLKRiderApiMethod.UPDATE_DELIVERY_TIME;
        }
        return null;
    }
}

/**
 * Google地理记录类型
*/
export class KLGoogleGeoRecordType extends KLEnum<string>{

    // Google路线规划
    static readonly GOOGLE_ROUTE_PLANNING = new KLGoogleGeoRecordType('GOOGLE_ROUTE_PLANNING','GOOGLE_ROUTE_PLANNING','Google路线规划');

    // Google逆地理编码
    static readonly GOOGLE_REVERSE_GEOCODING = new KLGoogleGeoRecordType('GOOGLE_REVERSE_GEOCODING','GOOGLE_REVERSE_GEOCODING','Google逆地理编码');

    // 文本搜索缓存
    static readonly TEXT_SEARCH_CACHE = new KLGoogleGeoRecordType('TEXT_SEARCH_CACHE','TEXT_SEARCH_CACHE','文本搜索缓存');

    // 附近搜索缓存
    static readonly NEARBY_SEARCH_CACHE = new KLGoogleGeoRecordType('NEARBY_SEARCH_CACHE','NEARBY_SEARCH_CACHE','附近搜索缓存');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLGoogleGeoRecordType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GOOGLE_ROUTE_PLANNING','GOOGLE_ROUTE_PLANNING','Google路线规划'),
            new KLEnumCase<string>('GOOGLE_REVERSE_GEOCODING','GOOGLE_REVERSE_GEOCODING','Google逆地理编码'),
            new KLEnumCase<string>('TEXT_SEARCH_CACHE','TEXT_SEARCH_CACHE','文本搜索缓存'),
            new KLEnumCase<string>('NEARBY_SEARCH_CACHE','NEARBY_SEARCH_CACHE','附近搜索缓存'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLGoogleGeoRecordType|null {
        switch (val) {
            case KLGoogleGeoRecordType.GOOGLE_ROUTE_PLANNING.value:return KLGoogleGeoRecordType.GOOGLE_ROUTE_PLANNING;
            case KLGoogleGeoRecordType.GOOGLE_REVERSE_GEOCODING.value:return KLGoogleGeoRecordType.GOOGLE_REVERSE_GEOCODING;
            case KLGoogleGeoRecordType.TEXT_SEARCH_CACHE.value:return KLGoogleGeoRecordType.TEXT_SEARCH_CACHE;
            case KLGoogleGeoRecordType.NEARBY_SEARCH_CACHE.value:return KLGoogleGeoRecordType.NEARBY_SEARCH_CACHE;
        }
        return null;
    }
}

/**
 * 商家端账号角色
*/
export class KLMerchantAccountRole extends KLEnum<string>{

    // Merchant manager
    static readonly MERCHANT_MANAGER = new KLMerchantAccountRole('MERCHANT_MANAGER','MERCHANT_MANAGER','Merchant manager');

    // Merchant viewer
    static readonly MERCHANT_VIEWER = new KLMerchantAccountRole('MERCHANT_VIEWER','MERCHANT_VIEWER','Merchant viewer');

    // Store manager
    static readonly STORE_MANAGER = new KLMerchantAccountRole('STORE_MANAGER','STORE_MANAGER','Store manager');

    // Store viewer
    static readonly STORE_VIEWER = new KLMerchantAccountRole('STORE_VIEWER','STORE_VIEWER','Store viewer');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMerchantAccountRole.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MERCHANT_MANAGER','MERCHANT_MANAGER','Merchant manager'),
            new KLEnumCase<string>('MERCHANT_VIEWER','MERCHANT_VIEWER','Merchant viewer'),
            new KLEnumCase<string>('STORE_MANAGER','STORE_MANAGER','Store manager'),
            new KLEnumCase<string>('STORE_VIEWER','STORE_VIEWER','Store viewer'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMerchantAccountRole|null {
        switch (val) {
            case KLMerchantAccountRole.MERCHANT_MANAGER.value:return KLMerchantAccountRole.MERCHANT_MANAGER;
            case KLMerchantAccountRole.MERCHANT_VIEWER.value:return KLMerchantAccountRole.MERCHANT_VIEWER;
            case KLMerchantAccountRole.STORE_MANAGER.value:return KLMerchantAccountRole.STORE_MANAGER;
            case KLMerchantAccountRole.STORE_VIEWER.value:return KLMerchantAccountRole.STORE_VIEWER;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMerchantBusinessScopes extends KLEnum<string>{

    // 商城
    static readonly MALL = new KLMerchantBusinessScopes('MALL','MALL','商城');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMerchantBusinessScopes.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL','MALL','商城'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMerchantBusinessScopes|null {
        switch (val) {
            case KLMerchantBusinessScopes.MALL.value:return KLMerchantBusinessScopes.MALL;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMerchantStatus extends KLEnum<string>{

    // 待处理
    static readonly PENDING = new KLMerchantStatus('PENDING','PENDING','待处理');

    // 活跃
    static readonly ACTIVE = new KLMerchantStatus('ACTIVE','ACTIVE','活跃');

    // 不活跃
    static readonly INACTIVE = new KLMerchantStatus('INACTIVE','INACTIVE','不活跃');

    // 暂停
    static readonly SUSPENDED = new KLMerchantStatus('SUSPENDED','SUSPENDED','暂停');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMerchantStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','待处理'),
            new KLEnumCase<string>('ACTIVE','ACTIVE','活跃'),
            new KLEnumCase<string>('INACTIVE','INACTIVE','不活跃'),
            new KLEnumCase<string>('SUSPENDED','SUSPENDED','暂停'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMerchantStatus|null {
        switch (val) {
            case KLMerchantStatus.PENDING.value:return KLMerchantStatus.PENDING;
            case KLMerchantStatus.ACTIVE.value:return KLMerchantStatus.ACTIVE;
            case KLMerchantStatus.INACTIVE.value:return KLMerchantStatus.INACTIVE;
            case KLMerchantStatus.SUSPENDED.value:return KLMerchantStatus.SUSPENDED;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMerchantSubAccountStatus extends KLEnum<string>{

    // Normal
    static readonly NORMAL = new KLMerchantSubAccountStatus('NORMAL','NORMAL','Normal');

    // Suspended
    static readonly SUSPENDED = new KLMerchantSubAccountStatus('SUSPENDED','SUSPENDED','Suspended');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMerchantSubAccountStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NORMAL','NORMAL','Normal'),
            new KLEnumCase<string>('SUSPENDED','SUSPENDED','Suspended'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMerchantSubAccountStatus|null {
        switch (val) {
            case KLMerchantSubAccountStatus.NORMAL.value:return KLMerchantSubAccountStatus.NORMAL;
            case KLMerchantSubAccountStatus.SUSPENDED.value:return KLMerchantSubAccountStatus.SUSPENDED;
        }
        return null;
    }
}

/**
 * 商户钱包货币
*/
export class KLMerchantWalletCurrency extends KLEnum<string>{

    // 菲律宾比索
    static readonly PHP = new KLMerchantWalletCurrency('PHP','PHP','菲律宾比索');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMerchantWalletCurrency.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PHP','PHP','菲律宾比索'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMerchantWalletCurrency|null {
        switch (val) {
            case KLMerchantWalletCurrency.PHP.value:return KLMerchantWalletCurrency.PHP;
        }
        return null;
    }
}

/**
 * OAuth平台
*/
export class KLOAuthPlatform extends KLEnum<string>{

    // 谷歌
    static readonly GOOGLE = new KLOAuthPlatform('GOOGLE','GOOGLE','谷歌');

    // 苹果
    static readonly APPLE = new KLOAuthPlatform('APPLE','APPLE','苹果');

    // 脸书
    static readonly FACEBOOK = new KLOAuthPlatform('FACEBOOK','FACEBOOK','脸书');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLOAuthPlatform.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GOOGLE','GOOGLE','谷歌'),
            new KLEnumCase<string>('APPLE','APPLE','苹果'),
            new KLEnumCase<string>('FACEBOOK','FACEBOOK','脸书'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLOAuthPlatform|null {
        switch (val) {
            case KLOAuthPlatform.GOOGLE.value:return KLOAuthPlatform.GOOGLE;
            case KLOAuthPlatform.APPLE.value:return KLOAuthPlatform.APPLE;
            case KLOAuthPlatform.FACEBOOK.value:return KLOAuthPlatform.FACEBOOK;
        }
        return null;
    }
}

/**
 * 订单Tab类型
*/
export class KLOrderTab extends KLEnum<string>{

    // All
    static readonly ALL = new KLOrderTab('ALL','all','All');

    // Pending
    static readonly PENDING = new KLOrderTab('PENDING','pending','Pending');

    // Completed
    static readonly COMPLETED = new KLOrderTab('COMPLETED','completed','Completed');

    // Refund/Cancel
    static readonly REFUND_CANCEL = new KLOrderTab('REFUND_CANCEL','refund_cancel','Refund/Cancel');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLOrderTab.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','all','All'),
            new KLEnumCase<string>('PENDING','pending','Pending'),
            new KLEnumCase<string>('COMPLETED','completed','Completed'),
            new KLEnumCase<string>('REFUND_CANCEL','refund_cancel','Refund/Cancel'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLOrderTab|null {
        switch (val) {
            case KLOrderTab.ALL.value:return KLOrderTab.ALL;
            case KLOrderTab.PENDING.value:return KLOrderTab.PENDING;
            case KLOrderTab.COMPLETED.value:return KLOrderTab.COMPLETED;
            case KLOrderTab.REFUND_CANCEL.value:return KLOrderTab.REFUND_CANCEL;
        }
        return null;
    }
}

/**
 * 售后状态
*/
export class KLUnionOrderAfterSaleStatus extends KLEnum<string>{

    // Not Applied
    static readonly NOT_APPLIED = new KLUnionOrderAfterSaleStatus('NOT_APPLIED','NOT_APPLIED','Not Applied');

    // Applying
    static readonly APPLYING = new KLUnionOrderAfterSaleStatus('APPLYING','APPLYING','Applying');

    // Processing
    static readonly PROCESSING = new KLUnionOrderAfterSaleStatus('PROCESSING','PROCESSING','Processing');

    // Rejected
    static readonly REJECTED = new KLUnionOrderAfterSaleStatus('REJECTED','REJECTED','Rejected');

    // Completed
    static readonly COMPLETED = new KLUnionOrderAfterSaleStatus('COMPLETED','COMPLETED','Completed');

    // Cancelled
    static readonly CANCELLED = new KLUnionOrderAfterSaleStatus('CANCELLED','CANCELLED','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUnionOrderAfterSaleStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_APPLIED','NOT_APPLIED','Not Applied'),
            new KLEnumCase<string>('APPLYING','APPLYING','Applying'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','Processing'),
            new KLEnumCase<string>('REJECTED','REJECTED','Rejected'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUnionOrderAfterSaleStatus|null {
        switch (val) {
            case KLUnionOrderAfterSaleStatus.NOT_APPLIED.value:return KLUnionOrderAfterSaleStatus.NOT_APPLIED;
            case KLUnionOrderAfterSaleStatus.APPLYING.value:return KLUnionOrderAfterSaleStatus.APPLYING;
            case KLUnionOrderAfterSaleStatus.PROCESSING.value:return KLUnionOrderAfterSaleStatus.PROCESSING;
            case KLUnionOrderAfterSaleStatus.REJECTED.value:return KLUnionOrderAfterSaleStatus.REJECTED;
            case KLUnionOrderAfterSaleStatus.COMPLETED.value:return KLUnionOrderAfterSaleStatus.COMPLETED;
            case KLUnionOrderAfterSaleStatus.CANCELLED.value:return KLUnionOrderAfterSaleStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 联合订单类型
*/
export class KLUnionOrderBusinessType extends KLEnum<string>{

    // Recharge
    static readonly RECHARGE = new KLUnionOrderBusinessType('RECHARGE','RECHARGE','Recharge');

    // Mall
    static readonly MALL = new KLUnionOrderBusinessType('MALL','MALL','Mall');

    // Mall merge
    static readonly MALL_MERGE = new KLUnionOrderBusinessType('MALL_MERGE','MALL_MERGE','Mall merge');

    // Rejection
    static readonly REJECTION = new KLUnionOrderBusinessType('REJECTION','REJECTION','Rejection');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUnionOrderBusinessType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('RECHARGE','RECHARGE','Recharge'),
            new KLEnumCase<string>('MALL','MALL','Mall'),
            new KLEnumCase<string>('MALL_MERGE','MALL_MERGE','Mall merge'),
            new KLEnumCase<string>('REJECTION','REJECTION','Rejection'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUnionOrderBusinessType|null {
        switch (val) {
            case KLUnionOrderBusinessType.RECHARGE.value:return KLUnionOrderBusinessType.RECHARGE;
            case KLUnionOrderBusinessType.MALL.value:return KLUnionOrderBusinessType.MALL;
            case KLUnionOrderBusinessType.MALL_MERGE.value:return KLUnionOrderBusinessType.MALL_MERGE;
            case KLUnionOrderBusinessType.REJECTION.value:return KLUnionOrderBusinessType.REJECTION;
        }
        return null;
    }
}

/**
 * 支付状态
*/
export class KLUnionOrderPayStatus extends KLEnum<string>{

    // Unpaid
    static readonly NOT_PAID = new KLUnionOrderPayStatus('NOT_PAID','NOT_PAID','Unpaid');

    // Paid
    static readonly PAID = new KLUnionOrderPayStatus('PAID','PAID','Paid');

    // Partially refunded
    static readonly PARTIALLY_REFUNDED = new KLUnionOrderPayStatus('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially refunded');

    // Refunded
    static readonly REFUNDED = new KLUnionOrderPayStatus('REFUNDED','REFUNDED','Refunded');

    // Cancelled
    static readonly CANCELLED = new KLUnionOrderPayStatus('CANCELLED','CANCELLED','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUnionOrderPayStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_PAID','NOT_PAID','Unpaid'),
            new KLEnumCase<string>('PAID','PAID','Paid'),
            new KLEnumCase<string>('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially refunded'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUnionOrderPayStatus|null {
        switch (val) {
            case KLUnionOrderPayStatus.NOT_PAID.value:return KLUnionOrderPayStatus.NOT_PAID;
            case KLUnionOrderPayStatus.PAID.value:return KLUnionOrderPayStatus.PAID;
            case KLUnionOrderPayStatus.PARTIALLY_REFUNDED.value:return KLUnionOrderPayStatus.PARTIALLY_REFUNDED;
            case KLUnionOrderPayStatus.REFUNDED.value:return KLUnionOrderPayStatus.REFUNDED;
            case KLUnionOrderPayStatus.CANCELLED.value:return KLUnionOrderPayStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 联合订单配送状态
*/
export class KLUnionOrderShippingStatus extends KLEnum<string>{

    // Not Shipped
    static readonly NOT_SHIPPED = new KLUnionOrderShippingStatus('NOT_SHIPPED','NOT_SHIPPED','Not Shipped');

    // Packing - Rider Not Assigned
    static readonly PACKING_PENDING = new KLUnionOrderShippingStatus('PACKING_PENDING','PACKING_PENDING','Packing - Rider Not Assigned');

    // Packing - Rider Assigned
    static readonly PACKING_ACCEPTED = new KLUnionOrderShippingStatus('PACKING_ACCEPTED','PACKING_ACCEPTED','Packing - Rider Assigned');

    // Picking Up
    static readonly PICKING_UP = new KLUnionOrderShippingStatus('PICKING_UP','PICKING_UP','Picking Up');

    // Delivering
    static readonly DELIVERING = new KLUnionOrderShippingStatus('DELIVERING','DELIVERING','Delivering');

    // Arrived
    static readonly ARRIVED = new KLUnionOrderShippingStatus('ARRIVED','ARRIVED','Arrived');

    // Delivered
    static readonly DELIVERED = new KLUnionOrderShippingStatus('DELIVERED','DELIVERED','Delivered');

    // Self Pickup
    static readonly SELF_PICKUP = new KLUnionOrderShippingStatus('SELF_PICKUP','SELF_PICKUP','Self Pickup');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUnionOrderShippingStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_SHIPPED','NOT_SHIPPED','Not Shipped'),
            new KLEnumCase<string>('PACKING_PENDING','PACKING_PENDING','Packing - Rider Not Assigned'),
            new KLEnumCase<string>('PACKING_ACCEPTED','PACKING_ACCEPTED','Packing - Rider Assigned'),
            new KLEnumCase<string>('PICKING_UP','PICKING_UP','Picking Up'),
            new KLEnumCase<string>('DELIVERING','DELIVERING','Delivering'),
            new KLEnumCase<string>('ARRIVED','ARRIVED','Arrived'),
            new KLEnumCase<string>('DELIVERED','DELIVERED','Delivered'),
            new KLEnumCase<string>('SELF_PICKUP','SELF_PICKUP','Self Pickup'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUnionOrderShippingStatus|null {
        switch (val) {
            case KLUnionOrderShippingStatus.NOT_SHIPPED.value:return KLUnionOrderShippingStatus.NOT_SHIPPED;
            case KLUnionOrderShippingStatus.PACKING_PENDING.value:return KLUnionOrderShippingStatus.PACKING_PENDING;
            case KLUnionOrderShippingStatus.PACKING_ACCEPTED.value:return KLUnionOrderShippingStatus.PACKING_ACCEPTED;
            case KLUnionOrderShippingStatus.PICKING_UP.value:return KLUnionOrderShippingStatus.PICKING_UP;
            case KLUnionOrderShippingStatus.DELIVERING.value:return KLUnionOrderShippingStatus.DELIVERING;
            case KLUnionOrderShippingStatus.ARRIVED.value:return KLUnionOrderShippingStatus.ARRIVED;
            case KLUnionOrderShippingStatus.DELIVERED.value:return KLUnionOrderShippingStatus.DELIVERED;
            case KLUnionOrderShippingStatus.SELF_PICKUP.value:return KLUnionOrderShippingStatus.SELF_PICKUP;
        }
        return null;
    }
}

/**
 * 订单状态
*/
export class KLUnionOrderStatus extends KLEnum<string>{

    // Pending Payment
    static readonly PENDING = new KLUnionOrderStatus('PENDING','PENDING','Pending Payment');

    // Awaiting Shipment
    static readonly AWAITING_STOCK = new KLUnionOrderStatus('AWAITING_STOCK','AWAITING_STOCK','Awaiting Shipment');

    // Shipped
    static readonly SHIPPED = new KLUnionOrderStatus('SHIPPED','SHIPPED','Shipped');

    // Completed
    static readonly COMPLETED = new KLUnionOrderStatus('COMPLETED','COMPLETED','Completed');

    // Cancelled
    static readonly CANCELLED = new KLUnionOrderStatus('CANCELLED','CANCELLED','Cancelled');

    // Refunded
    static readonly REFUNDED = new KLUnionOrderStatus('REFUNDED','REFUNDED','Refunded');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUnionOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending Payment'),
            new KLEnumCase<string>('AWAITING_STOCK','AWAITING_STOCK','Awaiting Shipment'),
            new KLEnumCase<string>('SHIPPED','SHIPPED','Shipped'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUnionOrderStatus|null {
        switch (val) {
            case KLUnionOrderStatus.PENDING.value:return KLUnionOrderStatus.PENDING;
            case KLUnionOrderStatus.AWAITING_STOCK.value:return KLUnionOrderStatus.AWAITING_STOCK;
            case KLUnionOrderStatus.SHIPPED.value:return KLUnionOrderStatus.SHIPPED;
            case KLUnionOrderStatus.COMPLETED.value:return KLUnionOrderStatus.COMPLETED;
            case KLUnionOrderStatus.CANCELLED.value:return KLUnionOrderStatus.CANCELLED;
            case KLUnionOrderStatus.REFUNDED.value:return KLUnionOrderStatus.REFUNDED;
        }
        return null;
    }
}

/**
 * 用户订单类型
*/
export class KLUserOrderType extends KLEnum<string>{

    // 商城
    static readonly MALL = new KLUserOrderType('MALL','mall','商城');

    // 充值
    static readonly RECHARGE = new KLUserOrderType('RECHARGE','recharge','充值');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserOrderType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL','mall','商城'),
            new KLEnumCase<string>('RECHARGE','recharge','充值'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserOrderType|null {
        switch (val) {
            case KLUserOrderType.MALL.value:return KLUserOrderType.MALL;
            case KLUserOrderType.RECHARGE.value:return KLUserOrderType.RECHARGE;
        }
        return null;
    }
}

/**
 * 生物识别强制密码原因
*/
export class KLBiometricForcePasswordReason extends KLEnum<string>{

    // New Device First Pay
    static readonly NEW_DEVICE_FIRST_PAY = new KLBiometricForcePasswordReason('NEW_DEVICE_FIRST_PAY','NEW_DEVICE_FIRST_PAY','New Device First Pay');

    // High Amount
    static readonly HIGH_AMOUNT = new KLBiometricForcePasswordReason('HIGH_AMOUNT','HIGH_AMOUNT','High Amount');

    // Geo Anomaly
    static readonly GEO_ANOMALY = new KLBiometricForcePasswordReason('GEO_ANOMALY','GEO_ANOMALY','Geo Anomaly');

    // Password Changed
    static readonly PASSWORD_CHANGED = new KLBiometricForcePasswordReason('PASSWORD_CHANGED','PASSWORD_CHANGED','Password Changed');

    // Not Enabled
    static readonly NOT_ENABLED = new KLBiometricForcePasswordReason('NOT_ENABLED','NOT_ENABLED','Not Enabled');

    // Device Risk
    static readonly DEVICE_RISK = new KLBiometricForcePasswordReason('DEVICE_RISK','DEVICE_RISK','Device Risk');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLBiometricForcePasswordReason.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NEW_DEVICE_FIRST_PAY','NEW_DEVICE_FIRST_PAY','New Device First Pay'),
            new KLEnumCase<string>('HIGH_AMOUNT','HIGH_AMOUNT','High Amount'),
            new KLEnumCase<string>('GEO_ANOMALY','GEO_ANOMALY','Geo Anomaly'),
            new KLEnumCase<string>('PASSWORD_CHANGED','PASSWORD_CHANGED','Password Changed'),
            new KLEnumCase<string>('NOT_ENABLED','NOT_ENABLED','Not Enabled'),
            new KLEnumCase<string>('DEVICE_RISK','DEVICE_RISK','Device Risk'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLBiometricForcePasswordReason|null {
        switch (val) {
            case KLBiometricForcePasswordReason.NEW_DEVICE_FIRST_PAY.value:return KLBiometricForcePasswordReason.NEW_DEVICE_FIRST_PAY;
            case KLBiometricForcePasswordReason.HIGH_AMOUNT.value:return KLBiometricForcePasswordReason.HIGH_AMOUNT;
            case KLBiometricForcePasswordReason.GEO_ANOMALY.value:return KLBiometricForcePasswordReason.GEO_ANOMALY;
            case KLBiometricForcePasswordReason.PASSWORD_CHANGED.value:return KLBiometricForcePasswordReason.PASSWORD_CHANGED;
            case KLBiometricForcePasswordReason.NOT_ENABLED.value:return KLBiometricForcePasswordReason.NOT_ENABLED;
            case KLBiometricForcePasswordReason.DEVICE_RISK.value:return KLBiometricForcePasswordReason.DEVICE_RISK;
        }
        return null;
    }
}

/**
 * 生物识别支付设置项
*/
export class KLBiometricPaySettingsField extends KLEnum<string>{

    // Fingerprint pay switch
    static readonly FINGERPRINT_PAY = new KLBiometricPaySettingsField('FINGERPRINT_PAY','fingerprint_pay','Fingerprint pay switch');

    // Face pay switch
    static readonly FACE_PAY = new KLBiometricPaySettingsField('FACE_PAY','face_pay','Face pay switch');

    // Preferred biometric type
    static readonly BIOMETRIC_PAY_TYPE = new KLBiometricPaySettingsField('BIOMETRIC_PAY_TYPE','biometric_pay_type','Preferred biometric type');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLBiometricPaySettingsField.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FINGERPRINT_PAY','fingerprint_pay','Fingerprint pay switch'),
            new KLEnumCase<string>('FACE_PAY','face_pay','Face pay switch'),
            new KLEnumCase<string>('BIOMETRIC_PAY_TYPE','biometric_pay_type','Preferred biometric type'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLBiometricPaySettingsField|null {
        switch (val) {
            case KLBiometricPaySettingsField.FINGERPRINT_PAY.value:return KLBiometricPaySettingsField.FINGERPRINT_PAY;
            case KLBiometricPaySettingsField.FACE_PAY.value:return KLBiometricPaySettingsField.FACE_PAY;
            case KLBiometricPaySettingsField.BIOMETRIC_PAY_TYPE.value:return KLBiometricPaySettingsField.BIOMETRIC_PAY_TYPE;
        }
        return null;
    }
}

/**
 * 生物识别支付风控级别
*/
export class KLPaymentBiometricRiskLevel extends KLEnum<number>{

    // Normal
    static readonly NORMAL = new KLPaymentBiometricRiskLevel('NORMAL',0,'Normal');

    // Watch
    static readonly WATCH = new KLPaymentBiometricRiskLevel('WATCH',1,'Watch');

    // High Risk
    static readonly HIGH = new KLPaymentBiometricRiskLevel('HIGH',2,'High Risk');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLPaymentBiometricRiskLevel.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('NORMAL',0,'Normal'),
            new KLEnumCase<number>('WATCH',1,'Watch'),
            new KLEnumCase<number>('HIGH',2,'High Risk'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLPaymentBiometricRiskLevel|null {
        switch (val) {
            case KLPaymentBiometricRiskLevel.NORMAL.value:return KLPaymentBiometricRiskLevel.NORMAL;
            case KLPaymentBiometricRiskLevel.WATCH.value:return KLPaymentBiometricRiskLevel.WATCH;
            case KLPaymentBiometricRiskLevel.HIGH.value:return KLPaymentBiometricRiskLevel.HIGH;
        }
        return null;
    }
}

/**
 * 生物识别会话状态
*/
export class KLPaymentBiometricSessionStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING = new KLPaymentBiometricSessionStatus('PENDING','PENDING','Pending');

    // Success
    static readonly SUCCESS = new KLPaymentBiometricSessionStatus('SUCCESS','SUCCESS','Success');

    // Failed
    static readonly FAILED = new KLPaymentBiometricSessionStatus('FAILED','FAILED','Failed');

    // Locked Out
    static readonly LOCKED_OUT = new KLPaymentBiometricSessionStatus('LOCKED_OUT','LOCKED_OUT','Locked Out');

    // Canceled
    static readonly CANCELED = new KLPaymentBiometricSessionStatus('CANCELED','CANCELED','Canceled');

    // Expired
    static readonly EXPIRED = new KLPaymentBiometricSessionStatus('EXPIRED','EXPIRED','Expired');

    // Not Supported
    static readonly NOT_SUPPORTED = new KLPaymentBiometricSessionStatus('NOT_SUPPORTED','NOT_SUPPORTED','Not Supported');

    // Not Enrolled
    static readonly NOT_ENROLLED = new KLPaymentBiometricSessionStatus('NOT_ENROLLED','NOT_ENROLLED','Not Enrolled');

    // Fallback Password
    static readonly FALLBACK_PASSWORD = new KLPaymentBiometricSessionStatus('FALLBACK_PASSWORD','FALLBACK_PASSWORD','Fallback Password');

    // Used
    static readonly USED = new KLPaymentBiometricSessionStatus('USED','USED','Used');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentBiometricSessionStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('SUCCESS','SUCCESS','Success'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
            new KLEnumCase<string>('LOCKED_OUT','LOCKED_OUT','Locked Out'),
            new KLEnumCase<string>('CANCELED','CANCELED','Canceled'),
            new KLEnumCase<string>('EXPIRED','EXPIRED','Expired'),
            new KLEnumCase<string>('NOT_SUPPORTED','NOT_SUPPORTED','Not Supported'),
            new KLEnumCase<string>('NOT_ENROLLED','NOT_ENROLLED','Not Enrolled'),
            new KLEnumCase<string>('FALLBACK_PASSWORD','FALLBACK_PASSWORD','Fallback Password'),
            new KLEnumCase<string>('USED','USED','Used'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentBiometricSessionStatus|null {
        switch (val) {
            case KLPaymentBiometricSessionStatus.PENDING.value:return KLPaymentBiometricSessionStatus.PENDING;
            case KLPaymentBiometricSessionStatus.SUCCESS.value:return KLPaymentBiometricSessionStatus.SUCCESS;
            case KLPaymentBiometricSessionStatus.FAILED.value:return KLPaymentBiometricSessionStatus.FAILED;
            case KLPaymentBiometricSessionStatus.LOCKED_OUT.value:return KLPaymentBiometricSessionStatus.LOCKED_OUT;
            case KLPaymentBiometricSessionStatus.CANCELED.value:return KLPaymentBiometricSessionStatus.CANCELED;
            case KLPaymentBiometricSessionStatus.EXPIRED.value:return KLPaymentBiometricSessionStatus.EXPIRED;
            case KLPaymentBiometricSessionStatus.NOT_SUPPORTED.value:return KLPaymentBiometricSessionStatus.NOT_SUPPORTED;
            case KLPaymentBiometricSessionStatus.NOT_ENROLLED.value:return KLPaymentBiometricSessionStatus.NOT_ENROLLED;
            case KLPaymentBiometricSessionStatus.FALLBACK_PASSWORD.value:return KLPaymentBiometricSessionStatus.FALLBACK_PASSWORD;
            case KLPaymentBiometricSessionStatus.USED.value:return KLPaymentBiometricSessionStatus.USED;
        }
        return null;
    }
}

/**
 * 生物识别类型
*/
export class KLPaymentBiometricType extends KLEnum<string>{

    // Fingerprint
    static readonly FINGERPRINT = new KLPaymentBiometricType('FINGERPRINT','FINGERPRINT','Fingerprint');

    // Face
    static readonly FACE = new KLPaymentBiometricType('FACE','FACE','Face');

    // None
    static readonly NONE = new KLPaymentBiometricType('NONE','NONE','None');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentBiometricType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FINGERPRINT','FINGERPRINT','Fingerprint'),
            new KLEnumCase<string>('FACE','FACE','Face'),
            new KLEnumCase<string>('NONE','NONE','None'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentBiometricType|null {
        switch (val) {
            case KLPaymentBiometricType.FINGERPRINT.value:return KLPaymentBiometricType.FINGERPRINT;
            case KLPaymentBiometricType.FACE.value:return KLPaymentBiometricType.FACE;
            case KLPaymentBiometricType.NONE.value:return KLPaymentBiometricType.NONE;
        }
        return null;
    }
}

/**
 * 支付渠道
*/
export class KLPaymentChannel extends KLEnum<string>{

    // 余额支付
    static readonly BALANCE = new KLPaymentChannel('BALANCE','BALANCE','余额支付');

    // 货到付款
    static readonly COD = new KLPaymentChannel('COD','COD','货到付款');

    // USDT支付
    static readonly USDT = new KLPaymentChannel('USDT','USDT','USDT支付');

    // Fucent GCash支付
    static readonly FUCENT_GCASH = new KLPaymentChannel('FUCENT_GCASH','FUCENT_GCASH','Fucent GCash支付');

    // Fucent Grab支付
    static readonly FUCENT_GRAB = new KLPaymentChannel('FUCENT_GRAB','FUCENT_GRAB','Fucent Grab支付');

    // Fucent 微信支付
    static readonly FUCENT_WECHAT_PAY = new KLPaymentChannel('FUCENT_WECHAT_PAY','FUCENT_WECHAT_PAY','Fucent 微信支付');

    // Fucent 支付宝支付
    static readonly FUCENT_ALI_PAY = new KLPaymentChannel('FUCENT_ALI_PAY','FUCENT_ALI_PAY','Fucent 支付宝支付');

    // Fucent Maya支付
    static readonly FUCENT_MAYA = new KLPaymentChannel('FUCENT_MAYA','FUCENT_MAYA','Fucent Maya支付');

    // Fucent 银联支付
    static readonly FUCENT_UNIONPAY = new KLPaymentChannel('FUCENT_UNIONPAY','FUCENT_UNIONPAY','Fucent 银联支付');

    // UU Wallet支付
    static readonly UU_WALLET = new KLPaymentChannel('UU_WALLET','UU_WALLET','UU Wallet支付');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentChannel.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('BALANCE','BALANCE','余额支付'),
            new KLEnumCase<string>('COD','COD','货到付款'),
            new KLEnumCase<string>('USDT','USDT','USDT支付'),
            new KLEnumCase<string>('FUCENT_GCASH','FUCENT_GCASH','Fucent GCash支付'),
            new KLEnumCase<string>('FUCENT_GRAB','FUCENT_GRAB','Fucent Grab支付'),
            new KLEnumCase<string>('FUCENT_WECHAT_PAY','FUCENT_WECHAT_PAY','Fucent 微信支付'),
            new KLEnumCase<string>('FUCENT_ALI_PAY','FUCENT_ALI_PAY','Fucent 支付宝支付'),
            new KLEnumCase<string>('FUCENT_MAYA','FUCENT_MAYA','Fucent Maya支付'),
            new KLEnumCase<string>('FUCENT_UNIONPAY','FUCENT_UNIONPAY','Fucent 银联支付'),
            new KLEnumCase<string>('UU_WALLET','UU_WALLET','UU Wallet支付'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentChannel|null {
        switch (val) {
            case KLPaymentChannel.BALANCE.value:return KLPaymentChannel.BALANCE;
            case KLPaymentChannel.COD.value:return KLPaymentChannel.COD;
            case KLPaymentChannel.USDT.value:return KLPaymentChannel.USDT;
            case KLPaymentChannel.FUCENT_GCASH.value:return KLPaymentChannel.FUCENT_GCASH;
            case KLPaymentChannel.FUCENT_GRAB.value:return KLPaymentChannel.FUCENT_GRAB;
            case KLPaymentChannel.FUCENT_WECHAT_PAY.value:return KLPaymentChannel.FUCENT_WECHAT_PAY;
            case KLPaymentChannel.FUCENT_ALI_PAY.value:return KLPaymentChannel.FUCENT_ALI_PAY;
            case KLPaymentChannel.FUCENT_MAYA.value:return KLPaymentChannel.FUCENT_MAYA;
            case KLPaymentChannel.FUCENT_UNIONPAY.value:return KLPaymentChannel.FUCENT_UNIONPAY;
            case KLPaymentChannel.UU_WALLET.value:return KLPaymentChannel.UU_WALLET;
        }
        return null;
    }
}

/**
 * 支付意图业务类型
*/
export class KLPaymentIntentBizType extends KLEnum<string>{

    // Mall
    static readonly MALL = new KLPaymentIntentBizType('MALL','MALL','Mall');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentIntentBizType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL','MALL','Mall'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentIntentBizType|null {
        switch (val) {
            case KLPaymentIntentBizType.MALL.value:return KLPaymentIntentBizType.MALL;
        }
        return null;
    }
}

/**
 * 支付意图状态
*/
export class KLPaymentIntentStatus extends KLEnum<string>{

    // Created
    static readonly CREATED = new KLPaymentIntentStatus('CREATED','CREATED','Created');

    // Awaiting Verify
    static readonly AWAITING_VERIFY = new KLPaymentIntentStatus('AWAITING_VERIFY','AWAITING_VERIFY','Awaiting Verify');

    // Verify Passed
    static readonly VERIFY_PASSED = new KLPaymentIntentStatus('VERIFY_PASSED','VERIFY_PASSED','Verify Passed');

    // Paying
    static readonly PAYING = new KLPaymentIntentStatus('PAYING','PAYING','Paying');

    // Paid
    static readonly PAID = new KLPaymentIntentStatus('PAID','PAID','Paid');

    // Pay Failed
    static readonly PAY_FAILED = new KLPaymentIntentStatus('PAY_FAILED','PAY_FAILED','Pay Failed');

    // Canceled
    static readonly CANCELED = new KLPaymentIntentStatus('CANCELED','CANCELED','Canceled');

    // Expired
    static readonly EXPIRED = new KLPaymentIntentStatus('EXPIRED','EXPIRED','Expired');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentIntentStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CREATED','CREATED','Created'),
            new KLEnumCase<string>('AWAITING_VERIFY','AWAITING_VERIFY','Awaiting Verify'),
            new KLEnumCase<string>('VERIFY_PASSED','VERIFY_PASSED','Verify Passed'),
            new KLEnumCase<string>('PAYING','PAYING','Paying'),
            new KLEnumCase<string>('PAID','PAID','Paid'),
            new KLEnumCase<string>('PAY_FAILED','PAY_FAILED','Pay Failed'),
            new KLEnumCase<string>('CANCELED','CANCELED','Canceled'),
            new KLEnumCase<string>('EXPIRED','EXPIRED','Expired'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentIntentStatus|null {
        switch (val) {
            case KLPaymentIntentStatus.CREATED.value:return KLPaymentIntentStatus.CREATED;
            case KLPaymentIntentStatus.AWAITING_VERIFY.value:return KLPaymentIntentStatus.AWAITING_VERIFY;
            case KLPaymentIntentStatus.VERIFY_PASSED.value:return KLPaymentIntentStatus.VERIFY_PASSED;
            case KLPaymentIntentStatus.PAYING.value:return KLPaymentIntentStatus.PAYING;
            case KLPaymentIntentStatus.PAID.value:return KLPaymentIntentStatus.PAID;
            case KLPaymentIntentStatus.PAY_FAILED.value:return KLPaymentIntentStatus.PAY_FAILED;
            case KLPaymentIntentStatus.CANCELED.value:return KLPaymentIntentStatus.CANCELED;
            case KLPaymentIntentStatus.EXPIRED.value:return KLPaymentIntentStatus.EXPIRED;
        }
        return null;
    }
}

/**
 * 支付意图验证方式
*/
export class KLPaymentIntentVerificationMode extends KLEnum<string>{

    // Biometric
    static readonly BIOMETRIC = new KLPaymentIntentVerificationMode('BIOMETRIC','BIOMETRIC','Biometric');

    // Payment Password
    static readonly PAYMENT_PASSWORD = new KLPaymentIntentVerificationMode('PAYMENT_PASSWORD','PAYMENT_PASSWORD','Payment Password');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentIntentVerificationMode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('BIOMETRIC','BIOMETRIC','Biometric'),
            new KLEnumCase<string>('PAYMENT_PASSWORD','PAYMENT_PASSWORD','Payment Password'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentIntentVerificationMode|null {
        switch (val) {
            case KLPaymentIntentVerificationMode.BIOMETRIC.value:return KLPaymentIntentVerificationMode.BIOMETRIC;
            case KLPaymentIntentVerificationMode.PAYMENT_PASSWORD.value:return KLPaymentIntentVerificationMode.PAYMENT_PASSWORD;
        }
        return null;
    }
}

/**
 * 在线支付渠道
*/
export class KLPaymentOnlineChannel extends KLEnum<string>{

    // GCASH
    static readonly GCASH = new KLPaymentOnlineChannel('GCASH','GCASH','GCASH');

    // 微信支付
    static readonly WECHAT = new KLPaymentOnlineChannel('WECHAT','WECHAT','微信支付');

    // 支付宝
    static readonly ALIPAY = new KLPaymentOnlineChannel('ALIPAY','ALIPAY','支付宝');

    // GRAB
    static readonly GRAB = new KLPaymentOnlineChannel('GRAB','GRAB','GRAB');

    // MAYA
    static readonly MAYA = new KLPaymentOnlineChannel('MAYA','MAYA','MAYA');

    // UNIONPAY
    static readonly UNIONPAY = new KLPaymentOnlineChannel('UNIONPAY','UNIONPAY','UNIONPAY');

    // USDT
    static readonly USDT = new KLPaymentOnlineChannel('USDT','USDT','USDT');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOnlineChannel.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GCASH','GCASH','GCASH'),
            new KLEnumCase<string>('WECHAT','WECHAT','微信支付'),
            new KLEnumCase<string>('ALIPAY','ALIPAY','支付宝'),
            new KLEnumCase<string>('GRAB','GRAB','GRAB'),
            new KLEnumCase<string>('MAYA','MAYA','MAYA'),
            new KLEnumCase<string>('UNIONPAY','UNIONPAY','UNIONPAY'),
            new KLEnumCase<string>('USDT','USDT','USDT'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOnlineChannel|null {
        switch (val) {
            case KLPaymentOnlineChannel.GCASH.value:return KLPaymentOnlineChannel.GCASH;
            case KLPaymentOnlineChannel.WECHAT.value:return KLPaymentOnlineChannel.WECHAT;
            case KLPaymentOnlineChannel.ALIPAY.value:return KLPaymentOnlineChannel.ALIPAY;
            case KLPaymentOnlineChannel.GRAB.value:return KLPaymentOnlineChannel.GRAB;
            case KLPaymentOnlineChannel.MAYA.value:return KLPaymentOnlineChannel.MAYA;
            case KLPaymentOnlineChannel.UNIONPAY.value:return KLPaymentOnlineChannel.UNIONPAY;
            case KLPaymentOnlineChannel.USDT.value:return KLPaymentOnlineChannel.USDT;
        }
        return null;
    }
}

/**
 * 支付订单用户类型
*/
export class KLPaymentOrderMemberType extends KLEnum<string>{

    // 商户
    static readonly MERCHANT = new KLPaymentOrderMemberType('MERCHANT','MERCHANT','商户');

    // 用户
    static readonly USER = new KLPaymentOrderMemberType('USER','USER','用户');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOrderMemberType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MERCHANT','MERCHANT','商户'),
            new KLEnumCase<string>('USER','USER','用户'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOrderMemberType|null {
        switch (val) {
            case KLPaymentOrderMemberType.MERCHANT.value:return KLPaymentOrderMemberType.MERCHANT;
            case KLPaymentOrderMemberType.USER.value:return KLPaymentOrderMemberType.USER;
        }
        return null;
    }
}

/**
 * 支付订单支付方式
*/
export class KLPaymentOrderMethod extends KLEnum<string>{

    // Balance Payment
    static readonly BALANCE = new KLPaymentOrderMethod('BALANCE','BALANCE','Balance Payment');

    // COD
    static readonly COD = new KLPaymentOrderMethod('COD','COD','COD');

    // Online Payment
    static readonly ONLINE = new KLPaymentOrderMethod('ONLINE','ONLINE','Online Payment');

    // Mixed Payment
    static readonly MIXED = new KLPaymentOrderMethod('MIXED','MIXED','Mixed Payment');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOrderMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('BALANCE','BALANCE','Balance Payment'),
            new KLEnumCase<string>('COD','COD','COD'),
            new KLEnumCase<string>('ONLINE','ONLINE','Online Payment'),
            new KLEnumCase<string>('MIXED','MIXED','Mixed Payment'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOrderMethod|null {
        switch (val) {
            case KLPaymentOrderMethod.BALANCE.value:return KLPaymentOrderMethod.BALANCE;
            case KLPaymentOrderMethod.COD.value:return KLPaymentOrderMethod.COD;
            case KLPaymentOrderMethod.ONLINE.value:return KLPaymentOrderMethod.ONLINE;
            case KLPaymentOrderMethod.MIXED.value:return KLPaymentOrderMethod.MIXED;
        }
        return null;
    }
}

/**
 * 支付订单类型
*/
export class KLPaymentOrderOrderType extends KLEnum<string>{

    // 商城订单
    static readonly MALL = new KLPaymentOrderOrderType('MALL','MALL','商城订单');

    // 充值订单
    static readonly RECHARGE = new KLPaymentOrderOrderType('RECHARGE','RECHARGE','充值订单');

    // 商城COD转在线支付
    static readonly MALL_COD_REPAY = new KLPaymentOrderOrderType('MALL_COD_REPAY','MALL_COD_REPAY','商城COD转在线支付');

    // 订单拒单
    static readonly REJECTION = new KLPaymentOrderOrderType('REJECTION','REJECTION','订单拒单');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOrderOrderType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL','MALL','商城订单'),
            new KLEnumCase<string>('RECHARGE','RECHARGE','充值订单'),
            new KLEnumCase<string>('MALL_COD_REPAY','MALL_COD_REPAY','商城COD转在线支付'),
            new KLEnumCase<string>('REJECTION','REJECTION','订单拒单'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOrderOrderType|null {
        switch (val) {
            case KLPaymentOrderOrderType.MALL.value:return KLPaymentOrderOrderType.MALL;
            case KLPaymentOrderOrderType.RECHARGE.value:return KLPaymentOrderOrderType.RECHARGE;
            case KLPaymentOrderOrderType.MALL_COD_REPAY.value:return KLPaymentOrderOrderType.MALL_COD_REPAY;
            case KLPaymentOrderOrderType.REJECTION.value:return KLPaymentOrderOrderType.REJECTION;
        }
        return null;
    }
}

/**
 * 退款订单退款方式
*/
export class KLPaymentOrderRefundRefundMethod extends KLEnum<string>{

    // 余额退款
    static readonly BALANCE = new KLPaymentOrderRefundRefundMethod('BALANCE','BALANCE','余额退款');

    // 货到付款退款
    static readonly COD = new KLPaymentOrderRefundRefundMethod('COD','COD','货到付款退款');

    // 第三方退款
    static readonly THIRD_PARTY = new KLPaymentOrderRefundRefundMethod('THIRD_PARTY','THIRD_PARTY','第三方退款');

    // 混合退款
    static readonly MIXED = new KLPaymentOrderRefundRefundMethod('MIXED','MIXED','混合退款');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOrderRefundRefundMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('BALANCE','BALANCE','余额退款'),
            new KLEnumCase<string>('COD','COD','货到付款退款'),
            new KLEnumCase<string>('THIRD_PARTY','THIRD_PARTY','第三方退款'),
            new KLEnumCase<string>('MIXED','MIXED','混合退款'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOrderRefundRefundMethod|null {
        switch (val) {
            case KLPaymentOrderRefundRefundMethod.BALANCE.value:return KLPaymentOrderRefundRefundMethod.BALANCE;
            case KLPaymentOrderRefundRefundMethod.COD.value:return KLPaymentOrderRefundRefundMethod.COD;
            case KLPaymentOrderRefundRefundMethod.THIRD_PARTY.value:return KLPaymentOrderRefundRefundMethod.THIRD_PARTY;
            case KLPaymentOrderRefundRefundMethod.MIXED.value:return KLPaymentOrderRefundRefundMethod.MIXED;
        }
        return null;
    }
}

/**
 * 退款订单退款状态
*/
export class KLPaymentOrderRefundRefundStatus extends KLEnum<string>{

    // 待处理
    static readonly PENDING = new KLPaymentOrderRefundRefundStatus('PENDING','PENDING','待处理');

    // 已完成
    static readonly COMPLETED = new KLPaymentOrderRefundRefundStatus('COMPLETED','COMPLETED','已完成');

    // 已失败
    static readonly FAILED = new KLPaymentOrderRefundRefundStatus('FAILED','FAILED','已失败');

    // 已取消
    static readonly CANCELLED = new KLPaymentOrderRefundRefundStatus('CANCELLED','CANCELLED','已取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOrderRefundRefundStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','待处理'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','已完成'),
            new KLEnumCase<string>('FAILED','FAILED','已失败'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','已取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOrderRefundRefundStatus|null {
        switch (val) {
            case KLPaymentOrderRefundRefundStatus.PENDING.value:return KLPaymentOrderRefundRefundStatus.PENDING;
            case KLPaymentOrderRefundRefundStatus.COMPLETED.value:return KLPaymentOrderRefundRefundStatus.COMPLETED;
            case KLPaymentOrderRefundRefundStatus.FAILED.value:return KLPaymentOrderRefundRefundStatus.FAILED;
            case KLPaymentOrderRefundRefundStatus.CANCELLED.value:return KLPaymentOrderRefundRefundStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 支付订单状态
*/
export class KLPaymentOrderStatus extends KLEnum<string>{

    // Not Paid
    static readonly NOT_PAID = new KLPaymentOrderStatus('NOT_PAID','NOT_PAID','Not Paid');

    // Partially Paid
    static readonly PARTIALLY_PAID = new KLPaymentOrderStatus('PARTIALLY_PAID','PARTIALLY_PAID','Partially Paid');

    // Paid
    static readonly PAID = new KLPaymentOrderStatus('PAID','PAID','Paid');

    // Refunded
    static readonly REFUNDED = new KLPaymentOrderStatus('REFUNDED','REFUNDED','Refunded');

    // Partially Refunded
    static readonly PARTIALLY_REFUNDED = new KLPaymentOrderStatus('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially Refunded');

    // Failed
    static readonly FAILED = new KLPaymentOrderStatus('FAILED','FAILED','Failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_PAID','NOT_PAID','Not Paid'),
            new KLEnumCase<string>('PARTIALLY_PAID','PARTIALLY_PAID','Partially Paid'),
            new KLEnumCase<string>('PAID','PAID','Paid'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
            new KLEnumCase<string>('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially Refunded'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentOrderStatus|null {
        switch (val) {
            case KLPaymentOrderStatus.NOT_PAID.value:return KLPaymentOrderStatus.NOT_PAID;
            case KLPaymentOrderStatus.PARTIALLY_PAID.value:return KLPaymentOrderStatus.PARTIALLY_PAID;
            case KLPaymentOrderStatus.PAID.value:return KLPaymentOrderStatus.PAID;
            case KLPaymentOrderStatus.REFUNDED.value:return KLPaymentOrderStatus.REFUNDED;
            case KLPaymentOrderStatus.PARTIALLY_REFUNDED.value:return KLPaymentOrderStatus.PARTIALLY_REFUNDED;
            case KLPaymentOrderStatus.FAILED.value:return KLPaymentOrderStatus.FAILED;
        }
        return null;
    }
}

/**
 * 支付校验票据方式
*/
export class KLPaymentVerifyTicketMethod extends KLEnum<string>{

    // Biometric
    static readonly BIOMETRIC = new KLPaymentVerifyTicketMethod('BIOMETRIC','BIOMETRIC','Biometric');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentVerifyTicketMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('BIOMETRIC','BIOMETRIC','Biometric'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentVerifyTicketMethod|null {
        switch (val) {
            case KLPaymentVerifyTicketMethod.BIOMETRIC.value:return KLPaymentVerifyTicketMethod.BIOMETRIC;
        }
        return null;
    }
}

/**
 * 支付校验票据状态
*/
export class KLPaymentVerifyTicketStatus extends KLEnum<string>{

    // Valid
    static readonly VALID = new KLPaymentVerifyTicketStatus('VALID','VALID','Valid');

    // Used
    static readonly USED = new KLPaymentVerifyTicketStatus('USED','USED','Used');

    // Expired
    static readonly EXPIRED = new KLPaymentVerifyTicketStatus('EXPIRED','EXPIRED','Expired');

    // Revoked
    static readonly REVOKED = new KLPaymentVerifyTicketStatus('REVOKED','REVOKED','Revoked');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPaymentVerifyTicketStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('VALID','VALID','Valid'),
            new KLEnumCase<string>('USED','USED','Used'),
            new KLEnumCase<string>('EXPIRED','EXPIRED','Expired'),
            new KLEnumCase<string>('REVOKED','REVOKED','Revoked'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPaymentVerifyTicketStatus|null {
        switch (val) {
            case KLPaymentVerifyTicketStatus.VALID.value:return KLPaymentVerifyTicketStatus.VALID;
            case KLPaymentVerifyTicketStatus.USED.value:return KLPaymentVerifyTicketStatus.USED;
            case KLPaymentVerifyTicketStatus.EXPIRED.value:return KLPaymentVerifyTicketStatus.EXPIRED;
            case KLPaymentVerifyTicketStatus.REVOKED.value:return KLPaymentVerifyTicketStatus.REVOKED;
        }
        return null;
    }
}

/**
 * 退款业务类型
*/
export class KLRefundBizType extends KLEnum<string>{

    // Order Refund
    static readonly MALL_ORDER = new KLRefundBizType('MALL_ORDER','MALL_ORDER','Order Refund');

    // Mall Order Refund
    static readonly MALL_ORDER_REFUND = new KLRefundBizType('MALL_ORDER_REFUND','MALL_ORDER_REFUND','Mall Order Refund');

    // Recharge Order
    static readonly RECHARGE_ORDER = new KLRefundBizType('RECHARGE_ORDER','RECHARGE_ORDER','Recharge Order');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRefundBizType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL_ORDER','MALL_ORDER','Order Refund'),
            new KLEnumCase<string>('MALL_ORDER_REFUND','MALL_ORDER_REFUND','Mall Order Refund'),
            new KLEnumCase<string>('RECHARGE_ORDER','RECHARGE_ORDER','Recharge Order'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRefundBizType|null {
        switch (val) {
            case KLRefundBizType.MALL_ORDER.value:return KLRefundBizType.MALL_ORDER;
            case KLRefundBizType.MALL_ORDER_REFUND.value:return KLRefundBizType.MALL_ORDER_REFUND;
            case KLRefundBizType.RECHARGE_ORDER.value:return KLRefundBizType.RECHARGE_ORDER;
        }
        return null;
    }
}

/**
 * 退款错误类型
*/
export class KLRefundErrorType extends KLEnum<string>{

    // 网络错误
    static readonly NETWORK_ERROR = new KLRefundErrorType('NETWORK_ERROR','NETWORK_ERROR','网络错误');

    // 业务错误
    static readonly BUSINESS_ERROR = new KLRefundErrorType('BUSINESS_ERROR','BUSINESS_ERROR','业务错误');

    // 系统错误
    static readonly SYSTEM_ERROR = new KLRefundErrorType('SYSTEM_ERROR','SYSTEM_ERROR','系统错误');

    // 第三方错误
    static readonly THIRD_PARTY_ERROR = new KLRefundErrorType('THIRD_PARTY_ERROR','THIRD_PARTY_ERROR','第三方错误');

    // 验证错误
    static readonly VALIDATION_ERROR = new KLRefundErrorType('VALIDATION_ERROR','VALIDATION_ERROR','验证错误');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRefundErrorType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NETWORK_ERROR','NETWORK_ERROR','网络错误'),
            new KLEnumCase<string>('BUSINESS_ERROR','BUSINESS_ERROR','业务错误'),
            new KLEnumCase<string>('SYSTEM_ERROR','SYSTEM_ERROR','系统错误'),
            new KLEnumCase<string>('THIRD_PARTY_ERROR','THIRD_PARTY_ERROR','第三方错误'),
            new KLEnumCase<string>('VALIDATION_ERROR','VALIDATION_ERROR','验证错误'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRefundErrorType|null {
        switch (val) {
            case KLRefundErrorType.NETWORK_ERROR.value:return KLRefundErrorType.NETWORK_ERROR;
            case KLRefundErrorType.BUSINESS_ERROR.value:return KLRefundErrorType.BUSINESS_ERROR;
            case KLRefundErrorType.SYSTEM_ERROR.value:return KLRefundErrorType.SYSTEM_ERROR;
            case KLRefundErrorType.THIRD_PARTY_ERROR.value:return KLRefundErrorType.THIRD_PARTY_ERROR;
            case KLRefundErrorType.VALIDATION_ERROR.value:return KLRefundErrorType.VALIDATION_ERROR;
        }
        return null;
    }
}

/**
 * Refund Method
*/
export class KLRefundMethod extends KLEnum<string>{

    // Refund to Original
    static readonly ORIGINAL = new KLRefundMethod('ORIGINAL','ORIGINAL','Refund to Original');

    // Refund to Balance
    static readonly BALANCE = new KLRefundMethod('BALANCE','BALANCE','Refund to Balance');

    // No Refund
    static readonly NONE = new KLRefundMethod('NONE','NONE','No Refund');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRefundMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ORIGINAL','ORIGINAL','Refund to Original'),
            new KLEnumCase<string>('BALANCE','BALANCE','Refund to Balance'),
            new KLEnumCase<string>('NONE','NONE','No Refund'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRefundMethod|null {
        switch (val) {
            case KLRefundMethod.ORIGINAL.value:return KLRefundMethod.ORIGINAL;
            case KLRefundMethod.BALANCE.value:return KLRefundMethod.BALANCE;
            case KLRefundMethod.NONE.value:return KLRefundMethod.NONE;
        }
        return null;
    }
}

/**
 * 退款来源类型
*/
export class KLRefundSourceType extends KLEnum<string>{

    // Balance Paid
    static readonly BALANCE_PAID = new KLRefundSourceType('BALANCE_PAID','BALANCE_PAID','Balance Paid');

    // Online Paid
    static readonly ONLINE_PAID = new KLRefundSourceType('ONLINE_PAID','ONLINE_PAID','Online Paid');

    // COD
    static readonly COD = new KLRefundSourceType('COD','COD','COD');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRefundSourceType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('BALANCE_PAID','BALANCE_PAID','Balance Paid'),
            new KLEnumCase<string>('ONLINE_PAID','ONLINE_PAID','Online Paid'),
            new KLEnumCase<string>('COD','COD','COD'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRefundSourceType|null {
        switch (val) {
            case KLRefundSourceType.BALANCE_PAID.value:return KLRefundSourceType.BALANCE_PAID;
            case KLRefundSourceType.ONLINE_PAID.value:return KLRefundSourceType.ONLINE_PAID;
            case KLRefundSourceType.COD.value:return KLRefundSourceType.COD;
        }
        return null;
    }
}

/**
 * 退款目标类型
*/
export class KLRefundTargetType extends KLEnum<string>{

    // Original Channel
    static readonly ORIGINAL = new KLRefundTargetType('ORIGINAL','ORIGINAL','Original Channel');

    // To Balance
    static readonly TO_BALANCE = new KLRefundTargetType('TO_BALANCE','TO_BALANCE','To Balance');

    // To COD
    static readonly TO_COD = new KLRefundTargetType('TO_COD','TO_COD','To COD');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRefundTargetType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ORIGINAL','ORIGINAL','Original Channel'),
            new KLEnumCase<string>('TO_BALANCE','TO_BALANCE','To Balance'),
            new KLEnumCase<string>('TO_COD','TO_COD','To COD'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRefundTargetType|null {
        switch (val) {
            case KLRefundTargetType.ORIGINAL.value:return KLRefundTargetType.ORIGINAL;
            case KLRefundTargetType.TO_BALANCE.value:return KLRefundTargetType.TO_BALANCE;
            case KLRefundTargetType.TO_COD.value:return KLRefundTargetType.TO_COD;
        }
        return null;
    }
}

/**
 * 收单机构
*/
export class KLUniPaymentAcquirer extends KLEnum<string>{

    // Fucent 支付
    static readonly FUCENT = new KLUniPaymentAcquirer('FUCENT','FUCENT','Fucent 支付');

    // UTC 支付 (USDT)
    static readonly UTC = new KLUniPaymentAcquirer('UTC','UTC','UTC 支付 (USDT)');

    // UU Wallet
    static readonly UU_WALLET = new KLUniPaymentAcquirer('UU_WALLET','UU_WALLET','UU Wallet');

    // 余额支付
    static readonly BALANCE = new KLUniPaymentAcquirer('BALANCE','BALANCE','余额支付');

    // 货到付款
    static readonly COD = new KLUniPaymentAcquirer('COD','COD','货到付款');

    // 官方支付宝
    static readonly ALIPAY = new KLUniPaymentAcquirer('ALIPAY','ALIPAY','官方支付宝');

    // 官方微信
    static readonly WECHAT = new KLUniPaymentAcquirer('WECHAT','WECHAT','官方微信');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentAcquirer.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FUCENT','FUCENT','Fucent 支付'),
            new KLEnumCase<string>('UTC','UTC','UTC 支付 (USDT)'),
            new KLEnumCase<string>('UU_WALLET','UU_WALLET','UU Wallet'),
            new KLEnumCase<string>('BALANCE','BALANCE','余额支付'),
            new KLEnumCase<string>('COD','COD','货到付款'),
            new KLEnumCase<string>('ALIPAY','ALIPAY','官方支付宝'),
            new KLEnumCase<string>('WECHAT','WECHAT','官方微信'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentAcquirer|null {
        switch (val) {
            case KLUniPaymentAcquirer.FUCENT.value:return KLUniPaymentAcquirer.FUCENT;
            case KLUniPaymentAcquirer.UTC.value:return KLUniPaymentAcquirer.UTC;
            case KLUniPaymentAcquirer.UU_WALLET.value:return KLUniPaymentAcquirer.UU_WALLET;
            case KLUniPaymentAcquirer.BALANCE.value:return KLUniPaymentAcquirer.BALANCE;
            case KLUniPaymentAcquirer.COD.value:return KLUniPaymentAcquirer.COD;
            case KLUniPaymentAcquirer.ALIPAY.value:return KLUniPaymentAcquirer.ALIPAY;
            case KLUniPaymentAcquirer.WECHAT.value:return KLUniPaymentAcquirer.WECHAT;
        }
        return null;
    }
}

/**
 * 支付流程模式
*/
export class KLUniPaymentFlowMode extends KLEnum<string>{

    // 预下单模式
    static readonly PRE_ORDER = new KLUniPaymentFlowMode('PRE_ORDER','PRE_ORDER','预下单模式');

    // 转账模式
    static readonly TRANSFER = new KLUniPaymentFlowMode('TRANSFER','TRANSFER','转账模式');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentFlowMode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PRE_ORDER','PRE_ORDER','预下单模式'),
            new KLEnumCase<string>('TRANSFER','TRANSFER','转账模式'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentFlowMode|null {
        switch (val) {
            case KLUniPaymentFlowMode.PRE_ORDER.value:return KLUniPaymentFlowMode.PRE_ORDER;
            case KLUniPaymentFlowMode.TRANSFER.value:return KLUniPaymentFlowMode.TRANSFER;
        }
        return null;
    }
}

/**
 * 支付启动器类型
*/
export class KLUniPaymentLauncherType extends KLEnum<string>{

    // 网页跳转URL
    static readonly WEB_URL = new KLUniPaymentLauncherType('WEB_URL','WEB_URL','网页跳转URL');

    // 支付宝APP调用
    static readonly ALIPAY_APP = new KLUniPaymentLauncherType('ALIPAY_APP','ALIPAY_APP','支付宝APP调用');

    // 微信APP调用
    static readonly WECHAT_APP = new KLUniPaymentLauncherType('WECHAT_APP','WECHAT_APP','微信APP调用');

    // 余额支付
    static readonly BALANCE = new KLUniPaymentLauncherType('BALANCE','BALANCE','余额支付');

    // 货到付款
    static readonly COD = new KLUniPaymentLauncherType('COD','COD','货到付款');

    // 支付宝小程序支付参数
    static readonly ALIPAY_MINI_APP = new KLUniPaymentLauncherType('ALIPAY_MINI_APP','ALIPAY_MINI_APP','支付宝小程序支付参数');

    // 微信小程序支付参数
    static readonly WECHAT_MINI_APP = new KLUniPaymentLauncherType('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序支付参数');

    // 二维码数据
    static readonly QR_CODE = new KLUniPaymentLauncherType('QR_CODE','QR_CODE','二维码数据');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentLauncherType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('WEB_URL','WEB_URL','网页跳转URL'),
            new KLEnumCase<string>('ALIPAY_APP','ALIPAY_APP','支付宝APP调用'),
            new KLEnumCase<string>('WECHAT_APP','WECHAT_APP','微信APP调用'),
            new KLEnumCase<string>('BALANCE','BALANCE','余额支付'),
            new KLEnumCase<string>('COD','COD','货到付款'),
            new KLEnumCase<string>('ALIPAY_MINI_APP','ALIPAY_MINI_APP','支付宝小程序支付参数'),
            new KLEnumCase<string>('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序支付参数'),
            new KLEnumCase<string>('QR_CODE','QR_CODE','二维码数据'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentLauncherType|null {
        switch (val) {
            case KLUniPaymentLauncherType.WEB_URL.value:return KLUniPaymentLauncherType.WEB_URL;
            case KLUniPaymentLauncherType.ALIPAY_APP.value:return KLUniPaymentLauncherType.ALIPAY_APP;
            case KLUniPaymentLauncherType.WECHAT_APP.value:return KLUniPaymentLauncherType.WECHAT_APP;
            case KLUniPaymentLauncherType.BALANCE.value:return KLUniPaymentLauncherType.BALANCE;
            case KLUniPaymentLauncherType.COD.value:return KLUniPaymentLauncherType.COD;
            case KLUniPaymentLauncherType.ALIPAY_MINI_APP.value:return KLUniPaymentLauncherType.ALIPAY_MINI_APP;
            case KLUniPaymentLauncherType.WECHAT_MINI_APP.value:return KLUniPaymentLauncherType.WECHAT_MINI_APP;
            case KLUniPaymentLauncherType.QR_CODE.value:return KLUniPaymentLauncherType.QR_CODE;
        }
        return null;
    }
}

/**
 * 统一支付方式
*/
export class KLUniPaymentMethod extends KLEnum<string>{

    // GCASH
    static readonly GCASH = new KLUniPaymentMethod('GCASH','GCASH','GCASH');

    // 微信支付
    static readonly WECHAT = new KLUniPaymentMethod('WECHAT','WECHAT','微信支付');

    // 支付宝
    static readonly ALIPAY = new KLUniPaymentMethod('ALIPAY','ALIPAY','支付宝');

    // GRAB
    static readonly GRAB = new KLUniPaymentMethod('GRAB','GRAB','GRAB');

    // MAYA
    static readonly MAYA = new KLUniPaymentMethod('MAYA','MAYA','MAYA');

    // 银联支付
    static readonly UNIONPAY = new KLUniPaymentMethod('UNIONPAY','UNIONPAY','银联支付');

    // USDT
    static readonly USDT = new KLUniPaymentMethod('USDT','USDT','USDT');

    // 货到付款
    static readonly COD = new KLUniPaymentMethod('COD','COD','货到付款');

    // 余额支付
    static readonly BALANCE = new KLUniPaymentMethod('BALANCE','BALANCE','余额支付');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GCASH','GCASH','GCASH'),
            new KLEnumCase<string>('WECHAT','WECHAT','微信支付'),
            new KLEnumCase<string>('ALIPAY','ALIPAY','支付宝'),
            new KLEnumCase<string>('GRAB','GRAB','GRAB'),
            new KLEnumCase<string>('MAYA','MAYA','MAYA'),
            new KLEnumCase<string>('UNIONPAY','UNIONPAY','银联支付'),
            new KLEnumCase<string>('USDT','USDT','USDT'),
            new KLEnumCase<string>('COD','COD','货到付款'),
            new KLEnumCase<string>('BALANCE','BALANCE','余额支付'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentMethod|null {
        switch (val) {
            case KLUniPaymentMethod.GCASH.value:return KLUniPaymentMethod.GCASH;
            case KLUniPaymentMethod.WECHAT.value:return KLUniPaymentMethod.WECHAT;
            case KLUniPaymentMethod.ALIPAY.value:return KLUniPaymentMethod.ALIPAY;
            case KLUniPaymentMethod.GRAB.value:return KLUniPaymentMethod.GRAB;
            case KLUniPaymentMethod.MAYA.value:return KLUniPaymentMethod.MAYA;
            case KLUniPaymentMethod.UNIONPAY.value:return KLUniPaymentMethod.UNIONPAY;
            case KLUniPaymentMethod.USDT.value:return KLUniPaymentMethod.USDT;
            case KLUniPaymentMethod.COD.value:return KLUniPaymentMethod.COD;
            case KLUniPaymentMethod.BALANCE.value:return KLUniPaymentMethod.BALANCE;
        }
        return null;
    }
}

/**
 * 支付订单状态
*/
export class KLUniPaymentOrderStatus extends KLEnum<string>{

    // 未支付
    static readonly PENDING = new KLUniPaymentOrderStatus('PENDING','NOT_PAID','未支付');

    // 已支付
    static readonly PAID = new KLUniPaymentOrderStatus('PAID','PAID','已支付');

    // 支付失败
    static readonly FAILED = new KLUniPaymentOrderStatus('FAILED','FAILED','支付失败');

    // 已退款
    static readonly REFUNDED = new KLUniPaymentOrderStatus('REFUNDED','REFUNDED','已退款');

    // 部分退款
    static readonly PARTIAL_REFUNDED = new KLUniPaymentOrderStatus('PARTIAL_REFUNDED','PARTIALLY_REFUNDED','部分退款');

    // 已取消
    static readonly CANCELLED = new KLUniPaymentOrderStatus('CANCELLED','CANCELLED','已取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','NOT_PAID','未支付'),
            new KLEnumCase<string>('PAID','PAID','已支付'),
            new KLEnumCase<string>('FAILED','FAILED','支付失败'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','已退款'),
            new KLEnumCase<string>('PARTIAL_REFUNDED','PARTIALLY_REFUNDED','部分退款'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','已取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentOrderStatus|null {
        switch (val) {
            case KLUniPaymentOrderStatus.PENDING.value:return KLUniPaymentOrderStatus.PENDING;
            case KLUniPaymentOrderStatus.PAID.value:return KLUniPaymentOrderStatus.PAID;
            case KLUniPaymentOrderStatus.FAILED.value:return KLUniPaymentOrderStatus.FAILED;
            case KLUniPaymentOrderStatus.REFUNDED.value:return KLUniPaymentOrderStatus.REFUNDED;
            case KLUniPaymentOrderStatus.PARTIAL_REFUNDED.value:return KLUniPaymentOrderStatus.PARTIAL_REFUNDED;
            case KLUniPaymentOrderStatus.CANCELLED.value:return KLUniPaymentOrderStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 支付服务商
*/
export class KLUniPaymentProvider extends KLEnum<string>{

    // GCASH
    static readonly GCASH = new KLUniPaymentProvider('GCASH','GCASH','GCASH');

    // 微信支付
    static readonly WECHAT = new KLUniPaymentProvider('WECHAT','WECHAT','微信支付');

    // 支付宝
    static readonly ALIPAY = new KLUniPaymentProvider('ALIPAY','ALIPAY','支付宝');

    // GRAB
    static readonly GRAB = new KLUniPaymentProvider('GRAB','GRAB','GRAB');

    // MAYA
    static readonly MAYA = new KLUniPaymentProvider('MAYA','MAYA','MAYA');

    // 银联支付
    static readonly UNIONPAY = new KLUniPaymentProvider('UNIONPAY','UNIONPAY','银联支付');

    // USDT
    static readonly USDT = new KLUniPaymentProvider('USDT','USDT','USDT');

    // 余额支付
    static readonly BALANCE = new KLUniPaymentProvider('BALANCE','BALANCE','余额支付');

    // 货到付款
    static readonly COD = new KLUniPaymentProvider('COD','COD','货到付款');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentProvider.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GCASH','GCASH','GCASH'),
            new KLEnumCase<string>('WECHAT','WECHAT','微信支付'),
            new KLEnumCase<string>('ALIPAY','ALIPAY','支付宝'),
            new KLEnumCase<string>('GRAB','GRAB','GRAB'),
            new KLEnumCase<string>('MAYA','MAYA','MAYA'),
            new KLEnumCase<string>('UNIONPAY','UNIONPAY','银联支付'),
            new KLEnumCase<string>('USDT','USDT','USDT'),
            new KLEnumCase<string>('BALANCE','BALANCE','余额支付'),
            new KLEnumCase<string>('COD','COD','货到付款'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentProvider|null {
        switch (val) {
            case KLUniPaymentProvider.GCASH.value:return KLUniPaymentProvider.GCASH;
            case KLUniPaymentProvider.WECHAT.value:return KLUniPaymentProvider.WECHAT;
            case KLUniPaymentProvider.ALIPAY.value:return KLUniPaymentProvider.ALIPAY;
            case KLUniPaymentProvider.GRAB.value:return KLUniPaymentProvider.GRAB;
            case KLUniPaymentProvider.MAYA.value:return KLUniPaymentProvider.MAYA;
            case KLUniPaymentProvider.UNIONPAY.value:return KLUniPaymentProvider.UNIONPAY;
            case KLUniPaymentProvider.USDT.value:return KLUniPaymentProvider.USDT;
            case KLUniPaymentProvider.BALANCE.value:return KLUniPaymentProvider.BALANCE;
            case KLUniPaymentProvider.COD.value:return KLUniPaymentProvider.COD;
        }
        return null;
    }
}

/**
 * 联合支付场景
*/
export class KLUniPaymentScene extends KLEnum<string>{

    // App内支付
    static readonly IN_APP = new KLUniPaymentScene('IN_APP','IN_APP','App内支付');

    // PC网页
    static readonly WEB = new KLUniPaymentScene('WEB','WEB','PC网页');

    // 移动端网页
    static readonly WAP = new KLUniPaymentScene('WAP','WAP','移动端网页');

    // 微信小程序
    static readonly WECHAT_MINI_APP = new KLUniPaymentScene('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序');

    // 微信JS API
    static readonly WECHAT_JS_API = new KLUniPaymentScene('WECHAT_JS_API','WECHAT_JS_API','微信JS API');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUniPaymentScene.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IN_APP','IN_APP','App内支付'),
            new KLEnumCase<string>('WEB','WEB','PC网页'),
            new KLEnumCase<string>('WAP','WAP','移动端网页'),
            new KLEnumCase<string>('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序'),
            new KLEnumCase<string>('WECHAT_JS_API','WECHAT_JS_API','微信JS API'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUniPaymentScene|null {
        switch (val) {
            case KLUniPaymentScene.IN_APP.value:return KLUniPaymentScene.IN_APP;
            case KLUniPaymentScene.WEB.value:return KLUniPaymentScene.WEB;
            case KLUniPaymentScene.WAP.value:return KLUniPaymentScene.WAP;
            case KLUniPaymentScene.WECHAT_MINI_APP.value:return KLUniPaymentScene.WECHAT_MINI_APP;
            case KLUniPaymentScene.WECHAT_JS_API.value:return KLUniPaymentScene.WECHAT_JS_API;
        }
        return null;
    }
}

/**
 * 菜单动作类型
*/
export class KLSysRbacMenuAction extends KLEnum<string>{

    // 默认
    static readonly DEFAULT = new KLSysRbacMenuAction('DEFAULT','DEFAULT','默认');

    // 新窗口
    static readonly BLANK = new KLSysRbacMenuAction('BLANK','BLANK','新窗口');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSysRbacMenuAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DEFAULT','DEFAULT','默认'),
            new KLEnumCase<string>('BLANK','BLANK','新窗口'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSysRbacMenuAction|null {
        switch (val) {
            case KLSysRbacMenuAction.DEFAULT.value:return KLSysRbacMenuAction.DEFAULT;
            case KLSysRbacMenuAction.BLANK.value:return KLSysRbacMenuAction.BLANK;
        }
        return null;
    }
}

/**
 * 菜单类型
*/
export class KLSysRbacMenuType extends KLEnum<string>{

    // 菜单
    static readonly MENU = new KLSysRbacMenuType('MENU','MENU','菜单');

    // 资源
    static readonly RES = new KLSysRbacMenuType('RES','RES','资源');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSysRbacMenuType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MENU','MENU','菜单'),
            new KLEnumCase<string>('RES','RES','资源'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSysRbacMenuType|null {
        switch (val) {
            case KLSysRbacMenuType.MENU.value:return KLSysRbacMenuType.MENU;
            case KLSysRbacMenuType.RES.value:return KLSysRbacMenuType.RES;
        }
        return null;
    }
}

/**
 * 
*/
export class KLRechargeOrderAction extends KLEnum<string>{

    // 立即支付
    static readonly PAY_NOW = new KLRechargeOrderAction('PAY_NOW','pay_now','立即支付');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLRechargeOrderAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PAY_NOW','pay_now','立即支付'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLRechargeOrderAction|null {
        switch (val) {
            case KLRechargeOrderAction.PAY_NOW.value:return KLRechargeOrderAction.PAY_NOW;
        }
        return null;
    }
}

/**
 * 客户端操作系统
*/
export class KLUserBalanceRechargeClientOs extends KLEnum<string>{

    // ANDROID
    static readonly ANDROID = new KLUserBalanceRechargeClientOs('ANDROID','ANDROID','ANDROID');

    // IOS
    static readonly IOS = new KLUserBalanceRechargeClientOs('IOS','IOS','IOS');

    // HARMONY
    static readonly HARMONY = new KLUserBalanceRechargeClientOs('HARMONY','HARMONY','HARMONY');

    // WINDOWS
    static readonly WINDOWS = new KLUserBalanceRechargeClientOs('WINDOWS','WINDOWS','WINDOWS');

    // MACOS
    static readonly MACOS = new KLUserBalanceRechargeClientOs('MACOS','MACOS','MACOS');

    // LINUX
    static readonly LINUX = new KLUserBalanceRechargeClientOs('LINUX','LINUX','LINUX');

    // UNKNOWN
    static readonly UNKNOWN = new KLUserBalanceRechargeClientOs('UNKNOWN','UNKNOWN','UNKNOWN');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserBalanceRechargeClientOs.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ANDROID','ANDROID','ANDROID'),
            new KLEnumCase<string>('IOS','IOS','IOS'),
            new KLEnumCase<string>('HARMONY','HARMONY','HARMONY'),
            new KLEnumCase<string>('WINDOWS','WINDOWS','WINDOWS'),
            new KLEnumCase<string>('MACOS','MACOS','MACOS'),
            new KLEnumCase<string>('LINUX','LINUX','LINUX'),
            new KLEnumCase<string>('UNKNOWN','UNKNOWN','UNKNOWN'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserBalanceRechargeClientOs|null {
        switch (val) {
            case KLUserBalanceRechargeClientOs.ANDROID.value:return KLUserBalanceRechargeClientOs.ANDROID;
            case KLUserBalanceRechargeClientOs.IOS.value:return KLUserBalanceRechargeClientOs.IOS;
            case KLUserBalanceRechargeClientOs.HARMONY.value:return KLUserBalanceRechargeClientOs.HARMONY;
            case KLUserBalanceRechargeClientOs.WINDOWS.value:return KLUserBalanceRechargeClientOs.WINDOWS;
            case KLUserBalanceRechargeClientOs.MACOS.value:return KLUserBalanceRechargeClientOs.MACOS;
            case KLUserBalanceRechargeClientOs.LINUX.value:return KLUserBalanceRechargeClientOs.LINUX;
            case KLUserBalanceRechargeClientOs.UNKNOWN.value:return KLUserBalanceRechargeClientOs.UNKNOWN;
        }
        return null;
    }
}

/**
 * 用户余额充值筛选状态
*/
export class KLUserBalanceRechargeFilterStatus extends KLEnum<string>{

    // All
    static readonly ALL = new KLUserBalanceRechargeFilterStatus('ALL','All','All');

    // In Progress
    static readonly IN_PROGRESS = new KLUserBalanceRechargeFilterStatus('IN_PROGRESS','In_Progress','In Progress');

    // Completed
    static readonly COMPLETED = new KLUserBalanceRechargeFilterStatus('COMPLETED','Completed','Completed');

    // Cancelled
    static readonly CANCELLED = new KLUserBalanceRechargeFilterStatus('CANCELLED','Cancelled','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserBalanceRechargeFilterStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','All','All'),
            new KLEnumCase<string>('IN_PROGRESS','In_Progress','In Progress'),
            new KLEnumCase<string>('COMPLETED','Completed','Completed'),
            new KLEnumCase<string>('CANCELLED','Cancelled','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserBalanceRechargeFilterStatus|null {
        switch (val) {
            case KLUserBalanceRechargeFilterStatus.ALL.value:return KLUserBalanceRechargeFilterStatus.ALL;
            case KLUserBalanceRechargeFilterStatus.IN_PROGRESS.value:return KLUserBalanceRechargeFilterStatus.IN_PROGRESS;
            case KLUserBalanceRechargeFilterStatus.COMPLETED.value:return KLUserBalanceRechargeFilterStatus.COMPLETED;
            case KLUserBalanceRechargeFilterStatus.CANCELLED.value:return KLUserBalanceRechargeFilterStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 用户余额充值支付方式
*/
export class KLUserBalanceRechargePayMethod extends KLEnum<string>{

    // 未支付
    static readonly NOT_PAID = new KLUserBalanceRechargePayMethod('NOT_PAID','NOT_PAID','未支付');

    // 在线支付
    static readonly ONLINE = new KLUserBalanceRechargePayMethod('ONLINE','ONLINE','在线支付');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserBalanceRechargePayMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_PAID','NOT_PAID','未支付'),
            new KLEnumCase<string>('ONLINE','ONLINE','在线支付'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserBalanceRechargePayMethod|null {
        switch (val) {
            case KLUserBalanceRechargePayMethod.NOT_PAID.value:return KLUserBalanceRechargePayMethod.NOT_PAID;
            case KLUserBalanceRechargePayMethod.ONLINE.value:return KLUserBalanceRechargePayMethod.ONLINE;
        }
        return null;
    }
}

/**
 * 用户余额充值来源
*/
export class KLUserBalanceRechargeSource extends KLEnum<string>{

    // APP
    static readonly APP = new KLUserBalanceRechargeSource('APP','APP','APP');

    // PC
    static readonly PC = new KLUserBalanceRechargeSource('PC','PC','PC');

    // WAP
    static readonly WAP = new KLUserBalanceRechargeSource('WAP','WAP','WAP');

    // 小程序
    static readonly APPLET = new KLUserBalanceRechargeSource('APPLET','APPLET','小程序');

    // 其他
    static readonly OTHER = new KLUserBalanceRechargeSource('OTHER','OTHER','其他');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserBalanceRechargeSource.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('APP','APP','APP'),
            new KLEnumCase<string>('PC','PC','PC'),
            new KLEnumCase<string>('WAP','WAP','WAP'),
            new KLEnumCase<string>('APPLET','APPLET','小程序'),
            new KLEnumCase<string>('OTHER','OTHER','其他'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserBalanceRechargeSource|null {
        switch (val) {
            case KLUserBalanceRechargeSource.APP.value:return KLUserBalanceRechargeSource.APP;
            case KLUserBalanceRechargeSource.PC.value:return KLUserBalanceRechargeSource.PC;
            case KLUserBalanceRechargeSource.WAP.value:return KLUserBalanceRechargeSource.WAP;
            case KLUserBalanceRechargeSource.APPLET.value:return KLUserBalanceRechargeSource.APPLET;
            case KLUserBalanceRechargeSource.OTHER.value:return KLUserBalanceRechargeSource.OTHER;
        }
        return null;
    }
}

/**
 * 用户余额充值状态
*/
export class KLUserBalanceRechargeStatus extends KLEnum<string>{

    // Pending Payment
    static readonly PENDING_PAYMENT = new KLUserBalanceRechargeStatus('PENDING_PAYMENT','PENDING_PAYMENT','Pending Payment');

    // Paid
    static readonly PAID = new KLUserBalanceRechargeStatus('PAID','PAID','Paid');

    // Completed
    static readonly COMPLETED = new KLUserBalanceRechargeStatus('COMPLETED','COMPLETED','Completed');

    // Cancelled
    static readonly CANCELLED = new KLUserBalanceRechargeStatus('CANCELLED','CANCELLED','Cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserBalanceRechargeStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING_PAYMENT','PENDING_PAYMENT','Pending Payment'),
            new KLEnumCase<string>('PAID','PAID','Paid'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','Completed'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','Cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserBalanceRechargeStatus|null {
        switch (val) {
            case KLUserBalanceRechargeStatus.PENDING_PAYMENT.value:return KLUserBalanceRechargeStatus.PENDING_PAYMENT;
            case KLUserBalanceRechargeStatus.PAID.value:return KLUserBalanceRechargeStatus.PAID;
            case KLUserBalanceRechargeStatus.COMPLETED.value:return KLUserBalanceRechargeStatus.COMPLETED;
            case KLUserBalanceRechargeStatus.CANCELLED.value:return KLUserBalanceRechargeStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 短信场景
*/
export class KLSmsScene extends KLEnum<string>{

    // 登录
    static readonly LOGIN = new KLSmsScene('LOGIN','LOGIN','登录');

    // OAuth绑定手机
    static readonly OAUTH_BIND_MOBILE = new KLSmsScene('OAUTH_BIND_MOBILE','OAUTH_BIND_MOBILE','OAuth绑定手机');

    // 修改信息
    static readonly MODIFY_INFO = new KLSmsScene('MODIFY_INFO','MODIFY_INFO','修改信息');

    // 注销账号
    static readonly DELETE_ACCOUNT = new KLSmsScene('DELETE_ACCOUNT','DELETE_ACCOUNT','注销账号');

    // 其他
    static readonly OTHER = new KLSmsScene('OTHER','OTHER','其他');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSmsScene.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('LOGIN','LOGIN','登录'),
            new KLEnumCase<string>('OAUTH_BIND_MOBILE','OAUTH_BIND_MOBILE','OAuth绑定手机'),
            new KLEnumCase<string>('MODIFY_INFO','MODIFY_INFO','修改信息'),
            new KLEnumCase<string>('DELETE_ACCOUNT','DELETE_ACCOUNT','注销账号'),
            new KLEnumCase<string>('OTHER','OTHER','其他'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSmsScene|null {
        switch (val) {
            case KLSmsScene.LOGIN.value:return KLSmsScene.LOGIN;
            case KLSmsScene.OAUTH_BIND_MOBILE.value:return KLSmsScene.OAUTH_BIND_MOBILE;
            case KLSmsScene.MODIFY_INFO.value:return KLSmsScene.MODIFY_INFO;
            case KLSmsScene.DELETE_ACCOUNT.value:return KLSmsScene.DELETE_ACCOUNT;
            case KLSmsScene.OTHER.value:return KLSmsScene.OTHER;
        }
        return null;
    }
}

/**
 * 短信发送状态
*/
export class KLSmsSendStatus extends KLEnum<string>{

    // 待发送
    static readonly PENDING = new KLSmsSendStatus('PENDING','PENDING','待发送');

    // 已发送
    static readonly SENT = new KLSmsSendStatus('SENT','SENT','已发送');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSmsSendStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','待发送'),
            new KLEnumCase<string>('SENT','SENT','已发送'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSmsSendStatus|null {
        switch (val) {
            case KLSmsSendStatus.PENDING.value:return KLSmsSendStatus.PENDING;
            case KLSmsSendStatus.SENT.value:return KLSmsSendStatus.SENT;
        }
        return null;
    }
}

/**
 * 短信验证码状态
*/
export class KLSmsStatus extends KLEnum<string>{

    // 未使用
    static readonly UNUSED = new KLSmsStatus('UNUSED','UNUSED','未使用');

    // 已使用
    static readonly USED = new KLSmsStatus('USED','USED','已使用');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSmsStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNUSED','UNUSED','未使用'),
            new KLEnumCase<string>('USED','USED','已使用'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSmsStatus|null {
        switch (val) {
            case KLSmsStatus.UNUSED.value:return KLSmsStatus.UNUSED;
            case KLSmsStatus.USED.value:return KLSmsStatus.USED;
        }
        return null;
    }
}

/**
 * 短信验证码类型
*/
export class KLSmsType extends KLEnum<string>{

    // 图形验证码
    static readonly IMAGE = new KLSmsType('IMAGE','IMAGE','图形验证码');

    // 短信验证码
    static readonly SMS = new KLSmsType('SMS','SMS','短信验证码');

    // 语音验证码
    static readonly VOICE = new KLSmsType('VOICE','VOICE','语音验证码');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSmsType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IMAGE','IMAGE','图形验证码'),
            new KLEnumCase<string>('SMS','SMS','短信验证码'),
            new KLEnumCase<string>('VOICE','VOICE','语音验证码'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSmsType|null {
        switch (val) {
            case KLSmsType.IMAGE.value:return KLSmsType.IMAGE;
            case KLSmsType.SMS.value:return KLSmsType.SMS;
            case KLSmsType.VOICE.value:return KLSmsType.VOICE;
        }
        return null;
    }
}

/**
 * 账号注销状态
*/
export class KLUserAccountDeletionStatus extends KLEnum<string>{

    // 待处理
    static readonly PENDING = new KLUserAccountDeletionStatus('PENDING','PENDING','待处理');

    // 已完成
    static readonly COMPLETED = new KLUserAccountDeletionStatus('COMPLETED','COMPLETED','已完成');

    // 已取消
    static readonly CANCELLED = new KLUserAccountDeletionStatus('CANCELLED','CANCELLED','已取消');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserAccountDeletionStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','待处理'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','已完成'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','已取消'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserAccountDeletionStatus|null {
        switch (val) {
            case KLUserAccountDeletionStatus.PENDING.value:return KLUserAccountDeletionStatus.PENDING;
            case KLUserAccountDeletionStatus.COMPLETED.value:return KLUserAccountDeletionStatus.COMPLETED;
            case KLUserAccountDeletionStatus.CANCELLED.value:return KLUserAccountDeletionStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 账号注销类型
*/
export class KLUserAccountDeletionType extends KLEnum<string>{

    // 用户发起
    static readonly USER_INITIATED = new KLUserAccountDeletionType('USER_INITIATED','USER_INITIATED','用户发起');

    // 管理员发起
    static readonly ADMIN_INITIATED = new KLUserAccountDeletionType('ADMIN_INITIATED','ADMIN_INITIATED','管理员发起');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserAccountDeletionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER_INITIATED','USER_INITIATED','用户发起'),
            new KLEnumCase<string>('ADMIN_INITIATED','ADMIN_INITIATED','管理员发起'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserAccountDeletionType|null {
        switch (val) {
            case KLUserAccountDeletionType.USER_INITIATED.value:return KLUserAccountDeletionType.USER_INITIATED;
            case KLUserAccountDeletionType.ADMIN_INITIATED.value:return KLUserAccountDeletionType.ADMIN_INITIATED;
        }
        return null;
    }
}

/**
 * 用户性别
*/
export class KLUserAddressGender extends KLEnum<string>{

    // 未知
    static readonly UNKNOWN = new KLUserAddressGender('UNKNOWN','UNKNOWN','未知');

    // 男
    static readonly MALE = new KLUserAddressGender('MALE','MALE','男');

    // 女
    static readonly FEMALE = new KLUserAddressGender('FEMALE','FEMALE','女');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserAddressGender.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNKNOWN','UNKNOWN','未知'),
            new KLEnumCase<string>('MALE','MALE','男'),
            new KLEnumCase<string>('FEMALE','FEMALE','女'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserAddressGender|null {
        switch (val) {
            case KLUserAddressGender.UNKNOWN.value:return KLUserAddressGender.UNKNOWN;
            case KLUserAddressGender.MALE.value:return KLUserAddressGender.MALE;
            case KLUserAddressGender.FEMALE.value:return KLUserAddressGender.FEMALE;
        }
        return null;
    }
}

/**
 * 用户地址标签
*/
export class KLUserAddressLabel extends KLEnum<string>{

    // Home
    static readonly HOME = new KLUserAddressLabel('HOME','Home','Home');

    // Work
    static readonly WORK = new KLUserAddressLabel('WORK','Work','Work');

    // Partner
    static readonly PARTNER = new KLUserAddressLabel('PARTNER','Partner','Partner');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserAddressLabel.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HOME','Home','Home'),
            new KLEnumCase<string>('WORK','Work','Work'),
            new KLEnumCase<string>('PARTNER','Partner','Partner'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserAddressLabel|null {
        switch (val) {
            case KLUserAddressLabel.HOME.value:return KLUserAddressLabel.HOME;
            case KLUserAddressLabel.WORK.value:return KLUserAddressLabel.WORK;
            case KLUserAddressLabel.PARTNER.value:return KLUserAddressLabel.PARTNER;
        }
        return null;
    }
}

/**
 * 用户协议类型
*/
export class KLUserConsentsType extends KLEnum<string>{

    // 隐私授权
    static readonly PRIVACY_CONSENT = new KLUserConsentsType('PRIVACY_CONSENT','privacy_consent','隐私授权');

    // 用户协议
    static readonly USER_AGREEMENT_CONSENT = new KLUserConsentsType('USER_AGREEMENT_CONSENT','user_agreement_consent','用户协议');

    // 充值协议
    static readonly TOPUP_AGREEMENT_CONSENT = new KLUserConsentsType('TOPUP_AGREEMENT_CONSENT','topup_agreement_consent','充值协议');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserConsentsType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PRIVACY_CONSENT','privacy_consent','隐私授权'),
            new KLEnumCase<string>('USER_AGREEMENT_CONSENT','user_agreement_consent','用户协议'),
            new KLEnumCase<string>('TOPUP_AGREEMENT_CONSENT','topup_agreement_consent','充值协议'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserConsentsType|null {
        switch (val) {
            case KLUserConsentsType.PRIVACY_CONSENT.value:return KLUserConsentsType.PRIVACY_CONSENT;
            case KLUserConsentsType.USER_AGREEMENT_CONSENT.value:return KLUserConsentsType.USER_AGREEMENT_CONSENT;
            case KLUserConsentsType.TOPUP_AGREEMENT_CONSENT.value:return KLUserConsentsType.TOPUP_AGREEMENT_CONSENT;
        }
        return null;
    }
}

/**
 * 用户优惠券筛选类型
*/
export class KLUserCouponFilterType extends KLEnum<string>{

    // All
    static readonly ALL = new KLUserCouponFilterType('ALL','All','All');

    // Available
    static readonly AVAILABLE = new KLUserCouponFilterType('AVAILABLE','Available','Available');

    // Used
    static readonly USED = new KLUserCouponFilterType('USED','Used','Used');

    // Invalid
    static readonly INVALID = new KLUserCouponFilterType('INVALID','Invalid','Invalid');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserCouponFilterType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','All','All'),
            new KLEnumCase<string>('AVAILABLE','Available','Available'),
            new KLEnumCase<string>('USED','Used','Used'),
            new KLEnumCase<string>('INVALID','Invalid','Invalid'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserCouponFilterType|null {
        switch (val) {
            case KLUserCouponFilterType.ALL.value:return KLUserCouponFilterType.ALL;
            case KLUserCouponFilterType.AVAILABLE.value:return KLUserCouponFilterType.AVAILABLE;
            case KLUserCouponFilterType.USED.value:return KLUserCouponFilterType.USED;
            case KLUserCouponFilterType.INVALID.value:return KLUserCouponFilterType.INVALID;
        }
        return null;
    }
}

/**
 * 用户优惠券状态
*/
export class KLUserCouponStatus extends KLEnum<string>{

    // 未使用
    static readonly UNUSED = new KLUserCouponStatus('UNUSED','UNUSED','未使用');

    // 已使用
    static readonly USED = new KLUserCouponStatus('USED','USED','已使用');

    // 已过期
    static readonly EXPIRED = new KLUserCouponStatus('EXPIRED','EXPIRED','已过期');

    // 已失效
    static readonly INVALID = new KLUserCouponStatus('INVALID','INVALID','已失效');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserCouponStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNUSED','UNUSED','未使用'),
            new KLEnumCase<string>('USED','USED','已使用'),
            new KLEnumCase<string>('EXPIRED','EXPIRED','已过期'),
            new KLEnumCase<string>('INVALID','INVALID','已失效'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserCouponStatus|null {
        switch (val) {
            case KLUserCouponStatus.UNUSED.value:return KLUserCouponStatus.UNUSED;
            case KLUserCouponStatus.USED.value:return KLUserCouponStatus.USED;
            case KLUserCouponStatus.EXPIRED.value:return KLUserCouponStatus.EXPIRED;
            case KLUserCouponStatus.INVALID.value:return KLUserCouponStatus.INVALID;
        }
        return null;
    }
}

/**
 * 用户注销理由
*/
export class KLUserDeleteReason extends KLEnum<string>{

    // Using another account
    static readonly HAVE_ANOTHER_ACCOUNT = new KLUserDeleteReason('HAVE_ANOTHER_ACCOUNT','HAVE_ANOTHER_ACCOUNT','Using another account');

    // I no longer want to use it
    static readonly NO_LONGER_WANT_TO_USE = new KLUserDeleteReason('NO_LONGER_WANT_TO_USE','NO_LONGER_WANT_TO_USE','I no longer want to use it');

    // Phone number no longer used
    static readonly PHONE_NO_LONGER_IN_USE = new KLUserDeleteReason('PHONE_NO_LONGER_IN_USE','PHONE_NO_LONGER_IN_USE','Phone number no longer used');

    // Privacy concerns
    static readonly PRIVACY_CONCERNS = new KLUserDeleteReason('PRIVACY_CONCERNS','PRIVACY_CONCERNS','Privacy concerns');

    // Other reasons
    static readonly OTHER = new KLUserDeleteReason('OTHER','OTHER','Other reasons');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserDeleteReason.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HAVE_ANOTHER_ACCOUNT','HAVE_ANOTHER_ACCOUNT','Using another account'),
            new KLEnumCase<string>('NO_LONGER_WANT_TO_USE','NO_LONGER_WANT_TO_USE','I no longer want to use it'),
            new KLEnumCase<string>('PHONE_NO_LONGER_IN_USE','PHONE_NO_LONGER_IN_USE','Phone number no longer used'),
            new KLEnumCase<string>('PRIVACY_CONCERNS','PRIVACY_CONCERNS','Privacy concerns'),
            new KLEnumCase<string>('OTHER','OTHER','Other reasons'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserDeleteReason|null {
        switch (val) {
            case KLUserDeleteReason.HAVE_ANOTHER_ACCOUNT.value:return KLUserDeleteReason.HAVE_ANOTHER_ACCOUNT;
            case KLUserDeleteReason.NO_LONGER_WANT_TO_USE.value:return KLUserDeleteReason.NO_LONGER_WANT_TO_USE;
            case KLUserDeleteReason.PHONE_NO_LONGER_IN_USE.value:return KLUserDeleteReason.PHONE_NO_LONGER_IN_USE;
            case KLUserDeleteReason.PRIVACY_CONCERNS.value:return KLUserDeleteReason.PRIVACY_CONCERNS;
            case KLUserDeleteReason.OTHER.value:return KLUserDeleteReason.OTHER;
        }
        return null;
    }
}

/**
 * 用户注销拒绝原因
*/
export class KLUserDeleteRejectionReason extends KLEnum<string>{

    // 存在未完成的订单
    static readonly UNFINISHED_ORDERS = new KLUserDeleteRejectionReason('UNFINISHED_ORDERS','UNFINISHED_ORDERS','存在未完成的订单');

    // 存在未使用的余额
    static readonly UNUSED_BALANCE = new KLUserDeleteRejectionReason('UNUSED_BALANCE','UNUSED_BALANCE','存在未使用的余额');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserDeleteRejectionReason.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNFINISHED_ORDERS','UNFINISHED_ORDERS','存在未完成的订单'),
            new KLEnumCase<string>('UNUSED_BALANCE','UNUSED_BALANCE','存在未使用的余额'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserDeleteRejectionReason|null {
        switch (val) {
            case KLUserDeleteRejectionReason.UNFINISHED_ORDERS.value:return KLUserDeleteRejectionReason.UNFINISHED_ORDERS;
            case KLUserDeleteRejectionReason.UNUSED_BALANCE.value:return KLUserDeleteRejectionReason.UNUSED_BALANCE;
        }
        return null;
    }
}

/**
 * 用户设备操作系统
*/
export class KLUserDeviceOs extends KLEnum<string>{

    // 苹果设备
    static readonly IOS = new KLUserDeviceOs('IOS','IOS','苹果设备');

    // 安卓设备
    static readonly ANDROID = new KLUserDeviceOs('ANDROID','ANDROID','安卓设备');

    // Mac电脑
    static readonly MAC = new KLUserDeviceOs('MAC','MAC','Mac电脑');

    // Windows电脑
    static readonly WINDOWS = new KLUserDeviceOs('WINDOWS','WINDOWS','Windows电脑');

    // 鸿蒙设备
    static readonly HARMONY = new KLUserDeviceOs('HARMONY','HARMONY','鸿蒙设备');

    // 其他设备
    static readonly OTHER = new KLUserDeviceOs('OTHER','OTHER','其他设备');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserDeviceOs.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IOS','IOS','苹果设备'),
            new KLEnumCase<string>('ANDROID','ANDROID','安卓设备'),
            new KLEnumCase<string>('MAC','MAC','Mac电脑'),
            new KLEnumCase<string>('WINDOWS','WINDOWS','Windows电脑'),
            new KLEnumCase<string>('HARMONY','HARMONY','鸿蒙设备'),
            new KLEnumCase<string>('OTHER','OTHER','其他设备'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserDeviceOs|null {
        switch (val) {
            case KLUserDeviceOs.IOS.value:return KLUserDeviceOs.IOS;
            case KLUserDeviceOs.ANDROID.value:return KLUserDeviceOs.ANDROID;
            case KLUserDeviceOs.MAC.value:return KLUserDeviceOs.MAC;
            case KLUserDeviceOs.WINDOWS.value:return KLUserDeviceOs.WINDOWS;
            case KLUserDeviceOs.HARMONY.value:return KLUserDeviceOs.HARMONY;
            case KLUserDeviceOs.OTHER.value:return KLUserDeviceOs.OTHER;
        }
        return null;
    }
}

/**
 * 用户设备状态
*/
export class KLUserDeviceStatus extends KLEnum<string>{

    // Active
    static readonly ACTIVE = new KLUserDeviceStatus('ACTIVE','ACTIVE','Active');

    // Inactive
    static readonly INACTIVE = new KLUserDeviceStatus('INACTIVE','INACTIVE','Inactive');

    // Revoked
    static readonly REVOKED = new KLUserDeviceStatus('REVOKED','REVOKED','Revoked');

    // Lost
    static readonly LOST = new KLUserDeviceStatus('LOST','LOST','Lost');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserDeviceStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ACTIVE','ACTIVE','Active'),
            new KLEnumCase<string>('INACTIVE','INACTIVE','Inactive'),
            new KLEnumCase<string>('REVOKED','REVOKED','Revoked'),
            new KLEnumCase<string>('LOST','LOST','Lost'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserDeviceStatus|null {
        switch (val) {
            case KLUserDeviceStatus.ACTIVE.value:return KLUserDeviceStatus.ACTIVE;
            case KLUserDeviceStatus.INACTIVE.value:return KLUserDeviceStatus.INACTIVE;
            case KLUserDeviceStatus.REVOKED.value:return KLUserDeviceStatus.REVOKED;
            case KLUserDeviceStatus.LOST.value:return KLUserDeviceStatus.LOST;
        }
        return null;
    }
}

/**
 * 用户设备客户端类型
*/
export class KLUserDeviceType extends KLEnum<string>{

    // 移动设备
    static readonly MOBILE = new KLUserDeviceType('MOBILE','MOBILE','移动设备');

    // WAP
    static readonly WAP = new KLUserDeviceType('WAP','WAP','WAP');

    // WEB
    static readonly WEB = new KLUserDeviceType('WEB','WEB','WEB');

    // APPLET
    static readonly APPLET = new KLUserDeviceType('APPLET','APPLET','APPLET');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserDeviceType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MOBILE','MOBILE','移动设备'),
            new KLEnumCase<string>('WAP','WAP','WAP'),
            new KLEnumCase<string>('WEB','WEB','WEB'),
            new KLEnumCase<string>('APPLET','APPLET','APPLET'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserDeviceType|null {
        switch (val) {
            case KLUserDeviceType.MOBILE.value:return KLUserDeviceType.MOBILE;
            case KLUserDeviceType.WAP.value:return KLUserDeviceType.WAP;
            case KLUserDeviceType.WEB.value:return KLUserDeviceType.WEB;
            case KLUserDeviceType.APPLET.value:return KLUserDeviceType.APPLET;
        }
        return null;
    }
}

/**
 * 用户反馈状态
*/
export class KLUserFeedbackStatus extends KLEnum<string>{

    // 待处理
    static readonly PENDING = new KLUserFeedbackStatus('PENDING','PENDING','待处理');

    // 处理中
    static readonly PROCESSING = new KLUserFeedbackStatus('PROCESSING','PROCESSING','处理中');

    // 已解决
    static readonly RESOLVED = new KLUserFeedbackStatus('RESOLVED','RESOLVED','已解决');

    // 已关闭
    static readonly CLOSED = new KLUserFeedbackStatus('CLOSED','CLOSED','已关闭');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserFeedbackStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','待处理'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','处理中'),
            new KLEnumCase<string>('RESOLVED','RESOLVED','已解决'),
            new KLEnumCase<string>('CLOSED','CLOSED','已关闭'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserFeedbackStatus|null {
        switch (val) {
            case KLUserFeedbackStatus.PENDING.value:return KLUserFeedbackStatus.PENDING;
            case KLUserFeedbackStatus.PROCESSING.value:return KLUserFeedbackStatus.PROCESSING;
            case KLUserFeedbackStatus.RESOLVED.value:return KLUserFeedbackStatus.RESOLVED;
            case KLUserFeedbackStatus.CLOSED.value:return KLUserFeedbackStatus.CLOSED;
        }
        return null;
    }
}

/**
 * 用户反馈类型
*/
export class KLUserFeedbackType extends KLEnum<string>{

    // Function issue
    static readonly FUNCTION_ISSUE = new KLUserFeedbackType('FUNCTION_ISSUE','FUNCTION_ISSUE','Function issue');

    // Payment issue
    static readonly PAYMENT_ISSUE = new KLUserFeedbackType('PAYMENT_ISSUE','PAYMENT_ISSUE','Payment issue');

    // Delivery issue
    static readonly DELIVERY_ISSUE = new KLUserFeedbackType('DELIVERY_ISSUE','DELIVERY_ISSUE','Delivery issue');

    // App crash / lag
    static readonly APP_CRASH_LAG = new KLUserFeedbackType('APP_CRASH_LAG','APP_CRASH_LAG','App crash / lag');

    // Suggestions &amp; others
    static readonly SUGGESTIONS_OTHERS = new KLUserFeedbackType('SUGGESTIONS_OTHERS','SUGGESTIONS_OTHERS','Suggestions & others');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserFeedbackType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FUNCTION_ISSUE','FUNCTION_ISSUE','Function issue'),
            new KLEnumCase<string>('PAYMENT_ISSUE','PAYMENT_ISSUE','Payment issue'),
            new KLEnumCase<string>('DELIVERY_ISSUE','DELIVERY_ISSUE','Delivery issue'),
            new KLEnumCase<string>('APP_CRASH_LAG','APP_CRASH_LAG','App crash / lag'),
            new KLEnumCase<string>('SUGGESTIONS_OTHERS','SUGGESTIONS_OTHERS','Suggestions & others'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserFeedbackType|null {
        switch (val) {
            case KLUserFeedbackType.FUNCTION_ISSUE.value:return KLUserFeedbackType.FUNCTION_ISSUE;
            case KLUserFeedbackType.PAYMENT_ISSUE.value:return KLUserFeedbackType.PAYMENT_ISSUE;
            case KLUserFeedbackType.DELIVERY_ISSUE.value:return KLUserFeedbackType.DELIVERY_ISSUE;
            case KLUserFeedbackType.APP_CRASH_LAG.value:return KLUserFeedbackType.APP_CRASH_LAG;
            case KLUserFeedbackType.SUGGESTIONS_OTHERS.value:return KLUserFeedbackType.SUGGESTIONS_OTHERS;
        }
        return null;
    }
}

/**
 * receive status
*/
export class KLUserInviteRecordReceiveStatus extends KLEnum<string>{

    // claimed
    static readonly CLAIMED = new KLUserInviteRecordReceiveStatus('CLAIMED','CLAIMED','claimed');

    // unclaimed
    static readonly UNCLAIMED = new KLUserInviteRecordReceiveStatus('UNCLAIMED','UNCLAIMED','unclaimed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserInviteRecordReceiveStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CLAIMED','CLAIMED','claimed'),
            new KLEnumCase<string>('UNCLAIMED','UNCLAIMED','unclaimed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserInviteRecordReceiveStatus|null {
        switch (val) {
            case KLUserInviteRecordReceiveStatus.CLAIMED.value:return KLUserInviteRecordReceiveStatus.CLAIMED;
            case KLUserInviteRecordReceiveStatus.UNCLAIMED.value:return KLUserInviteRecordReceiveStatus.UNCLAIMED;
        }
        return null;
    }
}

/**
 * 用户登录记录状态
*/
export class KLUserLoginRecordStatus extends KLEnum<string>{

    // 成功
    static readonly SUCCESS = new KLUserLoginRecordStatus('SUCCESS','SUCCESS','成功');

    // 失败
    static readonly FAILED = new KLUserLoginRecordStatus('FAILED','FAILED','失败');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserLoginRecordStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SUCCESS','SUCCESS','成功'),
            new KLEnumCase<string>('FAILED','FAILED','失败'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserLoginRecordStatus|null {
        switch (val) {
            case KLUserLoginRecordStatus.SUCCESS.value:return KLUserLoginRecordStatus.SUCCESS;
            case KLUserLoginRecordStatus.FAILED.value:return KLUserLoginRecordStatus.FAILED;
        }
        return null;
    }
}

/**
 * OAuth平台
*/
export class KLUserOauthBindingPlatform extends KLEnum<string>{

    // Google
    static readonly GOOGLE = new KLUserOauthBindingPlatform('GOOGLE','GOOGLE','Google');

    // Apple
    static readonly APPLE = new KLUserOauthBindingPlatform('APPLE','APPLE','Apple');

    // Facebook
    static readonly FACEBOOK = new KLUserOauthBindingPlatform('FACEBOOK','FACEBOOK','Facebook');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserOauthBindingPlatform.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GOOGLE','GOOGLE','Google'),
            new KLEnumCase<string>('APPLE','APPLE','Apple'),
            new KLEnumCase<string>('FACEBOOK','FACEBOOK','Facebook'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserOauthBindingPlatform|null {
        switch (val) {
            case KLUserOauthBindingPlatform.GOOGLE.value:return KLUserOauthBindingPlatform.GOOGLE;
            case KLUserOauthBindingPlatform.APPLE.value:return KLUserOauthBindingPlatform.APPLE;
            case KLUserOauthBindingPlatform.FACEBOOK.value:return KLUserOauthBindingPlatform.FACEBOOK;
        }
        return null;
    }
}

/**
 * 用户操作类型
*/
export class KLUserOperationType extends KLEnum<string>{

    // 更换手机号
    static readonly CHANGE_MOBILE = new KLUserOperationType('CHANGE_MOBILE','CHANGE_MOBILE','更换手机号');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserOperationType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CHANGE_MOBILE','CHANGE_MOBILE','更换手机号'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserOperationType|null {
        switch (val) {
            case KLUserOperationType.CHANGE_MOBILE.value:return KLUserOperationType.CHANGE_MOBILE;
        }
        return null;
    }
}

/**
 * 用户积分记录业务类型
*/
export class KLUserPointsRecordBiz extends KLEnum<string>{

    // 签到
    static readonly SIGN_IN = new KLUserPointsRecordBiz('SIGN_IN','SIGN_IN','签到');

    // 购买
    static readonly PURCHASE = new KLUserPointsRecordBiz('PURCHASE','PURCHASE','购买');

    // 退款
    static readonly REFUND = new KLUserPointsRecordBiz('REFUND','REFUND','退款');

    // 管理员调整
    static readonly ADMIN_ADJUST = new KLUserPointsRecordBiz('ADMIN_ADJUST','ADMIN_ADJUST','管理员调整');

    // 邀请奖励
    static readonly INVITE_REWARD = new KLUserPointsRecordBiz('INVITE_REWARD','INVITE_REWARD','邀请奖励');

    // 活动奖励
    static readonly ACTIVITY_REWARD = new KLUserPointsRecordBiz('ACTIVITY_REWARD','ACTIVITY_REWARD','活动奖励');

    // 系统赠送
    static readonly SYSTEM_GIFT = new KLUserPointsRecordBiz('SYSTEM_GIFT','SYSTEM_GIFT','系统赠送');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserPointsRecordBiz.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SIGN_IN','SIGN_IN','签到'),
            new KLEnumCase<string>('PURCHASE','PURCHASE','购买'),
            new KLEnumCase<string>('REFUND','REFUND','退款'),
            new KLEnumCase<string>('ADMIN_ADJUST','ADMIN_ADJUST','管理员调整'),
            new KLEnumCase<string>('INVITE_REWARD','INVITE_REWARD','邀请奖励'),
            new KLEnumCase<string>('ACTIVITY_REWARD','ACTIVITY_REWARD','活动奖励'),
            new KLEnumCase<string>('SYSTEM_GIFT','SYSTEM_GIFT','系统赠送'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserPointsRecordBiz|null {
        switch (val) {
            case KLUserPointsRecordBiz.SIGN_IN.value:return KLUserPointsRecordBiz.SIGN_IN;
            case KLUserPointsRecordBiz.PURCHASE.value:return KLUserPointsRecordBiz.PURCHASE;
            case KLUserPointsRecordBiz.REFUND.value:return KLUserPointsRecordBiz.REFUND;
            case KLUserPointsRecordBiz.ADMIN_ADJUST.value:return KLUserPointsRecordBiz.ADMIN_ADJUST;
            case KLUserPointsRecordBiz.INVITE_REWARD.value:return KLUserPointsRecordBiz.INVITE_REWARD;
            case KLUserPointsRecordBiz.ACTIVITY_REWARD.value:return KLUserPointsRecordBiz.ACTIVITY_REWARD;
            case KLUserPointsRecordBiz.SYSTEM_GIFT.value:return KLUserPointsRecordBiz.SYSTEM_GIFT;
        }
        return null;
    }
}

/**
 * 用户积分记录类型
*/
export class KLUserPointsRecordType extends KLEnum<string>{

    // 获得
    static readonly GAIN = new KLUserPointsRecordType('GAIN','GAIN','获得');

    // 消费
    static readonly CONSUMPTION = new KLUserPointsRecordType('CONSUMPTION','CONSUMPTION','消费');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserPointsRecordType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GAIN','GAIN','获得'),
            new KLEnumCase<string>('CONSUMPTION','CONSUMPTION','消费'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserPointsRecordType|null {
        switch (val) {
            case KLUserPointsRecordType.GAIN.value:return KLUserPointsRecordType.GAIN;
            case KLUserPointsRecordType.CONSUMPTION.value:return KLUserPointsRecordType.CONSUMPTION;
        }
        return null;
    }
}

/**
 * 用户性别
*/
export class KLUserProfileGender extends KLEnum<string>{

    // Prefer not to say
    static readonly UNKNOWN = new KLUserProfileGender('UNKNOWN','UNKNOWN','Prefer not to say');

    // Male
    static readonly MALE = new KLUserProfileGender('MALE','MALE','Male');

    // Female
    static readonly FEMALE = new KLUserProfileGender('FEMALE','FEMALE','Female');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserProfileGender.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNKNOWN','UNKNOWN','Prefer not to say'),
            new KLEnumCase<string>('MALE','MALE','Male'),
            new KLEnumCase<string>('FEMALE','FEMALE','Female'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserProfileGender|null {
        switch (val) {
            case KLUserProfileGender.UNKNOWN.value:return KLUserProfileGender.UNKNOWN;
            case KLUserProfileGender.MALE.value:return KLUserProfileGender.MALE;
            case KLUserProfileGender.FEMALE.value:return KLUserProfileGender.FEMALE;
        }
        return null;
    }
}

/**
 * 用户风险标签
*/
export class KLUserRiskTags extends KLEnum<string>{

    // Register within 30 days
    static readonly NEW = new KLUserRiskTags('NEW','NEW','Register within 30 days');

    // Cancel more than 5 times within 7 days
    static readonly HIGH_CANCEL = new KLUserRiskTags('HIGH_CANCEL','HIGH_CANCEL','Cancel more than 5 times within 7 days');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserRiskTags.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NEW','NEW','Register within 30 days'),
            new KLEnumCase<string>('HIGH_CANCEL','HIGH_CANCEL','Cancel more than 5 times within 7 days'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserRiskTags|null {
        switch (val) {
            case KLUserRiskTags.NEW.value:return KLUserRiskTags.NEW;
            case KLUserRiskTags.HIGH_CANCEL.value:return KLUserRiskTags.HIGH_CANCEL;
        }
        return null;
    }
}

/**
 * 用户状态
*/
export class KLUserStatus extends KLEnum<string>{

    // 正常
    static readonly ACTIVE = new KLUserStatus('ACTIVE','ACTIVE','正常');

    // 未激活
    static readonly INACTIVE = new KLUserStatus('INACTIVE','INACTIVE','未激活');

    // 禁用
    static readonly BANNED = new KLUserStatus('BANNED','BANNED','禁用');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ACTIVE','ACTIVE','正常'),
            new KLEnumCase<string>('INACTIVE','INACTIVE','未激活'),
            new KLEnumCase<string>('BANNED','BANNED','禁用'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserStatus|null {
        switch (val) {
            case KLUserStatus.ACTIVE.value:return KLUserStatus.ACTIVE;
            case KLUserStatus.INACTIVE.value:return KLUserStatus.INACTIVE;
            case KLUserStatus.BANNED.value:return KLUserStatus.BANNED;
        }
        return null;
    }
}

/**
 * 钱包交易筛选类型
*/
export class KLWalletTransactionFilterType extends KLEnum<string>{

    // All
    static readonly ALL = new KLWalletTransactionFilterType('ALL','All','All');

    // Income
    static readonly INCOME = new KLWalletTransactionFilterType('INCOME','Income','Income');

    // Expense
    static readonly EXPENSE = new KLWalletTransactionFilterType('EXPENSE','Expense','Expense');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLWalletTransactionFilterType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','All','All'),
            new KLEnumCase<string>('INCOME','Income','Income'),
            new KLEnumCase<string>('EXPENSE','Expense','Expense'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLWalletTransactionFilterType|null {
        switch (val) {
            case KLWalletTransactionFilterType.ALL.value:return KLWalletTransactionFilterType.ALL;
            case KLWalletTransactionFilterType.INCOME.value:return KLWalletTransactionFilterType.INCOME;
            case KLWalletTransactionFilterType.EXPENSE.value:return KLWalletTransactionFilterType.EXPENSE;
        }
        return null;
    }
}

/**
 * 钱包交易类型
*/
export class KLUserWalletAction extends KLEnum<string>{

    // 消费
    static readonly CONSUMPTION = new KLUserWalletAction('CONSUMPTION','CONSUMPTION','消费');

    // 充值
    static readonly RECHARGE = new KLUserWalletAction('RECHARGE','RECHARGE','充值');

    // 冻结
    static readonly FREEZE = new KLUserWalletAction('FREEZE','FREEZE','冻结');

    // 解冻
    static readonly UNFREEZE = new KLUserWalletAction('UNFREEZE','UNFREEZE','解冻');

    // 扣减
    static readonly DEDUCATION = new KLUserWalletAction('DEDUCATION','DEDUCATION','扣减');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserWalletAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CONSUMPTION','CONSUMPTION','消费'),
            new KLEnumCase<string>('RECHARGE','RECHARGE','充值'),
            new KLEnumCase<string>('FREEZE','FREEZE','冻结'),
            new KLEnumCase<string>('UNFREEZE','UNFREEZE','解冻'),
            new KLEnumCase<string>('DEDUCATION','DEDUCATION','扣减'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserWalletAction|null {
        switch (val) {
            case KLUserWalletAction.CONSUMPTION.value:return KLUserWalletAction.CONSUMPTION;
            case KLUserWalletAction.RECHARGE.value:return KLUserWalletAction.RECHARGE;
            case KLUserWalletAction.FREEZE.value:return KLUserWalletAction.FREEZE;
            case KLUserWalletAction.UNFREEZE.value:return KLUserWalletAction.UNFREEZE;
            case KLUserWalletAction.DEDUCATION.value:return KLUserWalletAction.DEDUCATION;
        }
        return null;
    }
}

/**
 * 钱包业务类型
*/
export class KLUserWalletBizType extends KLEnum<string>{

    // Order Payment
    static readonly MALL_ORDER = new KLUserWalletBizType('MALL_ORDER','MALL_ORDER','Order Payment');

    // Order Payment
    static readonly MALL_ORDER_REFUND = new KLUserWalletBizType('MALL_ORDER_REFUND','MALL_ORDER_REFUND','Order Payment');

    // MANUAL ADJUST
    static readonly MANUAL_ADJUST = new KLUserWalletBizType('MANUAL_ADJUST','MANUAL_ADJUST','MANUAL ADJUST');

    // ADMIN OPERATION
    static readonly ADMIN_OPERATION = new KLUserWalletBizType('ADMIN_OPERATION','ADMIN_OPERATION','ADMIN OPERATION');

    // SYSTEM ADJUST
    static readonly SYSTEM_ADJUST = new KLUserWalletBizType('SYSTEM_ADJUST','SYSTEM_ADJUST','SYSTEM ADJUST');

    // PROMOTION REWARD
    static readonly PROMOTION_REWARD = new KLUserWalletBizType('PROMOTION_REWARD','PROMOTION_REWARD','PROMOTION REWARD');

    // 邀请奖励
    static readonly INVITE_REWARD = new KLUserWalletBizType('INVITE_REWARD','INVITE_REWARD','邀请奖励');

    // Balance Recharge
    static readonly RECHARGE_ORDER = new KLUserWalletBizType('RECHARGE_ORDER','RECHARGE_ORDER','Balance Recharge');

    // Rejection Settle
    static readonly REJECTION = new KLUserWalletBizType('REJECTION','REJECTION','Rejection Settle');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserWalletBizType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL_ORDER','MALL_ORDER','Order Payment'),
            new KLEnumCase<string>('MALL_ORDER_REFUND','MALL_ORDER_REFUND','Order Payment'),
            new KLEnumCase<string>('MANUAL_ADJUST','MANUAL_ADJUST','MANUAL ADJUST'),
            new KLEnumCase<string>('ADMIN_OPERATION','ADMIN_OPERATION','ADMIN OPERATION'),
            new KLEnumCase<string>('SYSTEM_ADJUST','SYSTEM_ADJUST','SYSTEM ADJUST'),
            new KLEnumCase<string>('PROMOTION_REWARD','PROMOTION_REWARD','PROMOTION REWARD'),
            new KLEnumCase<string>('INVITE_REWARD','INVITE_REWARD','邀请奖励'),
            new KLEnumCase<string>('RECHARGE_ORDER','RECHARGE_ORDER','Balance Recharge'),
            new KLEnumCase<string>('REJECTION','REJECTION','Rejection Settle'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserWalletBizType|null {
        switch (val) {
            case KLUserWalletBizType.MALL_ORDER.value:return KLUserWalletBizType.MALL_ORDER;
            case KLUserWalletBizType.MALL_ORDER_REFUND.value:return KLUserWalletBizType.MALL_ORDER_REFUND;
            case KLUserWalletBizType.MANUAL_ADJUST.value:return KLUserWalletBizType.MANUAL_ADJUST;
            case KLUserWalletBizType.ADMIN_OPERATION.value:return KLUserWalletBizType.ADMIN_OPERATION;
            case KLUserWalletBizType.SYSTEM_ADJUST.value:return KLUserWalletBizType.SYSTEM_ADJUST;
            case KLUserWalletBizType.PROMOTION_REWARD.value:return KLUserWalletBizType.PROMOTION_REWARD;
            case KLUserWalletBizType.INVITE_REWARD.value:return KLUserWalletBizType.INVITE_REWARD;
            case KLUserWalletBizType.RECHARGE_ORDER.value:return KLUserWalletBizType.RECHARGE_ORDER;
            case KLUserWalletBizType.REJECTION.value:return KLUserWalletBizType.REJECTION;
        }
        return null;
    }
}

/**
 * 钱包交易类型
*/
export class KLUserWalletRecordAction extends KLEnum<string>{

    // 消费
    static readonly CONSUMPTION = new KLUserWalletRecordAction('CONSUMPTION','CONSUMPTION','消费');

    // 充值
    static readonly RECHARGE = new KLUserWalletRecordAction('RECHARGE','RECHARGE','充值');

    // 冻结
    static readonly FREEZE = new KLUserWalletRecordAction('FREEZE','FREEZE','冻结');

    // 解冻
    static readonly UNFREEZE = new KLUserWalletRecordAction('UNFREEZE','UNFREEZE','解冻');

    // 扣减
    static readonly DEDUCATION = new KLUserWalletRecordAction('DEDUCATION','DEDUCATION','扣减');

    // 邀请好友
    static readonly INVITE_FRIEND = new KLUserWalletRecordAction('INVITE_FRIEND','INVITE_FRIEND','邀请好友');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserWalletRecordAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CONSUMPTION','CONSUMPTION','消费'),
            new KLEnumCase<string>('RECHARGE','RECHARGE','充值'),
            new KLEnumCase<string>('FREEZE','FREEZE','冻结'),
            new KLEnumCase<string>('UNFREEZE','UNFREEZE','解冻'),
            new KLEnumCase<string>('DEDUCATION','DEDUCATION','扣减'),
            new KLEnumCase<string>('INVITE_FRIEND','INVITE_FRIEND','邀请好友'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserWalletRecordAction|null {
        switch (val) {
            case KLUserWalletRecordAction.CONSUMPTION.value:return KLUserWalletRecordAction.CONSUMPTION;
            case KLUserWalletRecordAction.RECHARGE.value:return KLUserWalletRecordAction.RECHARGE;
            case KLUserWalletRecordAction.FREEZE.value:return KLUserWalletRecordAction.FREEZE;
            case KLUserWalletRecordAction.UNFREEZE.value:return KLUserWalletRecordAction.UNFREEZE;
            case KLUserWalletRecordAction.DEDUCATION.value:return KLUserWalletRecordAction.DEDUCATION;
            case KLUserWalletRecordAction.INVITE_FRIEND.value:return KLUserWalletRecordAction.INVITE_FRIEND;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeIconGridConfigBgStyle extends KLEnum<string>{

    // 圆形
    static readonly CIRCLE = new KLAppHomeIconGridConfigBgStyle('CIRCLE','CIRCLE','圆形');

    // 方形
    static readonly SQUARE = new KLAppHomeIconGridConfigBgStyle('SQUARE','SQUARE','方形');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeIconGridConfigBgStyle.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CIRCLE','CIRCLE','圆形'),
            new KLEnumCase<string>('SQUARE','SQUARE','方形'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeIconGridConfigBgStyle|null {
        switch (val) {
            case KLAppHomeIconGridConfigBgStyle.CIRCLE.value:return KLAppHomeIconGridConfigBgStyle.CIRCLE;
            case KLAppHomeIconGridConfigBgStyle.SQUARE.value:return KLAppHomeIconGridConfigBgStyle.SQUARE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeIconGridItemJumpType extends KLEnum<string>{

    // 分类
    static readonly CATEGORY = new KLAppHomeIconGridItemJumpType('CATEGORY','CATEGORY','分类');

    // 活动
    static readonly ACTIVITY = new KLAppHomeIconGridItemJumpType('ACTIVITY','ACTIVITY','活动');

    // 标签
    static readonly TAG = new KLAppHomeIconGridItemJumpType('TAG','TAG','标签');

    // URL
    static readonly URL = new KLAppHomeIconGridItemJumpType('URL','URL','URL');

    // 无跳转
    static readonly NONE = new KLAppHomeIconGridItemJumpType('NONE','NONE','无跳转');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeIconGridItemJumpType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CATEGORY','CATEGORY','分类'),
            new KLEnumCase<string>('ACTIVITY','ACTIVITY','活动'),
            new KLEnumCase<string>('TAG','TAG','标签'),
            new KLEnumCase<string>('URL','URL','URL'),
            new KLEnumCase<string>('NONE','NONE','无跳转'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeIconGridItemJumpType|null {
        switch (val) {
            case KLAppHomeIconGridItemJumpType.CATEGORY.value:return KLAppHomeIconGridItemJumpType.CATEGORY;
            case KLAppHomeIconGridItemJumpType.ACTIVITY.value:return KLAppHomeIconGridItemJumpType.ACTIVITY;
            case KLAppHomeIconGridItemJumpType.TAG.value:return KLAppHomeIconGridItemJumpType.TAG;
            case KLAppHomeIconGridItemJumpType.URL.value:return KLAppHomeIconGridItemJumpType.URL;
            case KLAppHomeIconGridItemJumpType.NONE.value:return KLAppHomeIconGridItemJumpType.NONE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeIconGridItemStatus extends KLEnum<string>{

    // 上线
    static readonly ONLINE = new KLAppHomeIconGridItemStatus('ONLINE','ONLINE','上线');

    // 下线
    static readonly OFFLINE = new KLAppHomeIconGridItemStatus('OFFLINE','OFFLINE','下线');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeIconGridItemStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','上线'),
            new KLEnumCase<string>('OFFLINE','OFFLINE','下线'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeIconGridItemStatus|null {
        switch (val) {
            case KLAppHomeIconGridItemStatus.ONLINE.value:return KLAppHomeIconGridItemStatus.ONLINE;
            case KLAppHomeIconGridItemStatus.OFFLINE.value:return KLAppHomeIconGridItemStatus.OFFLINE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeMallGoodsConfigStyle extends KLEnum<string>{

    // 横向滑动
    static readonly CAROUSEL = new KLAppHomeMallGoodsConfigStyle('CAROUSEL','CAROUSEL','横向滑动');

    // 双列瀑布流
    static readonly WATERFALL = new KLAppHomeMallGoodsConfigStyle('WATERFALL','WATERFALL','双列瀑布流');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeMallGoodsConfigStyle.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CAROUSEL','CAROUSEL','横向滑动'),
            new KLEnumCase<string>('WATERFALL','WATERFALL','双列瀑布流'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeMallGoodsConfigStyle|null {
        switch (val) {
            case KLAppHomeMallGoodsConfigStyle.CAROUSEL.value:return KLAppHomeMallGoodsConfigStyle.CAROUSEL;
            case KLAppHomeMallGoodsConfigStyle.WATERFALL.value:return KLAppHomeMallGoodsConfigStyle.WATERFALL;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeMallGoodsItemStatus extends KLEnum<string>{

    // 上线
    static readonly ONLINE = new KLAppHomeMallGoodsItemStatus('ONLINE','ONLINE','上线');

    // 下线
    static readonly OFFLINE = new KLAppHomeMallGoodsItemStatus('OFFLINE','OFFLINE','下线');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeMallGoodsItemStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','上线'),
            new KLEnumCase<string>('OFFLINE','OFFLINE','下线'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeMallGoodsItemStatus|null {
        switch (val) {
            case KLAppHomeMallGoodsItemStatus.ONLINE.value:return KLAppHomeMallGoodsItemStatus.ONLINE;
            case KLAppHomeMallGoodsItemStatus.OFFLINE.value:return KLAppHomeMallGoodsItemStatus.OFFLINE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeModuleStatus extends KLEnum<string>{

    // 上线
    static readonly ONLINE = new KLAppHomeModuleStatus('ONLINE','ONLINE','上线');

    // 下线
    static readonly OFFLINE = new KLAppHomeModuleStatus('OFFLINE','OFFLINE','下线');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeModuleStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','上线'),
            new KLEnumCase<string>('OFFLINE','OFFLINE','下线'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeModuleStatus|null {
        switch (val) {
            case KLAppHomeModuleStatus.ONLINE.value:return KLAppHomeModuleStatus.ONLINE;
            case KLAppHomeModuleStatus.OFFLINE.value:return KLAppHomeModuleStatus.OFFLINE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLAppHomeModuleType extends KLEnum<string>{

    // 金刚区
    static readonly ICON_GRID = new KLAppHomeModuleType('ICON_GRID','ICON_GRID','金刚区');

    // Banner区
    static readonly BANNER = new KLAppHomeModuleType('BANNER','BANNER','Banner区');

    // 商城商品
    static readonly MALL_GOODS = new KLAppHomeModuleType('MALL_GOODS','MALL_GOODS','商城商品');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLAppHomeModuleType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ICON_GRID','ICON_GRID','金刚区'),
            new KLEnumCase<string>('BANNER','BANNER','Banner区'),
            new KLEnumCase<string>('MALL_GOODS','MALL_GOODS','商城商品'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLAppHomeModuleType|null {
        switch (val) {
            case KLAppHomeModuleType.ICON_GRID.value:return KLAppHomeModuleType.ICON_GRID;
            case KLAppHomeModuleType.BANNER.value:return KLAppHomeModuleType.BANNER;
            case KLAppHomeModuleType.MALL_GOODS.value:return KLAppHomeModuleType.MALL_GOODS;
        }
        return null;
    }
}

/**
 * BI统计周期
*/
export class KLBIStatPeriod extends KLEnum<number>{

    // Hourly
    static readonly HOURLY = new KLBIStatPeriod('HOURLY',1,'Hourly');

    // Daily
    static readonly DAILY = new KLBIStatPeriod('DAILY',2,'Daily');

    // Monthly
    static readonly MONTHLY = new KLBIStatPeriod('MONTHLY',4,'Monthly');

    // Yearly
    static readonly YEARLY = new KLBIStatPeriod('YEARLY',6,'Yearly');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLBIStatPeriod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('HOURLY',1,'Hourly'),
            new KLEnumCase<number>('DAILY',2,'Daily'),
            new KLEnumCase<number>('MONTHLY',4,'Monthly'),
            new KLEnumCase<number>('YEARLY',6,'Yearly'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLBIStatPeriod|null {
        switch (val) {
            case KLBIStatPeriod.HOURLY.value:return KLBIStatPeriod.HOURLY;
            case KLBIStatPeriod.DAILY.value:return KLBIStatPeriod.DAILY;
            case KLBIStatPeriod.MONTHLY.value:return KLBIStatPeriod.MONTHLY;
            case KLBIStatPeriod.YEARLY.value:return KLBIStatPeriod.YEARLY;
        }
        return null;
    }
}

/**
 * BI统计类型
*/
export class KLBIStatType extends KLEnum<number>{

    // Mall Total Order Count
    static readonly MALL_TOTAL_NUM = new KLBIStatType('MALL_TOTAL_NUM',200100,'Mall Total Order Count');

    // Mall Total User Count
    static readonly MALL_TOTAL_PER = new KLBIStatType('MALL_TOTAL_PER',200101,'Mall Total User Count');

    // Mall Total Pay Amount
    static readonly MALL_TOTAL_PAY = new KLBIStatType('MALL_TOTAL_PAY',200102,'Mall Total Pay Amount');

    // Mall Total Shipping Amount
    static readonly MALL_TOTAL_SPAY = new KLBIStatType('MALL_TOTAL_SPAY',200104,'Mall Total Shipping Amount');

    // Mall Total Completed Order Count
    static readonly MALL_TOTALC_NUM = new KLBIStatType('MALL_TOTALC_NUM',200200,'Mall Total Completed Order Count');

    // Mall Total Completed User Count
    static readonly MALL_TOTALC_PER = new KLBIStatType('MALL_TOTALC_PER',200201,'Mall Total Completed User Count');

    // Mall Total Completed Pay Amount
    static readonly MALL_TOTALC_PAY = new KLBIStatType('MALL_TOTALC_PAY',200202,'Mall Total Completed Pay Amount');

    // Mall Total Completed Shipping Amount
    static readonly MALL_TOTALC_SPAY = new KLBIStatType('MALL_TOTALC_SPAY',200204,'Mall Total Completed Shipping Amount');

    // Mall New User Day1 Order Count
    static readonly MALL_UR1_NUM = new KLBIStatType('MALL_UR1_NUM',205100,'Mall New User Day1 Order Count');

    // Mall New User Day1 User Count
    static readonly MALL_UR1_PER = new KLBIStatType('MALL_UR1_PER',205101,'Mall New User Day1 User Count');

    // Mall New User Day1 Pay Amount
    static readonly MALL_UR1_PAY = new KLBIStatType('MALL_UR1_PAY',205102,'Mall New User Day1 Pay Amount');

    // Mall New User Day1 Shipping Amount
    static readonly MALL_UR1_SPAY = new KLBIStatType('MALL_UR1_SPAY',205104,'Mall New User Day1 Shipping Amount');

    // Mall New User Day7 Order Count
    static readonly MALL_UR7_NUM = new KLBIStatType('MALL_UR7_NUM',205200,'Mall New User Day7 Order Count');

    // Mall New User Day7 User Count
    static readonly MALL_UR7_PER = new KLBIStatType('MALL_UR7_PER',205201,'Mall New User Day7 User Count');

    // Mall New User Day7 Pay Amount
    static readonly MALL_UR7_PAY = new KLBIStatType('MALL_UR7_PAY',205202,'Mall New User Day7 Pay Amount');

    // Mall New User Day7 Shipping Amount
    static readonly MALL_UR7_SPAY = new KLBIStatType('MALL_UR7_SPAY',205204,'Mall New User Day7 Shipping Amount');

    // Mall New User Day1 Completed Order Count
    static readonly MALL_URC1_NUM = new KLBIStatType('MALL_URC1_NUM',206100,'Mall New User Day1 Completed Order Count');

    // Mall New User Day1 Completed User Count
    static readonly MALL_URC1_PER = new KLBIStatType('MALL_URC1_PER',206101,'Mall New User Day1 Completed User Count');

    // Mall New User Day1 Completed Pay Amount
    static readonly MALL_URC1_PAY = new KLBIStatType('MALL_URC1_PAY',206102,'Mall New User Day1 Completed Pay Amount');

    // Mall New User Day1 Completed Shipping Amount
    static readonly MALL_URC1_SPAY = new KLBIStatType('MALL_URC1_SPAY',206104,'Mall New User Day1 Completed Shipping Amount');

    // Mall New User Day7 Completed Order Count
    static readonly MALL_URC7_NUM = new KLBIStatType('MALL_URC7_NUM',206200,'Mall New User Day7 Completed Order Count');

    // Mall New User Day7 Completed User Count
    static readonly MALL_URC7_PER = new KLBIStatType('MALL_URC7_PER',206201,'Mall New User Day7 Completed User Count');

    // Mall New User Day7 Completed Pay Amount
    static readonly MALL_URC7_PAY = new KLBIStatType('MALL_URC7_PAY',206202,'Mall New User Day7 Completed Pay Amount');

    // Mall New User Day7 Completed Shipping Amount
    static readonly MALL_URC7_SPAY = new KLBIStatType('MALL_URC7_SPAY',206204,'Mall New User Day7 Completed Shipping Amount');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLBIStatType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('MALL_TOTAL_NUM',200100,'Mall Total Order Count'),
            new KLEnumCase<number>('MALL_TOTAL_PER',200101,'Mall Total User Count'),
            new KLEnumCase<number>('MALL_TOTAL_PAY',200102,'Mall Total Pay Amount'),
            new KLEnumCase<number>('MALL_TOTAL_SPAY',200104,'Mall Total Shipping Amount'),
            new KLEnumCase<number>('MALL_TOTALC_NUM',200200,'Mall Total Completed Order Count'),
            new KLEnumCase<number>('MALL_TOTALC_PER',200201,'Mall Total Completed User Count'),
            new KLEnumCase<number>('MALL_TOTALC_PAY',200202,'Mall Total Completed Pay Amount'),
            new KLEnumCase<number>('MALL_TOTALC_SPAY',200204,'Mall Total Completed Shipping Amount'),
            new KLEnumCase<number>('MALL_UR1_NUM',205100,'Mall New User Day1 Order Count'),
            new KLEnumCase<number>('MALL_UR1_PER',205101,'Mall New User Day1 User Count'),
            new KLEnumCase<number>('MALL_UR1_PAY',205102,'Mall New User Day1 Pay Amount'),
            new KLEnumCase<number>('MALL_UR1_SPAY',205104,'Mall New User Day1 Shipping Amount'),
            new KLEnumCase<number>('MALL_UR7_NUM',205200,'Mall New User Day7 Order Count'),
            new KLEnumCase<number>('MALL_UR7_PER',205201,'Mall New User Day7 User Count'),
            new KLEnumCase<number>('MALL_UR7_PAY',205202,'Mall New User Day7 Pay Amount'),
            new KLEnumCase<number>('MALL_UR7_SPAY',205204,'Mall New User Day7 Shipping Amount'),
            new KLEnumCase<number>('MALL_URC1_NUM',206100,'Mall New User Day1 Completed Order Count'),
            new KLEnumCase<number>('MALL_URC1_PER',206101,'Mall New User Day1 Completed User Count'),
            new KLEnumCase<number>('MALL_URC1_PAY',206102,'Mall New User Day1 Completed Pay Amount'),
            new KLEnumCase<number>('MALL_URC1_SPAY',206104,'Mall New User Day1 Completed Shipping Amount'),
            new KLEnumCase<number>('MALL_URC7_NUM',206200,'Mall New User Day7 Completed Order Count'),
            new KLEnumCase<number>('MALL_URC7_PER',206201,'Mall New User Day7 Completed User Count'),
            new KLEnumCase<number>('MALL_URC7_PAY',206202,'Mall New User Day7 Completed Pay Amount'),
            new KLEnumCase<number>('MALL_URC7_SPAY',206204,'Mall New User Day7 Completed Shipping Amount'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLBIStatType|null {
        switch (val) {
            case KLBIStatType.MALL_TOTAL_NUM.value:return KLBIStatType.MALL_TOTAL_NUM;
            case KLBIStatType.MALL_TOTAL_PER.value:return KLBIStatType.MALL_TOTAL_PER;
            case KLBIStatType.MALL_TOTAL_PAY.value:return KLBIStatType.MALL_TOTAL_PAY;
            case KLBIStatType.MALL_TOTAL_SPAY.value:return KLBIStatType.MALL_TOTAL_SPAY;
            case KLBIStatType.MALL_TOTALC_NUM.value:return KLBIStatType.MALL_TOTALC_NUM;
            case KLBIStatType.MALL_TOTALC_PER.value:return KLBIStatType.MALL_TOTALC_PER;
            case KLBIStatType.MALL_TOTALC_PAY.value:return KLBIStatType.MALL_TOTALC_PAY;
            case KLBIStatType.MALL_TOTALC_SPAY.value:return KLBIStatType.MALL_TOTALC_SPAY;
            case KLBIStatType.MALL_UR1_NUM.value:return KLBIStatType.MALL_UR1_NUM;
            case KLBIStatType.MALL_UR1_PER.value:return KLBIStatType.MALL_UR1_PER;
            case KLBIStatType.MALL_UR1_PAY.value:return KLBIStatType.MALL_UR1_PAY;
            case KLBIStatType.MALL_UR1_SPAY.value:return KLBIStatType.MALL_UR1_SPAY;
            case KLBIStatType.MALL_UR7_NUM.value:return KLBIStatType.MALL_UR7_NUM;
            case KLBIStatType.MALL_UR7_PER.value:return KLBIStatType.MALL_UR7_PER;
            case KLBIStatType.MALL_UR7_PAY.value:return KLBIStatType.MALL_UR7_PAY;
            case KLBIStatType.MALL_UR7_SPAY.value:return KLBIStatType.MALL_UR7_SPAY;
            case KLBIStatType.MALL_URC1_NUM.value:return KLBIStatType.MALL_URC1_NUM;
            case KLBIStatType.MALL_URC1_PER.value:return KLBIStatType.MALL_URC1_PER;
            case KLBIStatType.MALL_URC1_PAY.value:return KLBIStatType.MALL_URC1_PAY;
            case KLBIStatType.MALL_URC1_SPAY.value:return KLBIStatType.MALL_URC1_SPAY;
            case KLBIStatType.MALL_URC7_NUM.value:return KLBIStatType.MALL_URC7_NUM;
            case KLBIStatType.MALL_URC7_PER.value:return KLBIStatType.MALL_URC7_PER;
            case KLBIStatType.MALL_URC7_PAY.value:return KLBIStatType.MALL_URC7_PAY;
            case KLBIStatType.MALL_URC7_SPAY.value:return KLBIStatType.MALL_URC7_SPAY;
        }
        return null;
    }
}

/**
 * 客服通知事件类型
*/
export class KLCsNoticeEventType extends KLEnum<string>{

    // cs action
    static readonly CS_ACTION = new KLCsNoticeEventType('CS_ACTION','CS_ACTION','cs action');

    // cs pending
    static readonly CS_PENDING = new KLCsNoticeEventType('CS_PENDING','CS_PENDING','cs pending');

    // click end button
    static readonly CLICK_END_BUTTON = new KLCsNoticeEventType('CLICK_END_BUTTON','CLICK_END_BUTTON','click end button');

    // cs end
    static readonly CS_END = new KLCsNoticeEventType('CS_END','CS_END','cs end');

    // waiting
    static readonly WAITING = new KLCsNoticeEventType('WAITING','WAITING','waiting');

    // destroy group
    static readonly DESTROY_GROUP = new KLCsNoticeEventType('DESTROY_GROUP','DESTROY_GROUP','destroy group');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLCsNoticeEventType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CS_ACTION','CS_ACTION','cs action'),
            new KLEnumCase<string>('CS_PENDING','CS_PENDING','cs pending'),
            new KLEnumCase<string>('CLICK_END_BUTTON','CLICK_END_BUTTON','click end button'),
            new KLEnumCase<string>('CS_END','CS_END','cs end'),
            new KLEnumCase<string>('WAITING','WAITING','waiting'),
            new KLEnumCase<string>('DESTROY_GROUP','DESTROY_GROUP','destroy group'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLCsNoticeEventType|null {
        switch (val) {
            case KLCsNoticeEventType.CS_ACTION.value:return KLCsNoticeEventType.CS_ACTION;
            case KLCsNoticeEventType.CS_PENDING.value:return KLCsNoticeEventType.CS_PENDING;
            case KLCsNoticeEventType.CLICK_END_BUTTON.value:return KLCsNoticeEventType.CLICK_END_BUTTON;
            case KLCsNoticeEventType.CS_END.value:return KLCsNoticeEventType.CS_END;
            case KLCsNoticeEventType.WAITING.value:return KLCsNoticeEventType.WAITING;
            case KLCsNoticeEventType.DESTROY_GROUP.value:return KLCsNoticeEventType.DESTROY_GROUP;
        }
        return null;
    }
}

/**
 * 自定义数据发送端口
*/
export class KLCustomDataSendPort extends KLEnum<number>{

    // default
    static readonly IM = new KLCustomDataSendPort('IM',0,'default');

    // applet service
    static readonly APPLET_SERVICE = new KLCustomDataSendPort('APPLET_SERVICE',1,'applet service');

    // auto reply
    static readonly AUTO_REPLY = new KLCustomDataSendPort('AUTO_REPLY',2,'auto reply');

    // click auto reply
    static readonly CLICK_AUTO_REPLY = new KLCustomDataSendPort('CLICK_AUTO_REPLY',3,'click auto reply');

    // rider send order msg
    static readonly RIDER_SEND_ORDER_MSG = new KLCustomDataSendPort('RIDER_SEND_ORDER_MSG',5,'rider send order msg');

    // merchant send order msg
    static readonly MERCHANT_SEND_ORDER_MSG = new KLCustomDataSendPort('MERCHANT_SEND_ORDER_MSG',6,'merchant send order msg');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLCustomDataSendPort.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('IM',0,'default'),
            new KLEnumCase<number>('APPLET_SERVICE',1,'applet service'),
            new KLEnumCase<number>('AUTO_REPLY',2,'auto reply'),
            new KLEnumCase<number>('CLICK_AUTO_REPLY',3,'click auto reply'),
            new KLEnumCase<number>('RIDER_SEND_ORDER_MSG',5,'rider send order msg'),
            new KLEnumCase<number>('MERCHANT_SEND_ORDER_MSG',6,'merchant send order msg'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLCustomDataSendPort|null {
        switch (val) {
            case KLCustomDataSendPort.IM.value:return KLCustomDataSendPort.IM;
            case KLCustomDataSendPort.APPLET_SERVICE.value:return KLCustomDataSendPort.APPLET_SERVICE;
            case KLCustomDataSendPort.AUTO_REPLY.value:return KLCustomDataSendPort.AUTO_REPLY;
            case KLCustomDataSendPort.CLICK_AUTO_REPLY.value:return KLCustomDataSendPort.CLICK_AUTO_REPLY;
            case KLCustomDataSendPort.RIDER_SEND_ORDER_MSG.value:return KLCustomDataSendPort.RIDER_SEND_ORDER_MSG;
            case KLCustomDataSendPort.MERCHANT_SEND_ORDER_MSG.value:return KLCustomDataSendPort.MERCHANT_SEND_ORDER_MSG;
        }
        return null;
    }
}

/**
 * IM账号类型
*/
export class KLImAccountType extends KLEnum<string>{

    // kmart user
    static readonly KMART_USER = new KLImAccountType('KMART_USER','kmartUser','kmart user');

    // kmart non-logged-in user
    static readonly KMART_NLI_USER = new KLImAccountType('KMART_NLI_USER','kmartNliUser','kmart non-logged-in user');

    // kmart store
    static readonly KMART_STORE = new KLImAccountType('KMART_STORE','kmartStore','kmart store');

    // kmart service
    static readonly KMART_SERVICE = new KLImAccountType('KMART_SERVICE','kmartService','kmart service');

    // kmart system
    static readonly KMART_SYSTEM = new KLImAccountType('KMART_SYSTEM','kmartSystem','kmart system');

    // rider
    static readonly RIDER = new KLImAccountType('RIDER','rider','rider');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLImAccountType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('KMART_USER','kmartUser','kmart user'),
            new KLEnumCase<string>('KMART_NLI_USER','kmartNliUser','kmart non-logged-in user'),
            new KLEnumCase<string>('KMART_STORE','kmartStore','kmart store'),
            new KLEnumCase<string>('KMART_SERVICE','kmartService','kmart service'),
            new KLEnumCase<string>('KMART_SYSTEM','kmartSystem','kmart system'),
            new KLEnumCase<string>('RIDER','rider','rider'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLImAccountType|null {
        switch (val) {
            case KLImAccountType.KMART_USER.value:return KLImAccountType.KMART_USER;
            case KLImAccountType.KMART_NLI_USER.value:return KLImAccountType.KMART_NLI_USER;
            case KLImAccountType.KMART_STORE.value:return KLImAccountType.KMART_STORE;
            case KLImAccountType.KMART_SERVICE.value:return KLImAccountType.KMART_SERVICE;
            case KLImAccountType.KMART_SYSTEM.value:return KLImAccountType.KMART_SYSTEM;
            case KLImAccountType.RIDER.value:return KLImAccountType.RIDER;
        }
        return null;
    }
}

/**
 * IM机器人类型
*/
export class KLImBotType extends KLEnum<string>{

    // scene
    static readonly SCENE = new KLImBotType('SCENE','scene','scene');

    // reply
    static readonly REPLY = new KLImBotType('REPLY','reply','reply');

    // guest
    static readonly GUEST = new KLImBotType('GUEST','guest','guest');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLImBotType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SCENE','scene','scene'),
            new KLEnumCase<string>('REPLY','reply','reply'),
            new KLEnumCase<string>('GUEST','guest','guest'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLImBotType|null {
        switch (val) {
            case KLImBotType.SCENE.value:return KLImBotType.SCENE;
            case KLImBotType.REPLY.value:return KLImBotType.REPLY;
            case KLImBotType.GUEST.value:return KLImBotType.GUEST;
        }
        return null;
    }
}

/**
 * 客服接入历史记录会话类型
*/
export class KLImCsAccessHistoryRecordSessionType extends KLEnum<string>{

    // chat
    static readonly C2C = new KLImCsAccessHistoryRecordSessionType('C2C','C2C','chat');

    // group
    static readonly GROUP = new KLImCsAccessHistoryRecordSessionType('GROUP','GROUP','group');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLImCsAccessHistoryRecordSessionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('C2C','C2C','chat'),
            new KLEnumCase<string>('GROUP','GROUP','group'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLImCsAccessHistoryRecordSessionType|null {
        switch (val) {
            case KLImCsAccessHistoryRecordSessionType.C2C.value:return KLImCsAccessHistoryRecordSessionType.C2C;
            case KLImCsAccessHistoryRecordSessionType.GROUP.value:return KLImCsAccessHistoryRecordSessionType.GROUP;
        }
        return null;
    }
}

/**
 * 客服接入会话类型
*/
export class KLImCsAccessRecordSessionType extends KLEnum<string>{

    // chat
    static readonly C2C = new KLImCsAccessRecordSessionType('C2C','C2C','chat');

    // group
    static readonly GROUP = new KLImCsAccessRecordSessionType('GROUP','GROUP','group');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLImCsAccessRecordSessionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('C2C','C2C','chat'),
            new KLEnumCase<string>('GROUP','GROUP','group'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLImCsAccessRecordSessionType|null {
        switch (val) {
            case KLImCsAccessRecordSessionType.C2C.value:return KLImCsAccessRecordSessionType.C2C;
            case KLImCsAccessRecordSessionType.GROUP.value:return KLImCsAccessRecordSessionType.GROUP;
        }
        return null;
    }
}

/**
 * 客服接入会话状态
*/
export class KLImCsAccessRecordStatus extends KLEnum<string>{

    // pending
    static readonly PENDING = new KLImCsAccessRecordStatus('PENDING','PENDING','pending');

    // wait
    static readonly WAIT = new KLImCsAccessRecordStatus('WAIT','WAIT','wait');

    // chat
    static readonly CHAT = new KLImCsAccessRecordStatus('CHAT','CHAT','chat');

    // end
    static readonly END = new KLImCsAccessRecordStatus('END','END','end');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLImCsAccessRecordStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','pending'),
            new KLEnumCase<string>('WAIT','WAIT','wait'),
            new KLEnumCase<string>('CHAT','CHAT','chat'),
            new KLEnumCase<string>('END','END','end'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLImCsAccessRecordStatus|null {
        switch (val) {
            case KLImCsAccessRecordStatus.PENDING.value:return KLImCsAccessRecordStatus.PENDING;
            case KLImCsAccessRecordStatus.WAIT.value:return KLImCsAccessRecordStatus.WAIT;
            case KLImCsAccessRecordStatus.CHAT.value:return KLImCsAccessRecordStatus.CHAT;
            case KLImCsAccessRecordStatus.END.value:return KLImCsAccessRecordStatus.END;
        }
        return null;
    }
}

/**
 * 快捷回复模板接收者角色
*/
export class KLMsgQuickReplyTplReceiverRole extends KLEnum<string>{

    // user
    static readonly USER = new KLMsgQuickReplyTplReceiverRole('USER','USER','user');

    // rider
    static readonly RIDER = new KLMsgQuickReplyTplReceiverRole('RIDER','RIDER','rider');

    // store
    static readonly STORE = new KLMsgQuickReplyTplReceiverRole('STORE','STORE','store');

    // service
    static readonly SERVICE = new KLMsgQuickReplyTplReceiverRole('SERVICE','SERVICE','service');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMsgQuickReplyTplReceiverRole.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER','USER','user'),
            new KLEnumCase<string>('RIDER','RIDER','rider'),
            new KLEnumCase<string>('STORE','STORE','store'),
            new KLEnumCase<string>('SERVICE','SERVICE','service'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMsgQuickReplyTplReceiverRole|null {
        switch (val) {
            case KLMsgQuickReplyTplReceiverRole.USER.value:return KLMsgQuickReplyTplReceiverRole.USER;
            case KLMsgQuickReplyTplReceiverRole.RIDER.value:return KLMsgQuickReplyTplReceiverRole.RIDER;
            case KLMsgQuickReplyTplReceiverRole.STORE.value:return KLMsgQuickReplyTplReceiverRole.STORE;
            case KLMsgQuickReplyTplReceiverRole.SERVICE.value:return KLMsgQuickReplyTplReceiverRole.SERVICE;
        }
        return null;
    }
}

/**
 * 消息快捷回复模板发送者角色
*/
export class KLMsgQuickReplyTplSenderRole extends KLEnum<string>{

    // user
    static readonly USER = new KLMsgQuickReplyTplSenderRole('USER','USER','user');

    // rider
    static readonly RIDER = new KLMsgQuickReplyTplSenderRole('RIDER','RIDER','rider');

    // store
    static readonly STORE = new KLMsgQuickReplyTplSenderRole('STORE','STORE','store');

    // service
    static readonly SERVICE = new KLMsgQuickReplyTplSenderRole('SERVICE','SERVICE','service');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMsgQuickReplyTplSenderRole.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('USER','USER','user'),
            new KLEnumCase<string>('RIDER','RIDER','rider'),
            new KLEnumCase<string>('STORE','STORE','store'),
            new KLEnumCase<string>('SERVICE','SERVICE','service'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMsgQuickReplyTplSenderRole|null {
        switch (val) {
            case KLMsgQuickReplyTplSenderRole.USER.value:return KLMsgQuickReplyTplSenderRole.USER;
            case KLMsgQuickReplyTplSenderRole.RIDER.value:return KLMsgQuickReplyTplSenderRole.RIDER;
            case KLMsgQuickReplyTplSenderRole.STORE.value:return KLMsgQuickReplyTplSenderRole.STORE;
            case KLMsgQuickReplyTplSenderRole.SERVICE.value:return KLMsgQuickReplyTplSenderRole.SERVICE;
        }
        return null;
    }
}

/**
 * 消息快捷回复模板状态
*/
export class KLMsgQuickReplyTplStatus extends KLEnum<string>{

    // enabled
    static readonly ENABLED = new KLMsgQuickReplyTplStatus('ENABLED','ENABLED','enabled');

    // disabled
    static readonly DISABLED = new KLMsgQuickReplyTplStatus('DISABLED','DISABLED','disabled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMsgQuickReplyTplStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ENABLED','ENABLED','enabled'),
            new KLEnumCase<string>('DISABLED','DISABLED','disabled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMsgQuickReplyTplStatus|null {
        switch (val) {
            case KLMsgQuickReplyTplStatus.ENABLED.value:return KLMsgQuickReplyTplStatus.ENABLED;
            case KLMsgQuickReplyTplStatus.DISABLED.value:return KLMsgQuickReplyTplStatus.DISABLED;
        }
        return null;
    }
}

/**
 * 通知事件类型
*/
export class KLNoticeEventType extends KLEnum<string>{

    // mall order created
    static readonly MALL_ORDER_CREATED = new KLNoticeEventType('MALL_ORDER_CREATED','MALL_ORDER_CREATED','mall order created');

    // mall order created pending payment notice
    static readonly MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE = new KLNoticeEventType('MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE','MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE','mall order created pending payment notice');

    // mall order paid
    static readonly MALL_ORDER_PAID = new KLNoticeEventType('MALL_ORDER_PAID','MALL_ORDER_PAID','mall order paid');

    // mall order delivery dispatched
    static readonly MALL_ORDER_DELIVERY_DISPATCHED = new KLNoticeEventType('MALL_ORDER_DELIVERY_DISPATCHED','MALL_ORDER_DELIVERY_DISPATCHED','mall order delivery dispatched');

    // mall order delivery accept
    static readonly MALL_ORDER_DELIVERY_ACCEPT = new KLNoticeEventType('MALL_ORDER_DELIVERY_ACCEPT','MALL_ORDER_DELIVERY_ACCEPT','mall order delivery accept');

    // mall order delivery ready for pick up
    static readonly MALL_ORDER_DELIVERY_READY_FOR_PICK_UP = new KLNoticeEventType('MALL_ORDER_DELIVERY_READY_FOR_PICK_UP','MALL_ORDER_DELIVERY_READY_FOR_PICK_UP','mall order delivery ready for pick up');

    // mall order delivery pick up
    static readonly MALL_ORDER_DELIVERY_PICK_UP = new KLNoticeEventType('MALL_ORDER_DELIVERY_PICK_UP','MALL_ORDER_DELIVERY_PICK_UP','mall order delivery pick up');

    // mall order delivery arrived
    static readonly MALL_ORDER_DELIVERY_ARRIVED = new KLNoticeEventType('MALL_ORDER_DELIVERY_ARRIVED','MALL_ORDER_DELIVERY_ARRIVED','mall order delivery arrived');

    // mall order delivery completed
    static readonly MALL_ORDER_DELIVERY_COMPLETED = new KLNoticeEventType('MALL_ORDER_DELIVERY_COMPLETED','MALL_ORDER_DELIVERY_COMPLETED','mall order delivery completed');

    // mall order stockout refund
    static readonly MALL_ORDER_STOCKOUT_REFUND = new KLNoticeEventType('MALL_ORDER_STOCKOUT_REFUND','MALL_ORDER_STOCKOUT_REFUND','mall order stockout refund');

    // mall order after sale approved
    static readonly MALL_ORDER_AFTER_SALE_APPROVED = new KLNoticeEventType('MALL_ORDER_AFTER_SALE_APPROVED','MALL_ORDER_AFTER_SALE_APPROVED','mall order after sale approved');

    // mall order after sale rejected
    static readonly MALL_ORDER_AFTER_SALE_REJECTED = new KLNoticeEventType('MALL_ORDER_AFTER_SALE_REJECTED','MALL_ORDER_AFTER_SALE_REJECTED','mall order after sale rejected');

    // mall order after sale submitted
    static readonly MALL_ORDER_AFTER_SALE_SUBMITTED = new KLNoticeEventType('MALL_ORDER_AFTER_SALE_SUBMITTED','MALL_ORDER_AFTER_SALE_SUBMITTED','mall order after sale submitted');

    // mall order pay expire cancelled
    static readonly MALL_ORDER_PAY_EXPIRE_CANCELLED = new KLNoticeEventType('MALL_ORDER_PAY_EXPIRE_CANCELLED','MALL_ORDER_PAY_EXPIRE_CANCELLED','mall order pay expire cancelled');

    // mall order delivery time expired
    static readonly MALL_ORDER_DELIVERY_TIME_EXPIRED = new KLNoticeEventType('MALL_ORDER_DELIVERY_TIME_EXPIRED','MALL_ORDER_DELIVERY_TIME_EXPIRED','mall order delivery time expired');

    // mall order unpaid cancelled
    static readonly MALL_ORDER_UNPAID_CANCELLED = new KLNoticeEventType('MALL_ORDER_UNPAID_CANCELLED','MALL_ORDER_UNPAID_CANCELLED','mall order unpaid cancelled');

    // mall order paid cancelled admin
    static readonly MALL_ORDER_PAID_CANCELLED_ADMIN = new KLNoticeEventType('MALL_ORDER_PAID_CANCELLED_ADMIN','MALL_ORDER_PAID_CANCELLED_ADMIN','mall order paid cancelled admin');

    // mall order paid cancelled user
    static readonly MALL_ORDER_PAID_CANCELLED_USER = new KLNoticeEventType('MALL_ORDER_PAID_CANCELLED_USER','MALL_ORDER_PAID_CANCELLED_USER','mall order paid cancelled user');

    // mall order after sale delivery completed
    static readonly MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED = new KLNoticeEventType('MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED','MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED','mall order after sale delivery completed');

    // issue invitation rewards
    static readonly ISSUE_INVITATION_REWARDS = new KLNoticeEventType('ISSUE_INVITATION_REWARDS','ISSUE_INVITATION_REWARDS','issue invitation rewards');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLNoticeEventType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL_ORDER_CREATED','MALL_ORDER_CREATED','mall order created'),
            new KLEnumCase<string>('MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE','MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE','mall order created pending payment notice'),
            new KLEnumCase<string>('MALL_ORDER_PAID','MALL_ORDER_PAID','mall order paid'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_DISPATCHED','MALL_ORDER_DELIVERY_DISPATCHED','mall order delivery dispatched'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_ACCEPT','MALL_ORDER_DELIVERY_ACCEPT','mall order delivery accept'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_READY_FOR_PICK_UP','MALL_ORDER_DELIVERY_READY_FOR_PICK_UP','mall order delivery ready for pick up'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_PICK_UP','MALL_ORDER_DELIVERY_PICK_UP','mall order delivery pick up'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_ARRIVED','MALL_ORDER_DELIVERY_ARRIVED','mall order delivery arrived'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_COMPLETED','MALL_ORDER_DELIVERY_COMPLETED','mall order delivery completed'),
            new KLEnumCase<string>('MALL_ORDER_STOCKOUT_REFUND','MALL_ORDER_STOCKOUT_REFUND','mall order stockout refund'),
            new KLEnumCase<string>('MALL_ORDER_AFTER_SALE_APPROVED','MALL_ORDER_AFTER_SALE_APPROVED','mall order after sale approved'),
            new KLEnumCase<string>('MALL_ORDER_AFTER_SALE_REJECTED','MALL_ORDER_AFTER_SALE_REJECTED','mall order after sale rejected'),
            new KLEnumCase<string>('MALL_ORDER_AFTER_SALE_SUBMITTED','MALL_ORDER_AFTER_SALE_SUBMITTED','mall order after sale submitted'),
            new KLEnumCase<string>('MALL_ORDER_PAY_EXPIRE_CANCELLED','MALL_ORDER_PAY_EXPIRE_CANCELLED','mall order pay expire cancelled'),
            new KLEnumCase<string>('MALL_ORDER_DELIVERY_TIME_EXPIRED','MALL_ORDER_DELIVERY_TIME_EXPIRED','mall order delivery time expired'),
            new KLEnumCase<string>('MALL_ORDER_UNPAID_CANCELLED','MALL_ORDER_UNPAID_CANCELLED','mall order unpaid cancelled'),
            new KLEnumCase<string>('MALL_ORDER_PAID_CANCELLED_ADMIN','MALL_ORDER_PAID_CANCELLED_ADMIN','mall order paid cancelled admin'),
            new KLEnumCase<string>('MALL_ORDER_PAID_CANCELLED_USER','MALL_ORDER_PAID_CANCELLED_USER','mall order paid cancelled user'),
            new KLEnumCase<string>('MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED','MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED','mall order after sale delivery completed'),
            new KLEnumCase<string>('ISSUE_INVITATION_REWARDS','ISSUE_INVITATION_REWARDS','issue invitation rewards'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLNoticeEventType|null {
        switch (val) {
            case KLNoticeEventType.MALL_ORDER_CREATED.value:return KLNoticeEventType.MALL_ORDER_CREATED;
            case KLNoticeEventType.MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE.value:return KLNoticeEventType.MALL_ORDER_CREATED_PENDING_PAYMENT_NOTICE;
            case KLNoticeEventType.MALL_ORDER_PAID.value:return KLNoticeEventType.MALL_ORDER_PAID;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_DISPATCHED.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_DISPATCHED;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_ACCEPT.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_ACCEPT;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_READY_FOR_PICK_UP.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_READY_FOR_PICK_UP;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_PICK_UP.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_PICK_UP;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_ARRIVED.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_ARRIVED;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_COMPLETED.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_COMPLETED;
            case KLNoticeEventType.MALL_ORDER_STOCKOUT_REFUND.value:return KLNoticeEventType.MALL_ORDER_STOCKOUT_REFUND;
            case KLNoticeEventType.MALL_ORDER_AFTER_SALE_APPROVED.value:return KLNoticeEventType.MALL_ORDER_AFTER_SALE_APPROVED;
            case KLNoticeEventType.MALL_ORDER_AFTER_SALE_REJECTED.value:return KLNoticeEventType.MALL_ORDER_AFTER_SALE_REJECTED;
            case KLNoticeEventType.MALL_ORDER_AFTER_SALE_SUBMITTED.value:return KLNoticeEventType.MALL_ORDER_AFTER_SALE_SUBMITTED;
            case KLNoticeEventType.MALL_ORDER_PAY_EXPIRE_CANCELLED.value:return KLNoticeEventType.MALL_ORDER_PAY_EXPIRE_CANCELLED;
            case KLNoticeEventType.MALL_ORDER_DELIVERY_TIME_EXPIRED.value:return KLNoticeEventType.MALL_ORDER_DELIVERY_TIME_EXPIRED;
            case KLNoticeEventType.MALL_ORDER_UNPAID_CANCELLED.value:return KLNoticeEventType.MALL_ORDER_UNPAID_CANCELLED;
            case KLNoticeEventType.MALL_ORDER_PAID_CANCELLED_ADMIN.value:return KLNoticeEventType.MALL_ORDER_PAID_CANCELLED_ADMIN;
            case KLNoticeEventType.MALL_ORDER_PAID_CANCELLED_USER.value:return KLNoticeEventType.MALL_ORDER_PAID_CANCELLED_USER;
            case KLNoticeEventType.MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED.value:return KLNoticeEventType.MALL_ORDER_AFTER_SALE_DELIVERY_COMPLETED;
            case KLNoticeEventType.ISSUE_INVITATION_REWARDS.value:return KLNoticeEventType.ISSUE_INVITATION_REWARDS;
        }
        return null;
    }
}

/**
 * 客服会话按钮类型
*/
export class KLSessionButtonType extends KLEnum<string>{

    // message summary
    static readonly MESSAGE_SUMMARY = new KLSessionButtonType('MESSAGE_SUMMARY','message_summary','message summary');

    // close session
    static readonly CLOSE_SESSION = new KLSessionButtonType('CLOSE_SESSION','close_session','close session');

    // history orders
    static readonly HISTORY_ORDERS = new KLSessionButtonType('HISTORY_ORDERS','history_orders','history orders');

    // search goods
    static readonly SEARCH_GOODS = new KLSessionButtonType('SEARCH_GOODS','search_goods','search goods');

    // quick reply
    static readonly QUICK_REPLY = new KLSessionButtonType('QUICK_REPLY','quick_reply','quick reply');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSessionButtonType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MESSAGE_SUMMARY','message_summary','message summary'),
            new KLEnumCase<string>('CLOSE_SESSION','close_session','close session'),
            new KLEnumCase<string>('HISTORY_ORDERS','history_orders','history orders'),
            new KLEnumCase<string>('SEARCH_GOODS','search_goods','search goods'),
            new KLEnumCase<string>('QUICK_REPLY','quick_reply','quick reply'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSessionButtonType|null {
        switch (val) {
            case KLSessionButtonType.MESSAGE_SUMMARY.value:return KLSessionButtonType.MESSAGE_SUMMARY;
            case KLSessionButtonType.CLOSE_SESSION.value:return KLSessionButtonType.CLOSE_SESSION;
            case KLSessionButtonType.HISTORY_ORDERS.value:return KLSessionButtonType.HISTORY_ORDERS;
            case KLSessionButtonType.SEARCH_GOODS.value:return KLSessionButtonType.SEARCH_GOODS;
            case KLSessionButtonType.QUICK_REPLY.value:return KLSessionButtonType.QUICK_REPLY;
        }
        return null;
    }
}

/**
 * 会话配置类型
*/
export class KLSessionConfigType extends KLEnum<string>{

    // chat
    static readonly C2C = new KLSessionConfigType('C2C','c2c','chat');

    // group
    static readonly GROUP = new KLSessionConfigType('GROUP','group','group');

    // notice
    static readonly NOTICE = new KLSessionConfigType('NOTICE','notice','notice');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSessionConfigType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('C2C','c2c','chat'),
            new KLEnumCase<string>('GROUP','group','group'),
            new KLEnumCase<string>('NOTICE','notice','notice'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSessionConfigType|null {
        switch (val) {
            case KLSessionConfigType.C2C.value:return KLSessionConfigType.C2C;
            case KLSessionConfigType.GROUP.value:return KLSessionConfigType.GROUP;
            case KLSessionConfigType.NOTICE.value:return KLSessionConfigType.NOTICE;
        }
        return null;
    }
}

/**
 * 会话标准标记
*/
export class KLSessionStandardTag extends KLEnum<number>{

    // waiting
    static readonly WAITING = new KLSessionStandardTag('WAITING',33,'waiting');

    // chatting
    static readonly CHATTING = new KLSessionStandardTag('CHATTING',34,'chatting');

    // pending transfer
    static readonly PENDING_TRANSFER = new KLSessionStandardTag('PENDING_TRANSFER',35,'pending transfer');

    // end mark
    static readonly END_MARK = new KLSessionStandardTag('END_MARK',36,'end mark');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>(null,null,defLabel),
            ... KLSessionStandardTag.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<number>[] {
        return [
            new KLEnumCase<number>('WAITING',33,'waiting'),
            new KLEnumCase<number>('CHATTING',34,'chatting'),
            new KLEnumCase<number>('PENDING_TRANSFER',35,'pending transfer'),
            new KLEnumCase<number>('END_MARK',36,'end mark'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:number):KLSessionStandardTag|null {
        switch (val) {
            case KLSessionStandardTag.WAITING.value:return KLSessionStandardTag.WAITING;
            case KLSessionStandardTag.CHATTING.value:return KLSessionStandardTag.CHATTING;
            case KLSessionStandardTag.PENDING_TRANSFER.value:return KLSessionStandardTag.PENDING_TRANSFER;
            case KLSessionStandardTag.END_MARK.value:return KLSessionStandardTag.END_MARK;
        }
        return null;
    }
}

/**
 * 会话类型
*/
export class KLSessionType extends KLEnum<string>{

    // chat
    static readonly C2C = new KLSessionType('C2C','C2C','chat');

    // group
    static readonly GROUP = new KLSessionType('GROUP','GROUP','group');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSessionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('C2C','C2C','chat'),
            new KLEnumCase<string>('GROUP','GROUP','group'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSessionType|null {
        switch (val) {
            case KLSessionType.C2C.value:return KLSessionType.C2C;
            case KLSessionType.GROUP.value:return KLSessionType.GROUP;
        }
        return null;
    }
}

/**
 * 系统通知接收范围
*/
export class KLSysNoticeReceiveScope extends KLEnum<string>{

    // all
    static readonly ALL = new KLSysNoticeReceiveScope('ALL','ALL','all');

    // user
    static readonly USER = new KLSysNoticeReceiveScope('USER','USER','user');

    // merchant
    static readonly MERCHANT = new KLSysNoticeReceiveScope('MERCHANT','MERCHANT','merchant');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSysNoticeReceiveScope.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','ALL','all'),
            new KLEnumCase<string>('USER','USER','user'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','merchant'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSysNoticeReceiveScope|null {
        switch (val) {
            case KLSysNoticeReceiveScope.ALL.value:return KLSysNoticeReceiveScope.ALL;
            case KLSysNoticeReceiveScope.USER.value:return KLSysNoticeReceiveScope.USER;
            case KLSysNoticeReceiveScope.MERCHANT.value:return KLSysNoticeReceiveScope.MERCHANT;
        }
        return null;
    }
}

/**
 * IM消息自定义数据类型
*/
export class KLTIMCustomElemType extends KLEnum<string>{

    // goods
    static readonly GOODS = new KLTIMCustomElemType('GOODS','5','goods');

    // automatic reply
    static readonly AUTOMATIC_REPLY = new KLTIMCustomElemType('AUTOMATIC_REPLY','6','automatic reply');

    // cs evaluate
    static readonly CS_EVALUATE = new KLTIMCustomElemType('CS_EVALUATE','7','cs evaluate');

    // cs prompt message
    static readonly CS_PROMPT_MESSAGE = new KLTIMCustomElemType('CS_PROMPT_MESSAGE','8','cs prompt message');

    // cs notice
    static readonly CS_NOTICE = new KLTIMCustomElemType('CS_NOTICE','9','cs notice');

    // notice
    static readonly NOTICE = new KLTIMCustomElemType('NOTICE','10','notice');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLTIMCustomElemType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GOODS','5','goods'),
            new KLEnumCase<string>('AUTOMATIC_REPLY','6','automatic reply'),
            new KLEnumCase<string>('CS_EVALUATE','7','cs evaluate'),
            new KLEnumCase<string>('CS_PROMPT_MESSAGE','8','cs prompt message'),
            new KLEnumCase<string>('CS_NOTICE','9','cs notice'),
            new KLEnumCase<string>('NOTICE','10','notice'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLTIMCustomElemType|null {
        switch (val) {
            case KLTIMCustomElemType.GOODS.value:return KLTIMCustomElemType.GOODS;
            case KLTIMCustomElemType.AUTOMATIC_REPLY.value:return KLTIMCustomElemType.AUTOMATIC_REPLY;
            case KLTIMCustomElemType.CS_EVALUATE.value:return KLTIMCustomElemType.CS_EVALUATE;
            case KLTIMCustomElemType.CS_PROMPT_MESSAGE.value:return KLTIMCustomElemType.CS_PROMPT_MESSAGE;
            case KLTIMCustomElemType.CS_NOTICE.value:return KLTIMCustomElemType.CS_NOTICE;
            case KLTIMCustomElemType.NOTICE.value:return KLTIMCustomElemType.NOTICE;
        }
        return null;
    }
}

/**
 * 翻译提供商
*/
export class KLTranslateProvider extends KLEnum<string>{

    // google
    static readonly GOOGLE = new KLTranslateProvider('GOOGLE','GOOGLE','google');

    // youdao
    static readonly YOUDAO = new KLTranslateProvider('YOUDAO','YOUDAO','youdao');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLTranslateProvider.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GOOGLE','GOOGLE','google'),
            new KLEnumCase<string>('YOUDAO','YOUDAO','youdao'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLTranslateProvider|null {
        switch (val) {
            case KLTranslateProvider.GOOGLE.value:return KLTranslateProvider.GOOGLE;
            case KLTranslateProvider.YOUDAO.value:return KLTranslateProvider.YOUDAO;
        }
        return null;
    }
}

/**
 * 用户会话按钮类型
*/
export class KLUserSessionButtonType extends KLEnum<string>{

    // quick reply
    static readonly QUICK_REPLY = new KLUserSessionButtonType('QUICK_REPLY','quick_reply','quick reply');

    // contact service
    static readonly CONTACT_SERVICE = new KLUserSessionButtonType('CONTACT_SERVICE','contact_service','contact service');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserSessionButtonType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('QUICK_REPLY','quick_reply','quick reply'),
            new KLEnumCase<string>('CONTACT_SERVICE','contact_service','contact service'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserSessionButtonType|null {
        switch (val) {
            case KLUserSessionButtonType.QUICK_REPLY.value:return KLUserSessionButtonType.QUICK_REPLY;
            case KLUserSessionButtonType.CONTACT_SERVICE.value:return KLUserSessionButtonType.CONTACT_SERVICE;
        }
        return null;
    }
}

/**
 * 广告事件日志行为
*/
export class KLMktAdEventLogAction extends KLEnum<string>{

    // impression
    static readonly IMPRESSION = new KLMktAdEventLogAction('IMPRESSION','IMPRESSION','impression');

    // click
    static readonly CLICK = new KLMktAdEventLogAction('CLICK','CLICK','click');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdEventLogAction.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IMPRESSION','IMPRESSION','impression'),
            new KLEnumCase<string>('CLICK','CLICK','click'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdEventLogAction|null {
        switch (val) {
            case KLMktAdEventLogAction.IMPRESSION.value:return KLMktAdEventLogAction.IMPRESSION;
            case KLMktAdEventLogAction.CLICK.value:return KLMktAdEventLogAction.CLICK;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdJumpType extends KLEnum<string>{

    // product
    static readonly PRODUCT = new KLMktAdJumpType('PRODUCT','PRODUCT','product');

    // category
    static readonly CATEGORY = new KLMktAdJumpType('CATEGORY','CATEGORY','category');

    // activity
    static readonly ACTIVITY = new KLMktAdJumpType('ACTIVITY','ACTIVITY','activity');

    // tag
    static readonly TAG = new KLMktAdJumpType('TAG','TAG','tag');

    // external
    static readonly EXTERNAL = new KLMktAdJumpType('EXTERNAL','EXTERNAL','external');

    // none
    static readonly NONE = new KLMktAdJumpType('NONE','NONE','none');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdJumpType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PRODUCT','PRODUCT','product'),
            new KLEnumCase<string>('CATEGORY','CATEGORY','category'),
            new KLEnumCase<string>('ACTIVITY','ACTIVITY','activity'),
            new KLEnumCase<string>('TAG','TAG','tag'),
            new KLEnumCase<string>('EXTERNAL','EXTERNAL','external'),
            new KLEnumCase<string>('NONE','NONE','none'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdJumpType|null {
        switch (val) {
            case KLMktAdJumpType.PRODUCT.value:return KLMktAdJumpType.PRODUCT;
            case KLMktAdJumpType.CATEGORY.value:return KLMktAdJumpType.CATEGORY;
            case KLMktAdJumpType.ACTIVITY.value:return KLMktAdJumpType.ACTIVITY;
            case KLMktAdJumpType.TAG.value:return KLMktAdJumpType.TAG;
            case KLMktAdJumpType.EXTERNAL.value:return KLMktAdJumpType.EXTERNAL;
            case KLMktAdJumpType.NONE.value:return KLMktAdJumpType.NONE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdSlotDevice extends KLEnum<string>{

    // all
    static readonly ALL = new KLMktAdSlotDevice('ALL','ALL','all');

    // pc
    static readonly PC = new KLMktAdSlotDevice('PC','PC','pc');

    // h5
    static readonly H5 = new KLMktAdSlotDevice('H5','H5','h5');

    // app
    static readonly APP = new KLMktAdSlotDevice('APP','APP','app');

    // wechat mini program
    static readonly WECHAT_MINI_PROGRAM = new KLMktAdSlotDevice('WECHAT_MINI_PROGRAM','WECHAT_MINI_PROGRAM','wechat mini program');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdSlotDevice.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','ALL','all'),
            new KLEnumCase<string>('PC','PC','pc'),
            new KLEnumCase<string>('H5','H5','h5'),
            new KLEnumCase<string>('APP','APP','app'),
            new KLEnumCase<string>('WECHAT_MINI_PROGRAM','WECHAT_MINI_PROGRAM','wechat mini program'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdSlotDevice|null {
        switch (val) {
            case KLMktAdSlotDevice.ALL.value:return KLMktAdSlotDevice.ALL;
            case KLMktAdSlotDevice.PC.value:return KLMktAdSlotDevice.PC;
            case KLMktAdSlotDevice.H5.value:return KLMktAdSlotDevice.H5;
            case KLMktAdSlotDevice.APP.value:return KLMktAdSlotDevice.APP;
            case KLMktAdSlotDevice.WECHAT_MINI_PROGRAM.value:return KLMktAdSlotDevice.WECHAT_MINI_PROGRAM;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdSlotPageType extends KLEnum<string>{

    // universal
    static readonly UNIVERSAL = new KLMktAdSlotPageType('UNIVERSAL','UNIVERSAL','universal');

    // home
    static readonly HOME = new KLMktAdSlotPageType('HOME','HOME','home');

    // category
    static readonly CATEGORY = new KLMktAdSlotPageType('CATEGORY','CATEGORY','category');

    // product
    static readonly PRODUCT = new KLMktAdSlotPageType('PRODUCT','PRODUCT','product');

    // activity
    static readonly ACTIVITY = new KLMktAdSlotPageType('ACTIVITY','ACTIVITY','activity');

    // topic
    static readonly TOPIC = new KLMktAdSlotPageType('TOPIC','TOPIC','topic');

    // merchant
    static readonly MERCHANT = new KLMktAdSlotPageType('MERCHANT','MERCHANT','merchant');

    // merchant store
    static readonly MERCHANT_STORE = new KLMktAdSlotPageType('MERCHANT_STORE','MERCHANT_STORE','merchant store');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdSlotPageType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UNIVERSAL','UNIVERSAL','universal'),
            new KLEnumCase<string>('HOME','HOME','home'),
            new KLEnumCase<string>('CATEGORY','CATEGORY','category'),
            new KLEnumCase<string>('PRODUCT','PRODUCT','product'),
            new KLEnumCase<string>('ACTIVITY','ACTIVITY','activity'),
            new KLEnumCase<string>('TOPIC','TOPIC','topic'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','merchant'),
            new KLEnumCase<string>('MERCHANT_STORE','MERCHANT_STORE','merchant store'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdSlotPageType|null {
        switch (val) {
            case KLMktAdSlotPageType.UNIVERSAL.value:return KLMktAdSlotPageType.UNIVERSAL;
            case KLMktAdSlotPageType.HOME.value:return KLMktAdSlotPageType.HOME;
            case KLMktAdSlotPageType.CATEGORY.value:return KLMktAdSlotPageType.CATEGORY;
            case KLMktAdSlotPageType.PRODUCT.value:return KLMktAdSlotPageType.PRODUCT;
            case KLMktAdSlotPageType.ACTIVITY.value:return KLMktAdSlotPageType.ACTIVITY;
            case KLMktAdSlotPageType.TOPIC.value:return KLMktAdSlotPageType.TOPIC;
            case KLMktAdSlotPageType.MERCHANT.value:return KLMktAdSlotPageType.MERCHANT;
            case KLMktAdSlotPageType.MERCHANT_STORE.value:return KLMktAdSlotPageType.MERCHANT_STORE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdSlotPopupAdPageType extends KLEnum<string>{

    // home
    static readonly HOME = new KLMktAdSlotPopupAdPageType('HOME','HOME','home');

    // cart
    static readonly CART = new KLMktAdSlotPopupAdPageType('CART','CART','cart');

    // message
    static readonly MESSAGE = new KLMktAdSlotPopupAdPageType('MESSAGE','MESSAGE','message');

    // user center
    static readonly UC = new KLMktAdSlotPopupAdPageType('UC','UC','user center');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdSlotPopupAdPageType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HOME','HOME','home'),
            new KLEnumCase<string>('CART','CART','cart'),
            new KLEnumCase<string>('MESSAGE','MESSAGE','message'),
            new KLEnumCase<string>('UC','UC','user center'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdSlotPopupAdPageType|null {
        switch (val) {
            case KLMktAdSlotPopupAdPageType.HOME.value:return KLMktAdSlotPopupAdPageType.HOME;
            case KLMktAdSlotPopupAdPageType.CART.value:return KLMktAdSlotPopupAdPageType.CART;
            case KLMktAdSlotPopupAdPageType.MESSAGE.value:return KLMktAdSlotPopupAdPageType.MESSAGE;
            case KLMktAdSlotPopupAdPageType.UC.value:return KLMktAdSlotPopupAdPageType.UC;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdSlotStatType extends KLEnum<string>{

    // daily
    static readonly DAILY = new KLMktAdSlotStatType('DAILY','DAILY','daily');

    // weekly
    static readonly WEEKLY = new KLMktAdSlotStatType('WEEKLY','WEEKLY','weekly');

    // monthly
    static readonly MONTHLY = new KLMktAdSlotStatType('MONTHLY','MONTHLY','monthly');

    // total
    static readonly TOTAL = new KLMktAdSlotStatType('TOTAL','TOTAL','total');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdSlotStatType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DAILY','DAILY','daily'),
            new KLEnumCase<string>('WEEKLY','WEEKLY','weekly'),
            new KLEnumCase<string>('MONTHLY','MONTHLY','monthly'),
            new KLEnumCase<string>('TOTAL','TOTAL','total'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdSlotStatType|null {
        switch (val) {
            case KLMktAdSlotStatType.DAILY.value:return KLMktAdSlotStatType.DAILY;
            case KLMktAdSlotStatType.WEEKLY.value:return KLMktAdSlotStatType.WEEKLY;
            case KLMktAdSlotStatType.MONTHLY.value:return KLMktAdSlotStatType.MONTHLY;
            case KLMktAdSlotStatType.TOTAL.value:return KLMktAdSlotStatType.TOTAL;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdSlotStatus extends KLEnum<string>{

    // online
    static readonly ONLINE = new KLMktAdSlotStatus('ONLINE','ONLINE','online');

    // offline
    static readonly OFFLINE = new KLMktAdSlotStatus('OFFLINE','OFFLINE','offline');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdSlotStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','online'),
            new KLEnumCase<string>('OFFLINE','OFFLINE','offline'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdSlotStatus|null {
        switch (val) {
            case KLMktAdSlotStatus.ONLINE.value:return KLMktAdSlotStatus.ONLINE;
            case KLMktAdSlotStatus.OFFLINE.value:return KLMktAdSlotStatus.OFFLINE;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdSlotStyle extends KLEnum<string>{

    // square (1:1) 342×342
    static readonly SQUARE = new KLMktAdSlotStyle('SQUARE','SQUARE','square (1:1) 342×342');

    // horizontal banner (2:1) 750×375
    static readonly HORIZONTAL_BANNER = new KLMktAdSlotStyle('HORIZONTAL_BANNER','HORIZONTAL_BANNER','horizontal banner (2:1) 750×375');

    // wide banner (3:1) 750×277
    static readonly WIDE_BANNER = new KLMktAdSlotStyle('WIDE_BANNER','WIDE_BANNER','wide banner (3:1) 750×277');

    // portrait (3:4) 224×299
    static readonly PORTRAIT = new KLMktAdSlotStyle('PORTRAIT','PORTRAIT','portrait (3:4) 224×299');

    // popup 584×840
    static readonly POPUP = new KLMktAdSlotStyle('POPUP','POPUP','popup 584×840');

    // original
    static readonly ORIGINAL = new KLMktAdSlotStyle('ORIGINAL','ORIGINAL','original');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdSlotStyle.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SQUARE','SQUARE','square (1:1) 342×342'),
            new KLEnumCase<string>('HORIZONTAL_BANNER','HORIZONTAL_BANNER','horizontal banner (2:1) 750×375'),
            new KLEnumCase<string>('WIDE_BANNER','WIDE_BANNER','wide banner (3:1) 750×277'),
            new KLEnumCase<string>('PORTRAIT','PORTRAIT','portrait (3:4) 224×299'),
            new KLEnumCase<string>('POPUP','POPUP','popup 584×840'),
            new KLEnumCase<string>('ORIGINAL','ORIGINAL','original'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdSlotStyle|null {
        switch (val) {
            case KLMktAdSlotStyle.SQUARE.value:return KLMktAdSlotStyle.SQUARE;
            case KLMktAdSlotStyle.HORIZONTAL_BANNER.value:return KLMktAdSlotStyle.HORIZONTAL_BANNER;
            case KLMktAdSlotStyle.WIDE_BANNER.value:return KLMktAdSlotStyle.WIDE_BANNER;
            case KLMktAdSlotStyle.PORTRAIT.value:return KLMktAdSlotStyle.PORTRAIT;
            case KLMktAdSlotStyle.POPUP.value:return KLMktAdSlotStyle.POPUP;
            case KLMktAdSlotStyle.ORIGINAL.value:return KLMktAdSlotStyle.ORIGINAL;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktAdStatus extends KLEnum<string>{

    // disabled
    static readonly DISABLED = new KLMktAdStatus('DISABLED','DISABLED','disabled');

    // enabled
    static readonly ENABLED = new KLMktAdStatus('ENABLED','ENABLED','enabled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktAdStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DISABLED','DISABLED','disabled'),
            new KLEnumCase<string>('ENABLED','ENABLED','enabled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktAdStatus|null {
        switch (val) {
            case KLMktAdStatus.DISABLED.value:return KLMktAdStatus.DISABLED;
            case KLMktAdStatus.ENABLED.value:return KLMktAdStatus.ENABLED;
        }
        return null;
    }
}

/**
 * 优惠券活动领取结果状态
*/
export class KLMktCouponCampaignClaimStatus extends KLEnum<string>{

    // success
    static readonly SUCCESS = new KLMktCouponCampaignClaimStatus('SUCCESS','SUCCESS','success');

    // skipped
    static readonly SKIPPED = new KLMktCouponCampaignClaimStatus('SKIPPED','SKIPPED','skipped');

    // failed
    static readonly FAILED = new KLMktCouponCampaignClaimStatus('FAILED','FAILED','failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponCampaignClaimStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SUCCESS','SUCCESS','success'),
            new KLEnumCase<string>('SKIPPED','SKIPPED','skipped'),
            new KLEnumCase<string>('FAILED','FAILED','failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponCampaignClaimStatus|null {
        switch (val) {
            case KLMktCouponCampaignClaimStatus.SUCCESS.value:return KLMktCouponCampaignClaimStatus.SUCCESS;
            case KLMktCouponCampaignClaimStatus.SKIPPED.value:return KLMktCouponCampaignClaimStatus.SKIPPED;
            case KLMktCouponCampaignClaimStatus.FAILED.value:return KLMktCouponCampaignClaimStatus.FAILED;
        }
        return null;
    }
}

/**
 * 优惠券活动状态
*/
export class KLMktCouponCampaignStatus extends KLEnum<string>{

    // upcoming
    static readonly UPCOMING = new KLMktCouponCampaignStatus('UPCOMING','UPCOMING','upcoming');

    // active
    static readonly ACTIVE = new KLMktCouponCampaignStatus('ACTIVE','ACTIVE','active');

    // ended
    static readonly ENDED = new KLMktCouponCampaignStatus('ENDED','ENDED','ended');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponCampaignStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('UPCOMING','UPCOMING','upcoming'),
            new KLEnumCase<string>('ACTIVE','ACTIVE','active'),
            new KLEnumCase<string>('ENDED','ENDED','ended'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponCampaignStatus|null {
        switch (val) {
            case KLMktCouponCampaignStatus.UPCOMING.value:return KLMktCouponCampaignStatus.UPCOMING;
            case KLMktCouponCampaignStatus.ACTIVE.value:return KLMktCouponCampaignStatus.ACTIVE;
            case KLMktCouponCampaignStatus.ENDED.value:return KLMktCouponCampaignStatus.ENDED;
        }
        return null;
    }
}

/**
 * 优惠券活动类型
*/
export class KLMktCouponCampaignType extends KLEnum<string>{

    // signup
    static readonly SIGNUP = new KLMktCouponCampaignType('SIGNUP','SIGNUP','signup');

    // invite
    static readonly INVITE = new KLMktCouponCampaignType('INVITE','INVITE','invite');

    // promotion
    static readonly PROMOTION = new KLMktCouponCampaignType('PROMOTION','PROMOTION','promotion');

    // festival
    static readonly FESTIVAL = new KLMktCouponCampaignType('FESTIVAL','FESTIVAL','festival');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponCampaignType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SIGNUP','SIGNUP','signup'),
            new KLEnumCase<string>('INVITE','INVITE','invite'),
            new KLEnumCase<string>('PROMOTION','PROMOTION','promotion'),
            new KLEnumCase<string>('FESTIVAL','FESTIVAL','festival'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponCampaignType|null {
        switch (val) {
            case KLMktCouponCampaignType.SIGNUP.value:return KLMktCouponCampaignType.SIGNUP;
            case KLMktCouponCampaignType.INVITE.value:return KLMktCouponCampaignType.INVITE;
            case KLMktCouponCampaignType.PROMOTION.value:return KLMktCouponCampaignType.PROMOTION;
            case KLMktCouponCampaignType.FESTIVAL.value:return KLMktCouponCampaignType.FESTIVAL;
        }
        return null;
    }
}

/**
 * 发送优惠券任务-发送类型
*/
export class KLMktCouponIssueRecordIssueType extends KLEnum<string>{

    // manual
    static readonly MANUAL = new KLMktCouponIssueRecordIssueType('MANUAL','MANUAL','manual');

    // campaign
    static readonly CAMPAIGN = new KLMktCouponIssueRecordIssueType('CAMPAIGN','CAMPAIGN','campaign');

    // register
    static readonly REGISTER = new KLMktCouponIssueRecordIssueType('REGISTER','REGISTER','register');

    // checkin
    static readonly CHECKIN = new KLMktCouponIssueRecordIssueType('CHECKIN','CHECKIN','checkin');

    // task
    static readonly TASK = new KLMktCouponIssueRecordIssueType('TASK','TASK','task');

    // system
    static readonly SYSTEM = new KLMktCouponIssueRecordIssueType('SYSTEM','SYSTEM','system');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponIssueRecordIssueType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MANUAL','MANUAL','manual'),
            new KLEnumCase<string>('CAMPAIGN','CAMPAIGN','campaign'),
            new KLEnumCase<string>('REGISTER','REGISTER','register'),
            new KLEnumCase<string>('CHECKIN','CHECKIN','checkin'),
            new KLEnumCase<string>('TASK','TASK','task'),
            new KLEnumCase<string>('SYSTEM','SYSTEM','system'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponIssueRecordIssueType|null {
        switch (val) {
            case KLMktCouponIssueRecordIssueType.MANUAL.value:return KLMktCouponIssueRecordIssueType.MANUAL;
            case KLMktCouponIssueRecordIssueType.CAMPAIGN.value:return KLMktCouponIssueRecordIssueType.CAMPAIGN;
            case KLMktCouponIssueRecordIssueType.REGISTER.value:return KLMktCouponIssueRecordIssueType.REGISTER;
            case KLMktCouponIssueRecordIssueType.CHECKIN.value:return KLMktCouponIssueRecordIssueType.CHECKIN;
            case KLMktCouponIssueRecordIssueType.TASK.value:return KLMktCouponIssueRecordIssueType.TASK;
            case KLMktCouponIssueRecordIssueType.SYSTEM.value:return KLMktCouponIssueRecordIssueType.SYSTEM;
        }
        return null;
    }
}

/**
 * 发送优惠券任务-发送状态
*/
export class KLMktCouponIssueRecordStatus extends KLEnum<string>{

    // pending
    static readonly PENDING = new KLMktCouponIssueRecordStatus('PENDING','PENDING','pending');

    // processing
    static readonly PROCESSING = new KLMktCouponIssueRecordStatus('PROCESSING','PROCESSING','processing');

    // completed
    static readonly COMPLETED = new KLMktCouponIssueRecordStatus('COMPLETED','COMPLETED','completed');

    // failed
    static readonly FAILED = new KLMktCouponIssueRecordStatus('FAILED','FAILED','failed');

    // cancelled
    static readonly CANCELLED = new KLMktCouponIssueRecordStatus('CANCELLED','CANCELLED','cancelled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponIssueRecordStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','pending'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','processing'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','completed'),
            new KLEnumCase<string>('FAILED','FAILED','failed'),
            new KLEnumCase<string>('CANCELLED','CANCELLED','cancelled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponIssueRecordStatus|null {
        switch (val) {
            case KLMktCouponIssueRecordStatus.PENDING.value:return KLMktCouponIssueRecordStatus.PENDING;
            case KLMktCouponIssueRecordStatus.PROCESSING.value:return KLMktCouponIssueRecordStatus.PROCESSING;
            case KLMktCouponIssueRecordStatus.COMPLETED.value:return KLMktCouponIssueRecordStatus.COMPLETED;
            case KLMktCouponIssueRecordStatus.FAILED.value:return KLMktCouponIssueRecordStatus.FAILED;
            case KLMktCouponIssueRecordStatus.CANCELLED.value:return KLMktCouponIssueRecordStatus.CANCELLED;
        }
        return null;
    }
}

/**
 * 优惠券发放任务派发类型
*/
export class KLMktCouponIssueTasksSendType extends KLEnum<string>{

    // Immediately
    static readonly IMMEDIATELY = new KLMktCouponIssueTasksSendType('IMMEDIATELY','IMMEDIATELY','Immediately');

    // Scheduled
    static readonly SCHEDULED = new KLMktCouponIssueTasksSendType('SCHEDULED','SCHEDULED','Scheduled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponIssueTasksSendType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IMMEDIATELY','IMMEDIATELY','Immediately'),
            new KLEnumCase<string>('SCHEDULED','SCHEDULED','Scheduled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponIssueTasksSendType|null {
        switch (val) {
            case KLMktCouponIssueTasksSendType.IMMEDIATELY.value:return KLMktCouponIssueTasksSendType.IMMEDIATELY;
            case KLMktCouponIssueTasksSendType.SCHEDULED.value:return KLMktCouponIssueTasksSendType.SCHEDULED;
        }
        return null;
    }
}

/**
 * 优惠券发放任务状态
*/
export class KLMktCouponIssueTasksStatus extends KLEnum<string>{

    // pending
    static readonly PENDING = new KLMktCouponIssueTasksStatus('PENDING','PENDING','pending');

    // processing
    static readonly PROCESSING = new KLMktCouponIssueTasksStatus('PROCESSING','PROCESSING','processing');

    // completed
    static readonly COMPLETED = new KLMktCouponIssueTasksStatus('COMPLETED','COMPLETED','completed');

    // failed
    static readonly FAILED = new KLMktCouponIssueTasksStatus('FAILED','FAILED','failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponIssueTasksStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','pending'),
            new KLEnumCase<string>('PROCESSING','PROCESSING','processing'),
            new KLEnumCase<string>('COMPLETED','COMPLETED','completed'),
            new KLEnumCase<string>('FAILED','FAILED','failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponIssueTasksStatus|null {
        switch (val) {
            case KLMktCouponIssueTasksStatus.PENDING.value:return KLMktCouponIssueTasksStatus.PENDING;
            case KLMktCouponIssueTasksStatus.PROCESSING.value:return KLMktCouponIssueTasksStatus.PROCESSING;
            case KLMktCouponIssueTasksStatus.COMPLETED.value:return KLMktCouponIssueTasksStatus.COMPLETED;
            case KLMktCouponIssueTasksStatus.FAILED.value:return KLMktCouponIssueTasksStatus.FAILED;
        }
        return null;
    }
}

/**
 * 使用优惠券跳转页面类型
*/
export class KLMktCouponTplJumpType extends KLEnum<string>{

    // home
    static readonly HOME = new KLMktCouponTplJumpType('HOME','HOME','home');

    // category
    static readonly CATEGORY = new KLMktCouponTplJumpType('CATEGORY','CATEGORY','category');

    // activity
    static readonly ACTIVITY = new KLMktCouponTplJumpType('ACTIVITY','ACTIVITY','activity');

    // url
    static readonly URL = new KLMktCouponTplJumpType('URL','URL','url');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponTplJumpType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HOME','HOME','home'),
            new KLEnumCase<string>('CATEGORY','CATEGORY','category'),
            new KLEnumCase<string>('ACTIVITY','ACTIVITY','activity'),
            new KLEnumCase<string>('URL','URL','url'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponTplJumpType|null {
        switch (val) {
            case KLMktCouponTplJumpType.HOME.value:return KLMktCouponTplJumpType.HOME;
            case KLMktCouponTplJumpType.CATEGORY.value:return KLMktCouponTplJumpType.CATEGORY;
            case KLMktCouponTplJumpType.ACTIVITY.value:return KLMktCouponTplJumpType.ACTIVITY;
            case KLMktCouponTplJumpType.URL.value:return KLMktCouponTplJumpType.URL;
        }
        return null;
    }
}

/**
 * 优惠券适用范围类型
*/
export class KLMktCouponTplScopeType extends KLEnum<string>{

    // all
    static readonly ALL = new KLMktCouponTplScopeType('ALL','ALL','all');

    // category
    static readonly CATEGORY = new KLMktCouponTplScopeType('CATEGORY','CATEGORY','category');

    // merchant
    static readonly MERCHANT = new KLMktCouponTplScopeType('MERCHANT','MERCHANT','merchant');

    // store
    static readonly STORE = new KLMktCouponTplScopeType('STORE','STORE','store');

    // goods
    static readonly GOODS = new KLMktCouponTplScopeType('GOODS','GOODS','goods');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponTplScopeType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL','ALL','all'),
            new KLEnumCase<string>('CATEGORY','CATEGORY','category'),
            new KLEnumCase<string>('MERCHANT','MERCHANT','merchant'),
            new KLEnumCase<string>('STORE','STORE','store'),
            new KLEnumCase<string>('GOODS','GOODS','goods'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponTplScopeType|null {
        switch (val) {
            case KLMktCouponTplScopeType.ALL.value:return KLMktCouponTplScopeType.ALL;
            case KLMktCouponTplScopeType.CATEGORY.value:return KLMktCouponTplScopeType.CATEGORY;
            case KLMktCouponTplScopeType.MERCHANT.value:return KLMktCouponTplScopeType.MERCHANT;
            case KLMktCouponTplScopeType.STORE.value:return KLMktCouponTplScopeType.STORE;
            case KLMktCouponTplScopeType.GOODS.value:return KLMktCouponTplScopeType.GOODS;
        }
        return null;
    }
}

/**
 * 优惠券模板状态
*/
export class KLMktCouponTplStatus extends KLEnum<string>{

    // draft
    static readonly DRAFT = new KLMktCouponTplStatus('DRAFT','DRAFT','draft');

    // active
    static readonly ACTIVE = new KLMktCouponTplStatus('ACTIVE','ACTIVE','active');

    // paused
    static readonly PAUSED = new KLMktCouponTplStatus('PAUSED','PAUSED','paused');

    // expired
    static readonly EXPIRED = new KLMktCouponTplStatus('EXPIRED','EXPIRED','expired');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponTplStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DRAFT','DRAFT','draft'),
            new KLEnumCase<string>('ACTIVE','ACTIVE','active'),
            new KLEnumCase<string>('PAUSED','PAUSED','paused'),
            new KLEnumCase<string>('EXPIRED','EXPIRED','expired'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponTplStatus|null {
        switch (val) {
            case KLMktCouponTplStatus.DRAFT.value:return KLMktCouponTplStatus.DRAFT;
            case KLMktCouponTplStatus.ACTIVE.value:return KLMktCouponTplStatus.ACTIVE;
            case KLMktCouponTplStatus.PAUSED.value:return KLMktCouponTplStatus.PAUSED;
            case KLMktCouponTplStatus.EXPIRED.value:return KLMktCouponTplStatus.EXPIRED;
        }
        return null;
    }
}

/**
 * 优惠券类型
*/
export class KLMktCouponTplType extends KLEnum<string>{

    // product discount
    static readonly PRODUCT_DISCOUNT = new KLMktCouponTplType('PRODUCT_DISCOUNT','PRODUCT_DISCOUNT','product discount');

    // product full reduction
    static readonly PRODUCT_FULL_REDUCTION = new KLMktCouponTplType('PRODUCT_FULL_REDUCTION','PRODUCT_FULL_REDUCTION','product full reduction');

    // shipping discount
    static readonly SHIPPING_DISCOUNT = new KLMktCouponTplType('SHIPPING_DISCOUNT','SHIPPING_DISCOUNT','shipping discount');

    // shipping full reduction
    static readonly SHIPPING_FULL_REDUCTION = new KLMktCouponTplType('SHIPPING_FULL_REDUCTION','SHIPPING_FULL_REDUCTION','shipping full reduction');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponTplType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PRODUCT_DISCOUNT','PRODUCT_DISCOUNT','product discount'),
            new KLEnumCase<string>('PRODUCT_FULL_REDUCTION','PRODUCT_FULL_REDUCTION','product full reduction'),
            new KLEnumCase<string>('SHIPPING_DISCOUNT','SHIPPING_DISCOUNT','shipping discount'),
            new KLEnumCase<string>('SHIPPING_FULL_REDUCTION','SHIPPING_FULL_REDUCTION','shipping full reduction'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponTplType|null {
        switch (val) {
            case KLMktCouponTplType.PRODUCT_DISCOUNT.value:return KLMktCouponTplType.PRODUCT_DISCOUNT;
            case KLMktCouponTplType.PRODUCT_FULL_REDUCTION.value:return KLMktCouponTplType.PRODUCT_FULL_REDUCTION;
            case KLMktCouponTplType.SHIPPING_DISCOUNT.value:return KLMktCouponTplType.SHIPPING_DISCOUNT;
            case KLMktCouponTplType.SHIPPING_FULL_REDUCTION.value:return KLMktCouponTplType.SHIPPING_FULL_REDUCTION;
        }
        return null;
    }
}

/**
 * 优惠券有效期类型
*/
export class KLMktCouponTplValidityType extends KLEnum<string>{

    // fixed period
    static readonly FIXED_PERIOD = new KLMktCouponTplValidityType('FIXED_PERIOD','FIXED_PERIOD','fixed period');

    // fixed days
    static readonly FIXED_DAYS = new KLMktCouponTplValidityType('FIXED_DAYS','FIXED_DAYS','fixed days');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktCouponTplValidityType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FIXED_PERIOD','FIXED_PERIOD','fixed period'),
            new KLEnumCase<string>('FIXED_DAYS','FIXED_DAYS','fixed days'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktCouponTplValidityType|null {
        switch (val) {
            case KLMktCouponTplValidityType.FIXED_PERIOD.value:return KLMktCouponTplValidityType.FIXED_PERIOD;
            case KLMktCouponTplValidityType.FIXED_DAYS.value:return KLMktCouponTplValidityType.FIXED_DAYS;
        }
        return null;
    }
}

/**
 * 营销订单类型
*/
export class KLMktOrderType extends KLEnum<string>{

    // mall
    static readonly MALL = new KLMktOrderType('MALL','MALL','mall');

    // recharge
    static readonly RECHARGE = new KLMktOrderType('RECHARGE','RECHARGE','recharge');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktOrderType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('MALL','MALL','mall'),
            new KLEnumCase<string>('RECHARGE','RECHARGE','recharge'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktOrderType|null {
        switch (val) {
            case KLMktOrderType.MALL.value:return KLMktOrderType.MALL;
            case KLMktOrderType.RECHARGE.value:return KLMktOrderType.RECHARGE;
        }
        return null;
    }
}

/**
 * 配送方式
*/
export class KLMktDeliveryCampaignDeliveryMethod extends KLEnum<string>{

    // K Life Delivery
    static readonly K_LIFE_DELIVERY = new KLMktDeliveryCampaignDeliveryMethod('K_LIFE_DELIVERY','K_LIFE_DELIVERY','K Life Delivery');

    // 覆盖商铺配送
    static readonly STORE_DELIVERY = new KLMktDeliveryCampaignDeliveryMethod('STORE_DELIVERY','STORE_DELIVERY','覆盖商铺配送');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktDeliveryCampaignDeliveryMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('K_LIFE_DELIVERY','K_LIFE_DELIVERY','K Life Delivery'),
            new KLEnumCase<string>('STORE_DELIVERY','STORE_DELIVERY','覆盖商铺配送'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktDeliveryCampaignDeliveryMethod|null {
        switch (val) {
            case KLMktDeliveryCampaignDeliveryMethod.K_LIFE_DELIVERY.value:return KLMktDeliveryCampaignDeliveryMethod.K_LIFE_DELIVERY;
            case KLMktDeliveryCampaignDeliveryMethod.STORE_DELIVERY.value:return KLMktDeliveryCampaignDeliveryMethod.STORE_DELIVERY;
        }
        return null;
    }
}

/**
 * 减免类型
*/
export class KLMktDeliveryCampaignReductionType extends KLEnum<string>{

    // 公里数
    static readonly DISTANCE_KM = new KLMktDeliveryCampaignReductionType('DISTANCE_KM','DISTANCE_KM','公里数');

    // 订单实付金额
    static readonly ORDER_PAID_AMOUNT = new KLMktDeliveryCampaignReductionType('ORDER_PAID_AMOUNT','ORDER_PAID_AMOUNT','订单实付金额');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktDeliveryCampaignReductionType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DISTANCE_KM','DISTANCE_KM','公里数'),
            new KLEnumCase<string>('ORDER_PAID_AMOUNT','ORDER_PAID_AMOUNT','订单实付金额'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktDeliveryCampaignReductionType|null {
        switch (val) {
            case KLMktDeliveryCampaignReductionType.DISTANCE_KM.value:return KLMktDeliveryCampaignReductionType.DISTANCE_KM;
            case KLMktDeliveryCampaignReductionType.ORDER_PAID_AMOUNT.value:return KLMktDeliveryCampaignReductionType.ORDER_PAID_AMOUNT;
        }
        return null;
    }
}

/**
 * 配送费营销活动启用状态
*/
export class KLMktDeliveryCampaignStatus extends KLEnum<string>{

    // disabled
    static readonly DISABLED = new KLMktDeliveryCampaignStatus('DISABLED','DISABLED','disabled');

    // enabled
    static readonly ENABLED = new KLMktDeliveryCampaignStatus('ENABLED','ENABLED','enabled');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktDeliveryCampaignStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('DISABLED','DISABLED','disabled'),
            new KLEnumCase<string>('ENABLED','ENABLED','enabled'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktDeliveryCampaignStatus|null {
        switch (val) {
            case KLMktDeliveryCampaignStatus.DISABLED.value:return KLMktDeliveryCampaignStatus.DISABLED;
            case KLMktDeliveryCampaignStatus.ENABLED.value:return KLMktDeliveryCampaignStatus.ENABLED;
        }
        return null;
    }
}

/**
 * 面向群体
*/
export class KLMktDeliveryCampaignTargetAudience extends KLEnum<string>{

    // 全体用户
    static readonly ALL_USER = new KLMktDeliveryCampaignTargetAudience('ALL_USER','ALL_USER','全体用户');

    // 门店新客
    static readonly STORE_NEW_CUSTOMER = new KLMktDeliveryCampaignTargetAudience('STORE_NEW_CUSTOMER','STORE_NEW_CUSTOMER','门店新客');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktDeliveryCampaignTargetAudience.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALL_USER','ALL_USER','全体用户'),
            new KLEnumCase<string>('STORE_NEW_CUSTOMER','STORE_NEW_CUSTOMER','门店新客'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktDeliveryCampaignTargetAudience|null {
        switch (val) {
            case KLMktDeliveryCampaignTargetAudience.ALL_USER.value:return KLMktDeliveryCampaignTargetAudience.ALL_USER;
            case KLMktDeliveryCampaignTargetAudience.STORE_NEW_CUSTOMER.value:return KLMktDeliveryCampaignTargetAudience.STORE_NEW_CUSTOMER;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktInviteFriendsGiftType extends KLEnum<string>{

    // Coupon
    static readonly COUPON = new KLMktInviteFriendsGiftType('COUPON','COUPON','Coupon');

    // Points
    static readonly POINTS = new KLMktInviteFriendsGiftType('POINTS','POINTS','Points');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktInviteFriendsGiftType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('COUPON','COUPON','Coupon'),
            new KLEnumCase<string>('POINTS','POINTS','Points'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktInviteFriendsGiftType|null {
        switch (val) {
            case KLMktInviteFriendsGiftType.COUPON.value:return KLMktInviteFriendsGiftType.COUPON;
            case KLMktInviteFriendsGiftType.POINTS.value:return KLMktInviteFriendsGiftType.POINTS;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktMallCampaignCouponClaimStatus extends KLEnum<string>{

    // Claim
    static readonly CLAIMABLE = new KLMktMallCampaignCouponClaimStatus('CLAIMABLE','CLAIMABLE','Claim');

    // Claimed
    static readonly CLAIMED = new KLMktMallCampaignCouponClaimStatus('CLAIMED','CLAIMED','Claimed');

    // Used
    static readonly USED = new KLMktMallCampaignCouponClaimStatus('USED','USED','Used');

    // Out of stock
    static readonly OUT_OF_STOCK = new KLMktMallCampaignCouponClaimStatus('OUT_OF_STOCK','OUT_OF_STOCK','Out of stock');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktMallCampaignCouponClaimStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('CLAIMABLE','CLAIMABLE','Claim'),
            new KLEnumCase<string>('CLAIMED','CLAIMED','Claimed'),
            new KLEnumCase<string>('USED','USED','Used'),
            new KLEnumCase<string>('OUT_OF_STOCK','OUT_OF_STOCK','Out of stock'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktMallCampaignCouponClaimStatus|null {
        switch (val) {
            case KLMktMallCampaignCouponClaimStatus.CLAIMABLE.value:return KLMktMallCampaignCouponClaimStatus.CLAIMABLE;
            case KLMktMallCampaignCouponClaimStatus.CLAIMED.value:return KLMktMallCampaignCouponClaimStatus.CLAIMED;
            case KLMktMallCampaignCouponClaimStatus.USED.value:return KLMktMallCampaignCouponClaimStatus.USED;
            case KLMktMallCampaignCouponClaimStatus.OUT_OF_STOCK.value:return KLMktMallCampaignCouponClaimStatus.OUT_OF_STOCK;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktMallCampaignDisplayScope extends KLEnum<string>{

    // 首页
    static readonly HOME = new KLMktMallCampaignDisplayScope('HOME','HOME','首页');

    // 分类页
    static readonly CATEGORY = new KLMktMallCampaignDisplayScope('CATEGORY','CATEGORY','分类页');

    // 搜索页
    static readonly SEARCH = new KLMktMallCampaignDisplayScope('SEARCH','SEARCH','搜索页');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktMallCampaignDisplayScope.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HOME','HOME','首页'),
            new KLEnumCase<string>('CATEGORY','CATEGORY','分类页'),
            new KLEnumCase<string>('SEARCH','SEARCH','搜索页'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktMallCampaignDisplayScope|null {
        switch (val) {
            case KLMktMallCampaignDisplayScope.HOME.value:return KLMktMallCampaignDisplayScope.HOME;
            case KLMktMallCampaignDisplayScope.CATEGORY.value:return KLMktMallCampaignDisplayScope.CATEGORY;
            case KLMktMallCampaignDisplayScope.SEARCH.value:return KLMktMallCampaignDisplayScope.SEARCH;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktMallCampaignGroupDisplayStyle extends KLEnum<string>{

    // 单列展示
    static readonly SINGLE = new KLMktMallCampaignGroupDisplayStyle('SINGLE','SINGLE','单列展示');

    // 三列展示
    static readonly TRIPLE = new KLMktMallCampaignGroupDisplayStyle('TRIPLE','TRIPLE','三列展示');

    // 网格展示
    static readonly GRID = new KLMktMallCampaignGroupDisplayStyle('GRID','GRID','网格展示');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktMallCampaignGroupDisplayStyle.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SINGLE','SINGLE','单列展示'),
            new KLEnumCase<string>('TRIPLE','TRIPLE','三列展示'),
            new KLEnumCase<string>('GRID','GRID','网格展示'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktMallCampaignGroupDisplayStyle|null {
        switch (val) {
            case KLMktMallCampaignGroupDisplayStyle.SINGLE.value:return KLMktMallCampaignGroupDisplayStyle.SINGLE;
            case KLMktMallCampaignGroupDisplayStyle.TRIPLE.value:return KLMktMallCampaignGroupDisplayStyle.TRIPLE;
            case KLMktMallCampaignGroupDisplayStyle.GRID.value:return KLMktMallCampaignGroupDisplayStyle.GRID;
        }
        return null;
    }
}

/**
 * 
*/
export class KLMktMallCampaignStatus extends KLEnum<string>{

    // 上线
    static readonly ONLINE = new KLMktMallCampaignStatus('ONLINE','ONLINE','上线');

    // 下线
    static readonly OFFLINE = new KLMktMallCampaignStatus('OFFLINE','OFFLINE','下线');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLMktMallCampaignStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONLINE','ONLINE','上线'),
            new KLEnumCase<string>('OFFLINE','OFFLINE','下线'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLMktMallCampaignStatus|null {
        switch (val) {
            case KLMktMallCampaignStatus.ONLINE.value:return KLMktMallCampaignStatus.ONLINE;
            case KLMktMallCampaignStatus.OFFLINE.value:return KLMktMallCampaignStatus.OFFLINE;
        }
        return null;
    }
}

/**
 * 推送提供商
*/
export class KLPushProvider extends KLEnum<string>{

    // onesignal
    static readonly ONESIGNAL = new KLPushProvider('ONESIGNAL','ONESIGNAL','onesignal');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPushProvider.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ONESIGNAL','ONESIGNAL','onesignal'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPushProvider|null {
        switch (val) {
            case KLPushProvider.ONESIGNAL.value:return KLPushProvider.ONESIGNAL;
        }
        return null;
    }
}

/**
 * 推送模板跳转类型
*/
export class KLPushTemplatesJumpType extends KLEnum<string>{

    // home
    static readonly HOME = new KLPushTemplatesJumpType('HOME','HOME','home');

    // search result
    static readonly SEARCH_RESULT = new KLPushTemplatesJumpType('SEARCH_RESULT','SEARCH_RESULT','search result');

    // product
    static readonly PRODUCT = new KLPushTemplatesJumpType('PRODUCT','PRODUCT','product');

    // category
    static readonly CATEGORY = new KLPushTemplatesJumpType('CATEGORY','CATEGORY','category');

    // activity
    static readonly ACTIVITY = new KLPushTemplatesJumpType('ACTIVITY','ACTIVITY','activity');

    // tag
    static readonly TAG = new KLPushTemplatesJumpType('TAG','TAG','tag');

    // external
    static readonly EXTERNAL = new KLPushTemplatesJumpType('EXTERNAL','EXTERNAL','external');

    // none
    static readonly NONE = new KLPushTemplatesJumpType('NONE','NONE','none');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPushTemplatesJumpType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('HOME','HOME','home'),
            new KLEnumCase<string>('SEARCH_RESULT','SEARCH_RESULT','search result'),
            new KLEnumCase<string>('PRODUCT','PRODUCT','product'),
            new KLEnumCase<string>('CATEGORY','CATEGORY','category'),
            new KLEnumCase<string>('ACTIVITY','ACTIVITY','activity'),
            new KLEnumCase<string>('TAG','TAG','tag'),
            new KLEnumCase<string>('EXTERNAL','EXTERNAL','external'),
            new KLEnumCase<string>('NONE','NONE','none'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPushTemplatesJumpType|null {
        switch (val) {
            case KLPushTemplatesJumpType.HOME.value:return KLPushTemplatesJumpType.HOME;
            case KLPushTemplatesJumpType.SEARCH_RESULT.value:return KLPushTemplatesJumpType.SEARCH_RESULT;
            case KLPushTemplatesJumpType.PRODUCT.value:return KLPushTemplatesJumpType.PRODUCT;
            case KLPushTemplatesJumpType.CATEGORY.value:return KLPushTemplatesJumpType.CATEGORY;
            case KLPushTemplatesJumpType.ACTIVITY.value:return KLPushTemplatesJumpType.ACTIVITY;
            case KLPushTemplatesJumpType.TAG.value:return KLPushTemplatesJumpType.TAG;
            case KLPushTemplatesJumpType.EXTERNAL.value:return KLPushTemplatesJumpType.EXTERNAL;
            case KLPushTemplatesJumpType.NONE.value:return KLPushTemplatesJumpType.NONE;
        }
        return null;
    }
}

/**
 * 推送用户类型
*/
export class KLPushUserType extends KLEnum<string>{

    // kmart user
    static readonly KMART_USER = new KLPushUserType('KMART_USER','kmartUser','kmart user');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLPushUserType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('KMART_USER','kmartUser','kmart user'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLPushUserType|null {
        switch (val) {
            case KLPushUserType.KMART_USER.value:return KLPushUserType.KMART_USER;
        }
        return null;
    }
}

/**
 * 搜索场景
*/
export class KLUserSearchRecordScene extends KLEnum<string>{

    // App商城
    static readonly APP_MALL = new KLUserSearchRecordScene('APP_MALL','APP_MALL','App商城');

    // 小程序
    static readonly MINI_PROGRAM = new KLUserSearchRecordScene('MINI_PROGRAM','MINI_PROGRAM','小程序');

    // H5站内
    static readonly H5 = new KLUserSearchRecordScene('H5','H5','H5站内');

    // PC网页
    static readonly WEB = new KLUserSearchRecordScene('WEB','WEB','PC网页');

    // 店铺内
    static readonly STORE_INNER = new KLUserSearchRecordScene('STORE_INNER','STORE_INNER','店铺内');

    // App活动页
    static readonly APP_CAMPAIGN = new KLUserSearchRecordScene('APP_CAMPAIGN','APP_CAMPAIGN','App活动页');

    // H5活动页
    static readonly H5_CAMPAIGN = new KLUserSearchRecordScene('H5_CAMPAIGN','H5_CAMPAIGN','H5活动页');

    // 其他
    static readonly OTHER = new KLUserSearchRecordScene('OTHER','OTHER','其他');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLUserSearchRecordScene.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('APP_MALL','APP_MALL','App商城'),
            new KLEnumCase<string>('MINI_PROGRAM','MINI_PROGRAM','小程序'),
            new KLEnumCase<string>('H5','H5','H5站内'),
            new KLEnumCase<string>('WEB','WEB','PC网页'),
            new KLEnumCase<string>('STORE_INNER','STORE_INNER','店铺内'),
            new KLEnumCase<string>('APP_CAMPAIGN','APP_CAMPAIGN','App活动页'),
            new KLEnumCase<string>('H5_CAMPAIGN','H5_CAMPAIGN','H5活动页'),
            new KLEnumCase<string>('OTHER','OTHER','其他'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLUserSearchRecordScene|null {
        switch (val) {
            case KLUserSearchRecordScene.APP_MALL.value:return KLUserSearchRecordScene.APP_MALL;
            case KLUserSearchRecordScene.MINI_PROGRAM.value:return KLUserSearchRecordScene.MINI_PROGRAM;
            case KLUserSearchRecordScene.H5.value:return KLUserSearchRecordScene.H5;
            case KLUserSearchRecordScene.WEB.value:return KLUserSearchRecordScene.WEB;
            case KLUserSearchRecordScene.STORE_INNER.value:return KLUserSearchRecordScene.STORE_INNER;
            case KLUserSearchRecordScene.APP_CAMPAIGN.value:return KLUserSearchRecordScene.APP_CAMPAIGN;
            case KLUserSearchRecordScene.H5_CAMPAIGN.value:return KLUserSearchRecordScene.H5_CAMPAIGN;
            case KLUserSearchRecordScene.OTHER.value:return KLUserSearchRecordScene.OTHER;
        }
        return null;
    }
}

/**
 * 地图服务提供商
*/
export class KLSMapProvider extends KLEnum<string>{

    // Google
    static readonly GOOGLE = new KLSMapProvider('GOOGLE','google','Google');

    // Graphhopper
    static readonly GRAPHHOOPER = new KLSMapProvider('GRAPHHOOPER','graphhopper','Graphhopper');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSMapProvider.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GOOGLE','google','Google'),
            new KLEnumCase<string>('GRAPHHOOPER','graphhopper','Graphhopper'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSMapProvider|null {
        switch (val) {
            case KLSMapProvider.GOOGLE.value:return KLSMapProvider.GOOGLE;
            case KLSMapProvider.GRAPHHOOPER.value:return KLSMapProvider.GRAPHHOOPER;
        }
        return null;
    }
}

/**
 * 收单机构
*/
export class KLSPaymentAcquirer extends KLEnum<string>{

    // Fucent 支付
    static readonly FUCENT = new KLSPaymentAcquirer('FUCENT','FUCENT','Fucent 支付');

    // UTC 支付 (USDT)
    static readonly UTC = new KLSPaymentAcquirer('UTC','UTC','UTC 支付 (USDT)');

    // UU Wallet
    static readonly UU_WALLET = new KLSPaymentAcquirer('UU_WALLET','UU_WALLET','UU Wallet');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentAcquirer.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('FUCENT','FUCENT','Fucent 支付'),
            new KLEnumCase<string>('UTC','UTC','UTC 支付 (USDT)'),
            new KLEnumCase<string>('UU_WALLET','UU_WALLET','UU Wallet'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentAcquirer|null {
        switch (val) {
            case KLSPaymentAcquirer.FUCENT.value:return KLSPaymentAcquirer.FUCENT;
            case KLSPaymentAcquirer.UTC.value:return KLSPaymentAcquirer.UTC;
            case KLSPaymentAcquirer.UU_WALLET.value:return KLSPaymentAcquirer.UU_WALLET;
        }
        return null;
    }
}

/**
 * 支付回调状态
*/
export class KLSPaymentCallbackStatus extends KLEnum<string>{

    // Pending
    static readonly PENDING = new KLSPaymentCallbackStatus('PENDING','PENDING','Pending');

    // Success
    static readonly SUCCESS = new KLSPaymentCallbackStatus('SUCCESS','SUCCESS','Success');

    // Failed
    static readonly FAILED = new KLSPaymentCallbackStatus('FAILED','FAILED','Failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentCallbackStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','Pending'),
            new KLEnumCase<string>('SUCCESS','SUCCESS','Success'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentCallbackStatus|null {
        switch (val) {
            case KLSPaymentCallbackStatus.PENDING.value:return KLSPaymentCallbackStatus.PENDING;
            case KLSPaymentCallbackStatus.SUCCESS.value:return KLSPaymentCallbackStatus.SUCCESS;
            case KLSPaymentCallbackStatus.FAILED.value:return KLSPaymentCallbackStatus.FAILED;
        }
        return null;
    }
}

/**
 * 支付流程模式
*/
export class KLSPaymentFlowMode extends KLEnum<string>{

    // 预下单模式
    static readonly PRE_ORDER = new KLSPaymentFlowMode('PRE_ORDER','PRE_ORDER','预下单模式');

    // 转账模式
    static readonly TRANSFER = new KLSPaymentFlowMode('TRANSFER','TRANSFER','转账模式');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentFlowMode.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PRE_ORDER','PRE_ORDER','预下单模式'),
            new KLEnumCase<string>('TRANSFER','TRANSFER','转账模式'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentFlowMode|null {
        switch (val) {
            case KLSPaymentFlowMode.PRE_ORDER.value:return KLSPaymentFlowMode.PRE_ORDER;
            case KLSPaymentFlowMode.TRANSFER.value:return KLSPaymentFlowMode.TRANSFER;
        }
        return null;
    }
}

/**
 * 支付启动器类型
*/
export class KLSPaymentLauncherType extends KLEnum<string>{

    // 网页跳转
    static readonly WEB_URL = new KLSPaymentLauncherType('WEB_URL','WEB_URL','网页跳转');

    // 支付宝APP
    static readonly ALIPAY_APP = new KLSPaymentLauncherType('ALIPAY_APP','ALIPAY_APP','支付宝APP');

    // 微信APP
    static readonly WECHAT_APP = new KLSPaymentLauncherType('WECHAT_APP','WECHAT_APP','微信APP');

    // 支付宝小程序
    static readonly ALIPAY_MINI_APP = new KLSPaymentLauncherType('ALIPAY_MINI_APP','ALIPAY_MINI_APP','支付宝小程序');

    // 微信小程序
    static readonly WECHAT_MINI_APP = new KLSPaymentLauncherType('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序');

    // 二维码
    static readonly QR_CODE = new KLSPaymentLauncherType('QR_CODE','QR_CODE','二维码');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentLauncherType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('WEB_URL','WEB_URL','网页跳转'),
            new KLEnumCase<string>('ALIPAY_APP','ALIPAY_APP','支付宝APP'),
            new KLEnumCase<string>('WECHAT_APP','WECHAT_APP','微信APP'),
            new KLEnumCase<string>('ALIPAY_MINI_APP','ALIPAY_MINI_APP','支付宝小程序'),
            new KLEnumCase<string>('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序'),
            new KLEnumCase<string>('QR_CODE','QR_CODE','二维码'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentLauncherType|null {
        switch (val) {
            case KLSPaymentLauncherType.WEB_URL.value:return KLSPaymentLauncherType.WEB_URL;
            case KLSPaymentLauncherType.ALIPAY_APP.value:return KLSPaymentLauncherType.ALIPAY_APP;
            case KLSPaymentLauncherType.WECHAT_APP.value:return KLSPaymentLauncherType.WECHAT_APP;
            case KLSPaymentLauncherType.ALIPAY_MINI_APP.value:return KLSPaymentLauncherType.ALIPAY_MINI_APP;
            case KLSPaymentLauncherType.WECHAT_MINI_APP.value:return KLSPaymentLauncherType.WECHAT_MINI_APP;
            case KLSPaymentLauncherType.QR_CODE.value:return KLSPaymentLauncherType.QR_CODE;
        }
        return null;
    }
}

/**
 * 支付方式
*/
export class KLSPaymentMethod extends KLEnum<string>{

    // GCASH
    static readonly GCASH = new KLSPaymentMethod('GCASH','GCASH','GCASH');

    // 微信支付
    static readonly WECHAT = new KLSPaymentMethod('WECHAT','WECHAT','微信支付');

    // 支付宝
    static readonly ALIPAY = new KLSPaymentMethod('ALIPAY','ALIPAY','支付宝');

    // GRAB
    static readonly GRAB = new KLSPaymentMethod('GRAB','GRAB','GRAB');

    // MAYA
    static readonly MAYA = new KLSPaymentMethod('MAYA','MAYA','MAYA');

    // 银联支付
    static readonly UNIONPAY = new KLSPaymentMethod('UNIONPAY','UNIONPAY','银联支付');

    // USDT
    static readonly USDT = new KLSPaymentMethod('USDT','USDT','USDT');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentMethod.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GCASH','GCASH','GCASH'),
            new KLEnumCase<string>('WECHAT','WECHAT','微信支付'),
            new KLEnumCase<string>('ALIPAY','ALIPAY','支付宝'),
            new KLEnumCase<string>('GRAB','GRAB','GRAB'),
            new KLEnumCase<string>('MAYA','MAYA','MAYA'),
            new KLEnumCase<string>('UNIONPAY','UNIONPAY','银联支付'),
            new KLEnumCase<string>('USDT','USDT','USDT'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentMethod|null {
        switch (val) {
            case KLSPaymentMethod.GCASH.value:return KLSPaymentMethod.GCASH;
            case KLSPaymentMethod.WECHAT.value:return KLSPaymentMethod.WECHAT;
            case KLSPaymentMethod.ALIPAY.value:return KLSPaymentMethod.ALIPAY;
            case KLSPaymentMethod.GRAB.value:return KLSPaymentMethod.GRAB;
            case KLSPaymentMethod.MAYA.value:return KLSPaymentMethod.MAYA;
            case KLSPaymentMethod.UNIONPAY.value:return KLSPaymentMethod.UNIONPAY;
            case KLSPaymentMethod.USDT.value:return KLSPaymentMethod.USDT;
        }
        return null;
    }
}

/**
 * 支付请求订单状态
*/
export class KLSPaymentOrderRequestStatus extends KLEnum<string>{

    // Pending
    static readonly NOT_PAID = new KLSPaymentOrderRequestStatus('NOT_PAID','NOT_PAID','Pending');

    // Paid
    static readonly PAID = new KLSPaymentOrderRequestStatus('PAID','PAID','Paid');

    // Refunded
    static readonly REFUNDED = new KLSPaymentOrderRequestStatus('REFUNDED','REFUNDED','Refunded');

    // Partially Refunded
    static readonly PARTIALLY_REFUNDED = new KLSPaymentOrderRequestStatus('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially Refunded');

    // Failed
    static readonly FAILED = new KLSPaymentOrderRequestStatus('FAILED','FAILED','Failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentOrderRequestStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_PAID','NOT_PAID','Pending'),
            new KLEnumCase<string>('PAID','PAID','Paid'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
            new KLEnumCase<string>('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially Refunded'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentOrderRequestStatus|null {
        switch (val) {
            case KLSPaymentOrderRequestStatus.NOT_PAID.value:return KLSPaymentOrderRequestStatus.NOT_PAID;
            case KLSPaymentOrderRequestStatus.PAID.value:return KLSPaymentOrderRequestStatus.PAID;
            case KLSPaymentOrderRequestStatus.REFUNDED.value:return KLSPaymentOrderRequestStatus.REFUNDED;
            case KLSPaymentOrderRequestStatus.PARTIALLY_REFUNDED.value:return KLSPaymentOrderRequestStatus.PARTIALLY_REFUNDED;
            case KLSPaymentOrderRequestStatus.FAILED.value:return KLSPaymentOrderRequestStatus.FAILED;
        }
        return null;
    }
}

/**
 * 支付订单状态
*/
export class KLSPaymentOrderStatus extends KLEnum<string>{

    // Not Paid
    static readonly NOT_PAID = new KLSPaymentOrderStatus('NOT_PAID','NOT_PAID','Not Paid');

    // Paid
    static readonly PAID = new KLSPaymentOrderStatus('PAID','PAID','Paid');

    // Refunded
    static readonly REFUNDED = new KLSPaymentOrderStatus('REFUNDED','REFUNDED','Refunded');

    // Partially Refunded
    static readonly PARTIALLY_REFUNDED = new KLSPaymentOrderStatus('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially Refunded');

    // Failed
    static readonly FAILED = new KLSPaymentOrderStatus('FAILED','FAILED','Failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentOrderStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('NOT_PAID','NOT_PAID','Not Paid'),
            new KLEnumCase<string>('PAID','PAID','Paid'),
            new KLEnumCase<string>('REFUNDED','REFUNDED','Refunded'),
            new KLEnumCase<string>('PARTIALLY_REFUNDED','PARTIALLY_REFUNDED','Partially Refunded'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentOrderStatus|null {
        switch (val) {
            case KLSPaymentOrderStatus.NOT_PAID.value:return KLSPaymentOrderStatus.NOT_PAID;
            case KLSPaymentOrderStatus.PAID.value:return KLSPaymentOrderStatus.PAID;
            case KLSPaymentOrderStatus.REFUNDED.value:return KLSPaymentOrderStatus.REFUNDED;
            case KLSPaymentOrderStatus.PARTIALLY_REFUNDED.value:return KLSPaymentOrderStatus.PARTIALLY_REFUNDED;
            case KLSPaymentOrderStatus.FAILED.value:return KLSPaymentOrderStatus.FAILED;
        }
        return null;
    }
}

/**
 * 支付退款状态
*/
export class KLSPaymentRefundStatus extends KLEnum<string>{

    // Initiated
    static readonly INITIATED = new KLSPaymentRefundStatus('INITIATED','INITIATED','Initiated');

    // Success
    static readonly SUCCESS = new KLSPaymentRefundStatus('SUCCESS','SUCCESS','Success');

    // Failed
    static readonly FAILED = new KLSPaymentRefundStatus('FAILED','FAILED','Failed');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentRefundStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('INITIATED','INITIATED','Initiated'),
            new KLEnumCase<string>('SUCCESS','SUCCESS','Success'),
            new KLEnumCase<string>('FAILED','FAILED','Failed'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentRefundStatus|null {
        switch (val) {
            case KLSPaymentRefundStatus.INITIATED.value:return KLSPaymentRefundStatus.INITIATED;
            case KLSPaymentRefundStatus.SUCCESS.value:return KLSPaymentRefundStatus.SUCCESS;
            case KLSPaymentRefundStatus.FAILED.value:return KLSPaymentRefundStatus.FAILED;
        }
        return null;
    }
}

/**
 * 支付场景
*/
export class KLSPaymentScene extends KLEnum<string>{

    // App内支付
    static readonly IN_APP = new KLSPaymentScene('IN_APP','IN_APP','App内支付');

    // PC网页
    static readonly WEB = new KLSPaymentScene('WEB','WEB','PC网页');

    // 移动端网页
    static readonly WAP = new KLSPaymentScene('WAP','WAP','移动端网页');

    // 微信小程序
    static readonly WECHAT_MINI_APP = new KLSPaymentScene('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序');

    // 微信JS API
    static readonly WECHAT_JS_API = new KLSPaymentScene('WECHAT_JS_API','WECHAT_JS_API','微信JS API');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPaymentScene.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IN_APP','IN_APP','App内支付'),
            new KLEnumCase<string>('WEB','WEB','PC网页'),
            new KLEnumCase<string>('WAP','WAP','移动端网页'),
            new KLEnumCase<string>('WECHAT_MINI_APP','WECHAT_MINI_APP','微信小程序'),
            new KLEnumCase<string>('WECHAT_JS_API','WECHAT_JS_API','微信JS API'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPaymentScene|null {
        switch (val) {
            case KLSPaymentScene.IN_APP.value:return KLSPaymentScene.IN_APP;
            case KLSPaymentScene.WEB.value:return KLSPaymentScene.WEB;
            case KLSPaymentScene.WAP.value:return KLSPaymentScene.WAP;
            case KLSPaymentScene.WECHAT_MINI_APP.value:return KLSPaymentScene.WECHAT_MINI_APP;
            case KLSPaymentScene.WECHAT_JS_API.value:return KLSPaymentScene.WECHAT_JS_API;
        }
        return null;
    }
}

/**
 * 支付服务商
*/
export class KLSPayProvider extends KLEnum<string>{

    // GCASH
    static readonly GCASH = new KLSPayProvider('GCASH','GCASH','GCASH');

    // 微信支付
    static readonly WECHAT = new KLSPayProvider('WECHAT','WECHAT','微信支付');

    // 支付宝
    static readonly ALIPAY = new KLSPayProvider('ALIPAY','ALIPAY','支付宝');

    // GRAB
    static readonly GRAB = new KLSPayProvider('GRAB','GRAB','GRAB');

    // MAYA
    static readonly MAYA = new KLSPayProvider('MAYA','MAYA','MAYA');

    // 银联支付
    static readonly UNIONPAY = new KLSPayProvider('UNIONPAY','UNIONPAY','银联支付');

    // USDT
    static readonly USDT = new KLSPayProvider('USDT','USDT','USDT');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSPayProvider.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('GCASH','GCASH','GCASH'),
            new KLEnumCase<string>('WECHAT','WECHAT','微信支付'),
            new KLEnumCase<string>('ALIPAY','ALIPAY','支付宝'),
            new KLEnumCase<string>('GRAB','GRAB','GRAB'),
            new KLEnumCase<string>('MAYA','MAYA','MAYA'),
            new KLEnumCase<string>('UNIONPAY','UNIONPAY','银联支付'),
            new KLEnumCase<string>('USDT','USDT','USDT'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSPayProvider|null {
        switch (val) {
            case KLSPayProvider.GCASH.value:return KLSPayProvider.GCASH;
            case KLSPayProvider.WECHAT.value:return KLSPayProvider.WECHAT;
            case KLSPayProvider.ALIPAY.value:return KLSPayProvider.ALIPAY;
            case KLSPayProvider.GRAB.value:return KLSPayProvider.GRAB;
            case KLSPayProvider.MAYA.value:return KLSPayProvider.MAYA;
            case KLSPayProvider.UNIONPAY.value:return KLSPayProvider.UNIONPAY;
            case KLSPayProvider.USDT.value:return KLSPayProvider.USDT;
        }
        return null;
    }
}

/**
 * 短信发送日志状态
*/
export class KLKsSmsSmartTaskSendLogStatus extends KLEnum<string>{

    // 发送成功
    static readonly SEND_OK = new KLKsSmsSmartTaskSendLogStatus('SEND_OK','SEND_OK','发送成功');

    // 发送失败
    static readonly SEND_FAIL = new KLKsSmsSmartTaskSendLogStatus('SEND_FAIL','SEND_FAIL','发送失败');

    // 推送成功
    static readonly PUSH_OK = new KLKsSmsSmartTaskSendLogStatus('PUSH_OK','PUSH_OK','推送成功');

    // 推送失败
    static readonly PUSH_FAIL = new KLKsSmsSmartTaskSendLogStatus('PUSH_FAIL','PUSH_FAIL','推送失败');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLKsSmsSmartTaskSendLogStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('SEND_OK','SEND_OK','发送成功'),
            new KLEnumCase<string>('SEND_FAIL','SEND_FAIL','发送失败'),
            new KLEnumCase<string>('PUSH_OK','PUSH_OK','推送成功'),
            new KLEnumCase<string>('PUSH_FAIL','PUSH_FAIL','推送失败'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLKsSmsSmartTaskSendLogStatus|null {
        switch (val) {
            case KLKsSmsSmartTaskSendLogStatus.SEND_OK.value:return KLKsSmsSmartTaskSendLogStatus.SEND_OK;
            case KLKsSmsSmartTaskSendLogStatus.SEND_FAIL.value:return KLKsSmsSmartTaskSendLogStatus.SEND_FAIL;
            case KLKsSmsSmartTaskSendLogStatus.PUSH_OK.value:return KLKsSmsSmartTaskSendLogStatus.PUSH_OK;
            case KLKsSmsSmartTaskSendLogStatus.PUSH_FAIL.value:return KLKsSmsSmartTaskSendLogStatus.PUSH_FAIL;
        }
        return null;
    }
}

/**
 * 短信任务状态
*/
export class KLKsSmsSmartTaskStatus extends KLEnum<string>{

    // 未发送
    static readonly PENDING = new KLKsSmsSmartTaskStatus('PENDING','PENDING','未发送');

    // 已发送
    static readonly SENT = new KLKsSmsSmartTaskStatus('SENT','SENT','已发送');

    // 已送达
    static readonly DELIVERED = new KLKsSmsSmartTaskStatus('DELIVERED','DELIVERED','已送达');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLKsSmsSmartTaskStatus.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PENDING','PENDING','未发送'),
            new KLEnumCase<string>('SENT','SENT','已发送'),
            new KLEnumCase<string>('DELIVERED','DELIVERED','已送达'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLKsSmsSmartTaskStatus|null {
        switch (val) {
            case KLKsSmsSmartTaskStatus.PENDING.value:return KLKsSmsSmartTaskStatus.PENDING;
            case KLKsSmsSmartTaskStatus.SENT.value:return KLKsSmsSmartTaskStatus.SENT;
            case KLKsSmsSmartTaskStatus.DELIVERED.value:return KLKsSmsSmartTaskStatus.DELIVERED;
        }
        return null;
    }
}

/**
 * 短信内容类型
*/
export class KLKsSmsSmartTaskType extends KLEnum<string>{

    // 纯文本
    static readonly PLAIN = new KLKsSmsSmartTaskType('PLAIN','PLAIN','纯文本');

    // 模板短信
    static readonly TEMP = new KLKsSmsSmartTaskType('TEMP','TEMP','模板短信');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLKsSmsSmartTaskType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('PLAIN','PLAIN','纯文本'),
            new KLEnumCase<string>('TEMP','TEMP','模板短信'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLKsSmsSmartTaskType|null {
        switch (val) {
            case KLKsSmsSmartTaskType.PLAIN.value:return KLKsSmsSmartTaskType.PLAIN;
            case KLKsSmsSmartTaskType.TEMP.value:return KLKsSmsSmartTaskType.TEMP;
        }
        return null;
    }
}

/**
 * 短信适配器
*/
export class KLSSmsAdapter extends KLEnum<string>{

    // 阿里云
    static readonly ALI_CLOUD = new KLSSmsAdapter('ALI_CLOUD','ALI_CLOUD','阿里云');

    // HAMS国际
    static readonly HAMS_INTL = new KLSSmsAdapter('HAMS_INTL','HAMS_INTL','HAMS国际');

    // 极光国际
    static readonly JIGUANG_INTL = new KLSSmsAdapter('JIGUANG_INTL','JIGUANG_INTL','极光国际');

    // 互亿无线国际
    static readonly IHUYI_INTL = new KLSSmsAdapter('IHUYI_INTL','IHUYI_INTL','互亿无线国际');

    // 赛邮
    static readonly MYSUBMAIL = new KLSSmsAdapter('MYSUBMAIL','MYSUBMAIL','赛邮');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSSmsAdapter.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('ALI_CLOUD','ALI_CLOUD','阿里云'),
            new KLEnumCase<string>('HAMS_INTL','HAMS_INTL','HAMS国际'),
            new KLEnumCase<string>('JIGUANG_INTL','JIGUANG_INTL','极光国际'),
            new KLEnumCase<string>('IHUYI_INTL','IHUYI_INTL','互亿无线国际'),
            new KLEnumCase<string>('MYSUBMAIL','MYSUBMAIL','赛邮'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSSmsAdapter|null {
        switch (val) {
            case KLSSmsAdapter.ALI_CLOUD.value:return KLSSmsAdapter.ALI_CLOUD;
            case KLSSmsAdapter.HAMS_INTL.value:return KLSSmsAdapter.HAMS_INTL;
            case KLSSmsAdapter.JIGUANG_INTL.value:return KLSSmsAdapter.JIGUANG_INTL;
            case KLSSmsAdapter.IHUYI_INTL.value:return KLSSmsAdapter.IHUYI_INTL;
            case KLSSmsAdapter.MYSUBMAIL.value:return KLSSmsAdapter.MYSUBMAIL;
        }
        return null;
    }
}

/**
 * 短信类型
*/
export class KLSSmsType extends KLEnum<string>{

    // 图片验证码
    static readonly IMAGE = new KLSSmsType('IMAGE','IMAGE','图片验证码');

    // 短信验证码
    static readonly SMS = new KLSSmsType('SMS','SMS','短信验证码');

    // 语音验证码
    static readonly VOICE = new KLSSmsType('VOICE','VOICE','语音验证码');

    /**
     * 获取所有选项
     * @param defLabel 默认标题
     */
    public static getSelectionsWithDef( defLabel:string = ''):KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>(null,null,defLabel),
            ... KLSSmsType.getSelections()
        ];
    }

    /**
     * 获取所有选项
    */
    public static getSelections():KLEnumCase<string>[] {
        return [
            new KLEnumCase<string>('IMAGE','IMAGE','图片验证码'),
            new KLEnumCase<string>('SMS','SMS','短信验证码'),
            new KLEnumCase<string>('VOICE','VOICE','语音验证码'),
        ];
    }

    /**
    * 根据值获取选项
    */
    public static formValue(val:string):KLSSmsType|null {
        switch (val) {
            case KLSSmsType.IMAGE.value:return KLSSmsType.IMAGE;
            case KLSSmsType.SMS.value:return KLSSmsType.SMS;
            case KLSSmsType.VOICE.value:return KLSSmsType.VOICE;
        }
        return null;
    }
}

